export const extraLocales: Record<string, Record<string, string>> = {
  "es": {
    "*Our sizing engine recommends": "*Nuestro motor de dimensionamiento recomienda",
    "✓ Pose detected — running body analysis": "✓ Pose detectada: análisis del cuerpo en ejecución",
    "A clean close-up improves landmark detection for eyewear and headwear.": "Un primer plano limpio mejora la detección de puntos de referencia para gafas y sombreros.",
    "A clear head-and-shoulders photo with space above your head gives the most accurate headwear try-on.": "Una foto clara de la cabeza y los hombros con espacio sobre la cabeza proporciona la prueba más precisa del sombrero.",
    "A clear, front-facing face photo — no glasses on — gives us the most accurate try-on.": "Una foto clara y de frente, sin gafas, nos brinda la prueba más precisa.",
    "A clear, well-lit face photo gives the most accurate eyewear try-on.": "Una fotografía del rostro clara y bien iluminada permite probar las gafas con mayor precisión.",
    "A clear, well-lit face photo gives the most accurate fit for eyewear and headwear.": "Una fotografía de rostro clara y bien iluminada proporciona el ajuste más preciso para gafas y sombreros.",
    "A tie tip should land at the middle of your belt buckle": "La punta de la corbata debe quedar en el centro de la hebilla del cinturón.",
    "Active Profile": "Perfil activo",
    "ACTIVE PROFILE": "PERFIL ACTIVO",
    "Add a name for this profile": "Añade un nombre para este perfil",
    "ADD MEASUREMENTS & PHOTO": "AÑADIR MEDIDAS Y FOTO",
    "Add them to cart.": "Agréguelos al carrito.",
    "Add to Bag": "Añadir a la bolsa",
    "Added to bag": "Añadido a la bolsa",
    "Adding...": "Añadiendo...",
    "Age": "edad",
    "Age verification": "Verificación de edad",
    "AGE VERIFICATION": "VERIFICACIÓN DE EDAD",
    "AI Fact": "Hecho de IA",
    "AI Powered": "Impulsado por IA",
    "AI SCAN": "ESCANEO AI",
    "All measurements in": "Todas las medidas en",
    "almost done": "casi terminado",
    "Almost done": "Casi terminado",
    "Almost done — finalizing…": "Casi terminado, finalizando...",
    "Almost done — preparing your suggested size.": "Ya casi hemos terminado: preparando la talla sugerida.",
    "Analyze": "analizar",
    "Analyze by photo": "Analizar por foto",
    "ANALYZE MY SIZE": "ANALIZAR MI TALLA",
    "ANALYZING": "ANALIZANDO",
    "ANALYZING BODY": "ÓRGANO ANALIZADOR",
    "ANALYZING BODY MAP": "ANALIZANDO EL MAPA CORPORAL",
    "Analyzing body proportions": "Analizando las proporciones corporales.",
    "Around the base of the neck.": "Alrededor de la base del cuello.",
    "AVERAGE": "PROMEDIO",
    "BACK": "VOLVER",
    "Back & Seat": "Respaldo y asiento",
    "BACK & SEAT": "RESPALDO Y ASIENTO",
    "Back to brands": "Volver a marcas",
    "Back to product": "Volver al producto",
    "based on your measurements and the garment's tailoring chart.": "en base a tus medidas y la tabla de confección de la prenda.",
    "based on your selected brand size and foot length.": "según el tamaño de la marca seleccionada y la longitud del pie.",
    "best match": "mejor partido",
    "BEST MATCH": "MEJOR PARTIDO",
    "BODY MEASUREMENTS": "MEDIDAS DEL CUERPO",
    "Body measurements calculated!": "¡Medidas corporales calculadas!",
    "Bra": "sujetador",
    "BRA SIZE": "TALLA DE SUJETADOR",
    "BROAD": "AMPLIO",
    "BUST": "BUSTO",
    "Calculate My Body Parts": "Calcular las partes de mi cuerpo",
    "CALCULATE MY FIT": "CALCULAR MI AJUSTE",
    "CALCULATING": "CALCULANDO",
    "calculating...": "calculando...",
    "Calculating...": "Calculando...",
    "CALIBRATING": "CALIBRANDO",
    "Calibrating fabric drape against your body proportions": "Calibrar la caída de la tela según las proporciones de tu cuerpo",
    "CALIBRATING SCALE": "BÁSCULA CALIBRADORA",
    "Cancel": "Cancelar",
    "Cancel Generation": "Cancelar generación",
    "centimeters": "centímetros",
    "Change": "Cambiar",
    "Checklist for accuracy": "Lista de verificación para la precisión",
    "CHEST": "PECHO",
    "CHEST PROFILE": "PERFIL DEL PECHO",
    "Choose a method": "Elige un método",
    "Choose a plain background": "Elige un fondo liso",
    "Choose a plain, light background": "Elige un fondo liso y claro",
    "Choose a saved profile or create a new one before finding your best fit.": "Elija un perfil guardado o cree uno nuevo antes de encontrar su mejor opción.",
    "Choose another photo": "Elige otra foto",
    "Choose one account": "Elige una cuenta",
    "Choose size": "Elige talla",
    "Choose your shoe brand": "Elige tu marca de zapatos",
    "Choose your usual": "Elige tu habitual",
    "Circumference around the upper leg.": "Circunferencia alrededor de la parte superior de la pierna.",
    "Circumference at the fullest point.": "Circunferencia en su punto más completo.",
    "Circumference at the natural waistline.": "Circunferencia en la cintura natural.",
    "Clear All": "Borrar todo",
    "Click or drag a close-up face photo": "Haz clic o arrastra una foto de rostro en primer plano",
    "Click or drag a front face photo": "Haga clic o arrastre una foto de la cara frontal",
    "Click or drag a head-and-shoulders photo": "Haz clic o arrastra una foto de cabeza y hombros.",
    "Click to change photo": "Haga clic para cambiar la foto",
    "CM": "CM",
    "Comparing your circumference to the size chart.": "Comparando tu circunferencia con la tabla de tallas.",
    "Comparing your measurements to the garment's size guide.": "Comparando tus medidas con la guía de tallas de la prenda.",
    "Comparing your measurements to the size chart.": "Comparando tus medidas con la tabla de tallas.",
    "Comparing your measurements to the size guide.": "Comparando tus medidas con la guía de tallas.",
    "Complete the look": "Completa el look",
    "Computing chest, waist, hips, sleeve and inseam from your basics.": "Calcular el pecho, la cintura, las caderas, las mangas y la entrepierna a partir de tus conceptos básicos.",
    "Confirm your measurements": "Confirma tus medidas",
    "Continue Shopping": "Continuar comprando",
    "Could not load your saved profiles.": "No se pudieron cargar sus perfiles guardados.",
    "Couldn't send. Try again.": "No se pudo enviar. Intentar otra vez.",
    "Country": "País",
    "Crafted with quality materials for everyday comfort": "Elaborado con materiales de calidad para la comodidad diaria.",
    "Create New Profile": "Crear nuevo perfil",
    "Create Profile": "Crear perfil",
    "Create your first fit profile to save your measurements, photo, and size history.": "Crea tu primer perfil de ajuste para guardar tus medidas, fotos e historial de tallas.",
    "Create your fit profile once.": "Crea tu perfil de ajuste una vez.",
    "Cross-checking fit against millions of garment patterns": "Comparación cruzada del ajuste con millones de patrones de prendas",
    "Cuff a pocket square so it peeks 1–2 cm above the pocket": "Ponga un pañuelo en el bolsillo de modo que quede entre 1 y 2 cm por encima del bolsillo.",
    "Cuff once for a relaxed everyday feel": "Puñetazo una vez para una sensación relajada todos los días.",
    "Cufflinks should sit half an inch past the jacket sleeve": "Los gemelos deben quedar media pulgada más allá de la manga de la chaqueta.",
    "CURVED": "CURVADO",
    "Decrease": "Disminución",
    "DEEP": "PROFUNDO",
    "DEFAULT PROFILE": "PERFIL PREDETERMINADO",
    "Delete": "Eliminar",
    "Delete this profile?": "¿Eliminar este perfil?",
    "Describe your mid-section silhouette": "Describe tu silueta de sección media",
    "DETAIL": "DETALLE",
    "Detecting body pose": "Detectar la postura del cuerpo",
    "Detecting face": "Detectando cara",
    "DETECTING FACE": "DETECCIÓN DE CARA",
    "Detecting head": "Cabezal detector",
    "DETECTING HEAD": "CABEZA DETECCIÓN",
    "DETECTING POSE": "POSE DE DETECCIÓN",
    "Detecting pose landmarks…": "Detectando puntos de referencia de pose...",
    "Display size in country": "Tamaño de visualización en el país",
    "Distance over the nose between lenses": "Distancia sobre la nariz entre lentes",
    "Don't apply filters or edits": "No aplicar filtros ni ediciones",
    "Don't apply filters or heavy edits": "No apliques filtros ni ediciones pesadas",
    "Don't cover your ears, eyes, or forehead": "No te tapes los oídos, los ojos ni la frente.",
    "Don't crop out the top of your head": "No recortes la parte superior de tu cabeza",
    "Don't crop out your ears or top of head": "No te cortes las orejas ni la parte superior de la cabeza.",
    "Don't sit, pose, or bend": "No te sientes, poses ni te dobles.",
    "Don't tilt or turn your head": "No incline ni gire la cabeza",
    "Don't use filters, mirrored photos, or angled selfies": "No uses filtros, fotos reflejadas ni selfies en ángulo",
    "Don't use heavy shadows or strong backlighting": "No utilices sombras intensas ni retroiluminación intensa.",
    "Don't use strong backlighting or flash": "No utilices retroiluminación intensa ni flash.",
    "Don't wear a hat in the photo": "No uses sombrero en la foto.",
    "Don't wear loose or baggy clothing": "No uses ropa holgada o holgada",
    "Don't wear sunglasses or a hat in the photo": "No uses gafas de sol ni sombrero en la foto.",
    "Done": "hecho",
    "e.g. 154": "por ej. 154",
    "e.g. 173": "por ej. 173",
    "e.g. 30": "por ej. 30",
    "e.g. 70": "por ej. 70",
    "e.g. My Measurements": "por ej. Mis medidas",
    "e.g. My Photo Profile": "p.ej. Mi foto de perfil",
    "Edit Profile": "Editar perfil",
    "EDITORIAL LENGTH": "DURACIÓN EDITORIAL",
    "Ensure your full body is visible for the most accurate digital tailoring scan.": "Asegúrese de que todo su cuerpo sea visible para realizar el escaneo de adaptación digital más preciso.",
    "Ensure your full body is visible for the most accurate virtual try-on.": "Asegúrese de que todo su cuerpo sea visible para una prueba virtual más precisa.",
    "Enter height, weight and answer quick body shape questions.": "Ingrese altura, peso y responda preguntas rápidas sobre la forma del cuerpo.",
    "Enter your details for a bespoke size suggestion": "Ingrese sus datos para una sugerencia de tamaño personalizado",
    "Enter your details for accurate body estimation": "Ingrese sus datos para una estimación corporal precisa",
    "Enter your measurements OR upload a photo — we'll use whichever you provide.": "Ingrese sus medidas O cargue una foto; usaremos la que usted proporcione.",
    "ENTERED": "ENTRADO",
    "ESTIMATED": "ESTIMADO",
    "ESTIMATING BODY": "ORGANISMO ESTIMADOR",
    "Estimating head width and depth.": "Estimación del ancho y profundidad de la cabeza.",
    "Estimating your measurements...": "Calculando tus medidas...",
    "Estimation could not complete": "La estimación no se pudo completar",
    "Face the camera directly at eye level": "Mire a la cámara directamente al nivel de los ojos.",
    "Face the camera directly, centered in frame": "Mire directamente a la cámara, centrado en el encuadre.",
    "Face the camera with head and shoulders in frame": "Mire a la cámara con la cabeza y los hombros encuadrados.",
    "Face the camera with your head and shoulders in frame, leaving space above your head.": "Mire a la cámara con la cabeza y los hombros encuadrados, dejando espacio por encima de la cabeza.",
    "Failed to process image": "No se pudo procesar la imagen",
    "Female": "Mujer",
    "FINALIZING": "FINALIZANDO",
    "FINALIZING RESULT": "RESULTADO FINAL",
    "FIT": "AJUSTE",
    "Fit reference": "Referencia de ajuste",
    "Fit Result": "Resultado de ajuste",
    "Fit Terms": "Términos de ajuste",
    "Flat": "Piso",
    "FLAT": "PISO",
    "FOOT": "PIE",
    "Foot length unit": "Unidad de longitud del pie",
    "For your safety, we cannot process photos of people under 18.": "Por tu seguridad, no podemos procesar fotografías de personas menores de 18 años.",
    "Frame Measurements": "Medidas del marco",
    "Full": "completo",
    "FULL": "COMPLETO",
    "Full circumference at the widest point.": "Circunferencia completa en el punto más ancho.",
    "Full Size": "Tamaño completo",
    "Full Size Chart": "Tabla de tallas completa",
    "Garment Spec": "Especificaciones de la prenda",
    "Garment Spotlight": "Foco de ropa",
    "Gender": "Género",
    "GENDER": "GÉNERO",
    "Generating try-on…": "Generando prueba...",
    "Generating Your Look": "Generando tu mirada",
    "Generating your look...": "Generando tu mirada...",
    "Generating your suggested size...": "Generando tu talla sugerida...",
    "Go back": "volver",
    "Good lighting, plain background": "Buena iluminación, fondo liso.",
    "Head and shoulders in frame": "Cabeza y hombros en marco.",
    "Headwear Measurements": "Medidas de sombreros",
    "Helps us refine bust measurements for tops and dresses": "Nos ayuda a refinar las medidas del busto para blusas y vestidos.",
    "Here's what we estimated": "Esto es lo que estimamos",
    "Hide Fit": "Ocultar ajuste",
    "HIP PROFILE": "PERFIL DE CADERA",
    "HIPS": "CADERAS",
    "Hips closer to shoulder width": "Caderas más cercanas al ancho de los hombros.",
    "Hips proportionate to shoulders": "Caderas proporcionales a los hombros.",
    "Hips wider than shoulders": "Caderas más anchas que los hombros.",
    "Hold the camera at eye level": "Sostenga la cámara a la altura de los ojos.",
    "Hold the phone at WAIST height (not eye level)": "Sostenga el teléfono a la altura de la CINTURA (no al nivel de los ojos)",
    "How to Measure": "Cómo medir",
    "Identifying 478 face landmarks in your photo.": "Identificar 478 puntos de referencia faciales en tu foto.",
    "Identifying body landmarks from your photo.": "Identificar puntos de referencia del cuerpo a partir de su foto.",
    "Identifying face landmarks in your photo.": "Identificar puntos de referencia faciales en tu foto.",
    "Identity": "Identidad",
    "Increase": "aumentar",
    "Inner leg seam length.": "Largo de costura interior de pierna.",
    "INSEAM": "ENTREPIEZA",
    "Is the person in this photo 18 years or older?": "¿La persona en esta foto tiene 18 años o más?",
    "JPEG, PNG (max 10MB)": "JPEG, PNG (máximo 10 MB)",
    "JPEG, PNG up to 10MB": "JPEG, PNG hasta 10MB",
    "JPEG, PNG up to 10MB · click or drop": "JPEG, PNG hasta 10 MB · haga clic o suelte",
    "JPEG, PNG, WebP, AVIF (max 10MB)": "JPEG, PNG, WebP, AVIF (máximo 10 MB)",
    "Keep hair away from face and ears": "Mantenga el cabello alejado de la cara y las orejas.",
    "Keep hair away from your face and ears": "Mantenga el cabello alejado de la cara y las orejas.",
    "Keep your full face, ears, and head visible": "Mantenga visible toda su cara, orejas y cabeza.",
    "LAST UPDATE": "ÚLTIMA ACTUALIZACIÓN",
    "Layer with a fitted base for sharper silhouette": "Capa con base ajustada para una silueta más definida.",
    "Leave some space above your head": "Deja algo de espacio encima de tu cabeza",
    "Leave space above your head": "Deja espacio encima de tu cabeza",
    "Leave the bottom button of a suit jacket undone": "Dejar desabrochado el botón inferior de una chaqueta de traje",
    "left": "izquierda",
    "LEGAL NOTICE": "AVISO LEGAL",
    "LENGTH ADJUSTMENT": "AJUSTE DE LONGITUD",
    "Length of the arm from hinge to tip": "Longitud del brazo desde la bisagra hasta la punta.",
    "Loading your fit profile": "Cargando tu perfil de ajuste",
    "Loading your saved measurements and body shape answers.": "Cargando sus medidas guardadas y respuestas sobre la forma del cuerpo.",
    "long": "largo",
    "LOOSE": "SUELTO",
    "Male": "masculino",
    "MANUAL FIT": "AJUSTE MANUAL",
    "MAPPING": "MAPEO",
    "Mapping body landmarks…": "Mapeo de puntos de referencia corporales...",
    "Mapping bridge, frame width and temple fit.": "Mapeo del puente, ancho de la montura y ajuste de las patillas.",
    "Mapping bridge, lens width and temple length.": "Mapeo del puente, ancho de la lente y largo de la patilla.",
    "MAPPING CIRCUMFERENCE": "MAPEO DE CIRCUNFERENCIA",
    "Mapping garment to body": "Mapeo de la prenda al cuerpo",
    "Match your belt to your shoes — never your pants": "Combina tu cinturón con tus zapatos, nunca con tus pantalones",
    "MATCHING FRAME SIZE": "TAMAÑO DE MARCO A JUEGO",
    "MATCHING HAT SIZE": "TAMAÑO DE SOMBRERO A JUEGO",
    "MATCHING SIZE": "TAMAÑO A JUEGO",
    "Measure around your wrist where the bracelet or watch sits": "Mide alrededor de tu muñeca donde se encuentra la pulsera o el reloj.",
    "Measure from heel to longest toe": "Mida desde el talón hasta el dedo más largo",
    "Measure manually": "Medir manualmente",
    "Measurement": "Medición",
    "MEASUREMENT BLUEPRINT": "PLANO DE MEDICIÓN",
    "Measurement Guide": "Guía de medidas",
    "MEASURING": "MEDICIÓN",
    "MEASURING FRAME": "MARCO DE MEDICIÓN",
    "Measuring shoulders, chest, waist and hips.": "Medición de hombros, pecho, cintura y caderas.",
    "MEN'S FIT": "AJUSTE PARA HOMBRE",
    "Menu": "Menú",
    "mm": "milímetros",
    "My Sizing Profiles": "Mis perfiles de tallas",
    "NAME": "NOMBRE",
    "NARROW": "ESTRECHO",
    "NECK": "CUELLO",
    "Neutral background with good lighting": "Fondo neutro con buena iluminación.",
    "New Profile": "Nuevo perfil",
    "No fit": "No encaja",
    "No matching size": "No hay talla coincidente",
    "NO MATCHING SIZE": "SIN TAMAÑO COINCIDENTE",
    "No matching size available": "No hay talla coincidente disponible",
    "No password needed. After sign in, you will continue to the normal profile setup.": "No se necesita contraseña. Después de iniciar sesión, continuará con la configuración normal del perfil.",
    "No size chart available": "No hay tabla de tallas disponible",
    "No size matches your measurements": "Ninguna talla coincide con tus medidas",
    "No sizes match the selected options.": "Ningún tamaño coincide con las opciones seleccionadas.",
    "Not Suggested": "No sugerido",
    "One Size": "Talla única",
    "Opening...": "Abriendo...",
    "Optional note": "Nota opcional",
    "or": "o",
    "Or upload front face": "O subir la cara frontal",
    "Our AI is mapping your proportions for a size suggestion.": "Nuestra IA está mapeando tus proporciones para una sugerencia de tamaño.",
    "Our AI is mapping your proportions.": "Nuestra IA está mapeando tus proporciones.",
    "Our AI is precisely mapping the garment to your unique proportions.": "Nuestra IA asigna con precisión la prenda a sus proporciones únicas.",
    "Our AI works best with front-facing, full-body photos in fitted clothing. Better photos = more accurate virtual try-on!": "Nuestra IA funciona mejor con fotografías de cuerpo completo de frente y con ropa ajustada. Mejores fotos = prueba virtual más precisa.",
    "Our model is analyzing 150+ body landmarks for your size suggestion": "Nuestro modelo está analizando más de 150 puntos de referencia corporales para su sugerencia de tamaño.",
    "Pair this with neutral tones for a balanced look": "Combínalo con tonos neutros para una apariencia equilibrada.",
    "Pick a brand you know well. We'll use that size as your fit reference.": "Elija una marca que conozca bien. Usaremos esa talla como referencia de ajuste.",
    "Please enter a profile name": "Por favor ingresa un nombre de perfil",
    "Please enter a valid age": "Por favor ingresa una edad válida",
    "Please enter your ": "Por favor ingrese su",
    "Please fill in all fields": "Por favor complete todos los campos",
    "Please pick an option": "Por favor elige una opción",
    "Please pick band and cup size": "Por favor elige banda y talla de copa.",
    "Please select your bra band and cup size": "Por favor selecciona la banda de tu sujetador y la talla de copa.",
    "Please select your usual shoe brand and size": "Por favor selecciona tu marca y talla de calzado habitual",
    "Please try again or use manual measurements": "Inténtalo de nuevo o utiliza medidas manuales.",
    "Please try again or use manual measurements.": "Inténtalo de nuevo o utiliza medidas manuales.",
    "Please upload a photo first.": "Primero sube una foto.",
    "Preparing your image": "Preparando tu imagen",
    "Preparing your image…": "Preparando tu imagen…",
    "PrimeStyleAI": "PrimeStyleAI",
    "PrimeStyleAI profile": "Perfil PrimeStyleAI",
    "PrimeStyleAI profile benefits": "Beneficios del perfil PrimeStyleAI",
    "Pro Tip": "Consejo profesional",
    "Proceed": "Continuar",
    "Processing...": "Procesando...",
    "Product photos": "Fotos del producto",
    "Profile": "Perfil",
    "PROFILE": "PERFIL",
    "Profile details": "Detalles del perfil",
    "Profile Name": "Nombre del perfil",
    "Profile photo is missing. Please add a photo and try again.": "Falta la foto de perfil. Añade una foto e inténtalo de nuevo.",
    "Profile sync failed. Your local changes are still saved here.": "Error en la sincronización del perfil. Sus cambios locales todavía se guardan aquí.",
    "Profile welcome": "Bienvenido perfil",
    "Quick Setup": "Configuración rápida",
    "Rate try-on": "Calificar prueba",
    "Rate your try-on": "Califica tu prueba",
    "Rating": "Calificación",
    "Reading head landmarks from your photo.": "Leer puntos de referencia de la cabeza en tu foto.",
    "READING PROFILE": "PERFIL DE LECTURA",
    "READING YOUR PROFILE": "LEYENDO TU PERFIL",
    "Refining drape and shadows": "Refinando cortinas y sombras.",
    "Refining drape and shadows…": "Refinando cortinas y sombras...",
    "Remove any glasses you're wearing": "Quítese las gafas que esté usando",
    "Remove photo": "Quitar foto",
    "Rendering shadows and highlights to match your photo's lighting": "Renderizar sombras y luces para que coincidan con la iluminación de tu foto",
    "Rendering the garment…": "Representando la prenda...",
    "RETAKE PHOTO": "VOLVER A TOMAR FOTO",
    "Reuse these measurements on future products.": "Reutilice estas medidas en productos futuros.",
    "Review before continuing.": "Revisar antes de continuar.",
    "Review your measurements below — you can edit them later": "Revise sus medidas a continuación; podrá editarlas más tarde",
    "Review your photo": "Revisa tu foto",
    "Roll sleeves twice for a relaxed, intentional finish": "Enrolle las mangas dos veces para un acabado relajado e intencionado.",
    "ROUND": "REDONDO",
    "SAVE": "GUARDAR",
    "Save Changes": "Guardar cambios",
    "Save Profile": "Guardar perfil",
    "Save your fit profile": "Guarda tu perfil de ajuste",
    "SCANNING FRAME": "MARCO DE ESCANEO",
    "SDK not configured. Please refresh and try again.": "SDK no configurado. Actualice e inténtelo de nuevo.",
    "Securely reuse your measurements and photo across PrimeStyleAI experiences and partner stores.": "Reutilice de forma segura sus medidas y fotografías en las experiencias PrimeStyleAI y en las tiendas asociadas.",
    "See how it looks on yourself": "Mira cómo te queda a ti mismo",
    "Select": "Seleccionar",
    "SELECT": "SELECCIONAR",
    "Select a size to add to cart": "Seleccione un tamaño para agregar al carrito",
    "SELECT A SIZE TO ADD TO CART": "SELECCIONA UNA TALLA PARA AGREGAR AL CARRITO",
    "Select bra band and cup": "Seleccionar banda y copa del sujetador",
    "Select the profile that best matches your chest breadth": "Selecciona el perfil que mejor se adapta a tu ancho de pecho",
    "SELECTED": "SELECCIONADO",
    "Selected brand": "Marca seleccionada",
    "Send": "enviar",
    "Send feedback": "Enviar comentarios",
    "Sending": "Enviando",
    "Sent": "Enviado",
    "Set height": "Establecer altura",
    "Set weight": "Establecer peso",
    "Shoe brand": "Marca de zapatos",
    "Shoe size": "Talla de zapato",
    "Shoe Size": "Talla de zapato",
    "short": "corto",
    "SHOULDER": "HOMBRO",
    "Shoulder edge to shoulder edge.": "Borde de hombro a borde de hombro.",
    "Shoulder seam to cuff edge.": "Costura del hombro hasta el borde del puño.",
    "Show Fit": "Mostrar ajuste",
    "Sign in": "Iniciar sesión",
    "Sign out": "Cerrar sesión",
    "size": "tamaño",
    "SIZE": "TAMAÑO",
    "Size Guide": "Guía de tallas",
    "SIZE GUIDE": "GUÍA DE TALLAS",
    "Sizing Profile": "Perfil de tamaño",
    "SLEEVE": "MANGA",
    "SLIGHT EASE": "LIGERA FACILIDAD",
    "SLIGHTLY TIGHT": "LIGERAMENTE APRETADO",
    "Continue with Google": "Continuar con Google",
    "Continue with Apple": "Continuar con Apple",
    "Continue with LinkedIn": "Continuar con LinkedIn",
    "Social login failed.": "Error al iniciar sesión social.",
    "Social login failed. Please try again.": "Error al iniciar sesión en redes sociales. Por favor inténtalo de nuevo.",
    "Social login must run in the browser.": "El inicio de sesión social debe ejecutarse en el navegador.",
    "Popup was blocked. Please allow popups and try again.": "La ventana emergente fue bloqueada. Permite ventanas emergentes e inténtalo de nuevo.",
    "Login did not finish. Please close the sign-in window and try again.": "El inicio de sesión no terminó. Cierra la ventana de inicio de sesión e inténtalo de nuevo.",
    "Social sign in": "inicio de sesión social",
    "Stand straight and still, arms relaxed": "Párate derecho y quieto, con los brazos relajados.",
    "Standard": "Estándar",
    "Standing 2-3 meters from camera": "De pie a 2-3 metros de la cámara",
    "stars": "estrellas",
    "Start Fresh": "Empezar de nuevo",
    "Start Try-On": "Iniciar prueba",
    "START TRY-ON": "COMENZAR LA PRUEBA",
    "STEP": "PASO",
    "Step 01": "Paso 01",
    "Step 02": "Paso 02",
    "Stomach": "Estómago",
    "STOMACH PROFILE": "PERFIL DEL ESTÓMAGO",
    "STRAIGHT": "RECTO",
    "Style Tip": "Consejo de estilo",
    "suggested": "sugerido",
    "SUGGESTED": "SUGERIDO",
    "Suggested Size": "Tamaño sugerido",
    "Tap any section for detailed breakdown": "Toca cualquier sección para ver un desglose detallado",
    "Tap any value to adjust if needed": "Toque cualquier valor para ajustarlo si es necesario",
    "Tap the card for detailed breakdown": "Toca la tarjeta para ver un desglose detallado",
    "Tap to upload": "Toca para subir",
    "The curvature of your hips and thighs": "La curvatura de tus caderas y muslos.",
    "The curvature of your lower spine and seat profile": "La curvatura de la parte inferior de la columna y el perfil del asiento.",
    "The merchant hasn't uploaded sizing data for this product yet. You can still see how it looks on you with a virtual try-on.": "El comerciante aún no ha subido datos de tallas para este producto. Aún puedes ver cómo te queda con una prueba virtual.",
    "THIGH": "MUSLO",
    "This cannot be undone.": "Esto no se puede deshacer.",
    "This product's size chart doesn't carry a fit close enough to your body. Try another product or update your profile.": "La tabla de tallas de este producto no se ajusta lo suficiente a tu cuerpo. Pruebe otro producto o actualice su perfil.",
    "This product's size chart doesn't include a reliable fit for your measurements.": "La tabla de tallas de este producto no incluye un ajuste confiable para sus medidas.",
    "TIGHT": "APRETADO",
    "Top to bottom length.": "Longitud de arriba a abajo.",
    "TRY ANOTHER SIZE": "PRUEBA OTRO TAMAÑO",
    "Try-on failed": "La prueba falló",
    "Unable to connect to sizing service. Please try again.": "No se puede conectar con el servicio de dimensionamiento. Por favor inténtalo de nuevo.",
    "Unable to connect to sizing service. Please try manual measurements.": "No se puede conectar con el servicio de dimensionamiento. Intente realizar mediciones manuales.",
    "Unable to get a size suggestion. Please try again.": "No se puede obtener una sugerencia de tamaño. Por favor inténtalo de nuevo.",
    "Unable to get a size suggestion. Please try manual measurements.": "No se puede obtener una sugerencia de tamaño. Intente realizar mediciones manuales.",
    "Unit": "Unidad",
    "Upload a full-body photo. Our AI computes every measurement.": "Sube una foto de cuerpo completo. Nuestra IA calcula cada medición.",
    "Upload a photo for AI sizing": "Sube una foto para dimensionarla con IA",
    "Upload front face": "Subir cara frontal",
    "UPLOAD NOT ALLOWED": "SUBIR NO PERMITIDO",
    "Use a front-facing photo with your face and head clearly visible.": "Utilice una fotografía de frente con su cara y cabeza claramente visibles.",
    "Use bright, even lighting and a plain background": "Utilice una iluminación brillante y uniforme y un fondo liso.",
    "Use natural or even lighting": "Utilice iluminación natural o uniforme.",
    "Use natural, even lighting": "Utilice iluminación natural y uniforme",
    "Use natural, even lighting (e.g. near a window)": "Utilice iluminación natural y uniforme (por ejemplo, cerca de una ventana)",
    "USE THIS PROFILE": "USA ESTE PERFIL",
    "Used to calibrate the AI from your photo.": "Se utiliza para calibrar la IA de tu foto.",
    "USER": "USUARIO",
    "Using iris size as the pixel-to-mm anchor.": "Usar el tamaño del iris como ancla de píxel a mm.",
    "Using saved measurements for this fit.": "Usando medidas guardadas para este ajuste.",
    "VIEW CHART": "VER GRÁFICO",
    "VIEW DETAILS": "VER DETALLES",
    "WAIST": "CINTURA",
    "We couldn't find a size that fits for this product.": "No pudimos encontrar un tamaño que se ajuste a este producto.",
    "We noticed your entered details didn't match your photo. To give you accurate sizing, we measured your body directly from the photo.": "Hemos notado que los datos ingresados no coinciden con su foto. Para brindarle una talla precisa, medimos su cuerpo directamente desde la foto.",
    "Wear fitted, simple clothing": "Use ropa ajustada y sencilla.",
    "Welcome": "Bienvenido",
    "What is my size?": "¿Cuál es mi talla?",
    "Which shoe brand do you usually wear?": "¿Qué marca de zapatos usas habitualmente?",
    "WHILE YOU WAIT": "MIENTRAS ESPERAS",
    "Width of one lens": "Ancho de una lente",
    "WITHIN RANGE": "DENTRO DEL ALCANCE",
    "WOMEN'S FIT": "AJUSTE DE MUJER",
    "Wrap a tape around the widest part of your head": "Envuelve una cinta alrededor de la parte más ancha de tu cabeza.",
    "Wrist Circumference": "Circunferencia de la muñeca",
    "Wrist Measurements": "Medidas de muñeca",
    "YEARS": "AÑOS",
    "You chose": "tu elegiste",
    "Your Body": "tu cuerpo",
    "Your Choice · Not Suggested": "Tu elección · No sugerido",
    "YOUR CHOICE · NOT SUGGESTED": "TU ELECCIÓN · NO SUGERIDO",
    "Your Details": "Tus detalles",
    "Your Fit": "Tu ajuste",
    "Your measurements": "Tus medidas",
    "Your profile is private to your PrimeStyleAI account and can be updated anytime.": "Su perfil es privado para su cuenta PrimeStyleAI y puede actualizarse en cualquier momento.",
    "Your profiles": "Tus perfiles",
    "Your Selection": "Tu selección",
    "YOUR SELECTION": "TU SELECCIÓN",
    "your selection · not suggested": "tu selección · no sugerido",
    "Your size": "Tu talla",
    "Your size is": "Tu talla es",
    "Your try-on history": "Tu historial de pruebas",
  },
  "fr": {
    "*Our sizing engine recommends": "*Notre moteur de dimensionnement recommande",
    "✓ Pose detected — running body analysis": "✓ Pose détectée - analyse corporelle en cours",
    "A clean close-up improves landmark detection for eyewear and headwear.": "Un gros plan net améliore la détection des points de repère pour les lunettes et les couvre-chefs.",
    "A clear head-and-shoulders photo with space above your head gives the most accurate headwear try-on.": "Une photo claire de la tête et des épaules avec un espace au-dessus de votre tête permet d'essayer le couvre-chef le plus précisément possible.",
    "A clear, front-facing face photo — no glasses on — gives us the most accurate try-on.": "Une photo claire du visage de face – sans lunettes – nous donne l’essayage le plus précis.",
    "A clear, well-lit face photo gives the most accurate eyewear try-on.": "Une photo du visage claire et bien éclairée permet un essai de lunettes le plus précis possible.",
    "A clear, well-lit face photo gives the most accurate fit for eyewear and headwear.": "Une photo de visage claire et bien éclairée donne l’ajustement le plus précis pour les lunettes et les couvre-chefs.",
    "A tie tip should land at the middle of your belt buckle": "Une pointe de cravate doit atterrir au milieu de la boucle de votre ceinture",
    "Active Profile": "Profil actif",
    "ACTIVE PROFILE": "PROFIL ACTIF",
    "Add a name for this profile": "Ajouter un nom pour ce profil",
    "ADD MEASUREMENTS & PHOTO": "AJOUTER DES MESURES ET UNE PHOTO",
    "Add them to cart.": "Ajoutez-les au panier.",
    "Add to Bag": "Ajouter au panier",
    "Added to bag": "Ajouté au panier",
    "Adding...": "Ajout...",
    "Age": "Âge",
    "Age verification": "Vérification de l'âge",
    "AGE VERIFICATION": "VÉRIFICATION DE L'ÂGE",
    "AI Fact": "Fait sur l'IA",
    "AI Powered": "Alimenté par l'IA",
    "AI SCAN": "ANALYSE IA",
    "All measurements in": "Toutes les mesures en",
    "almost done": "presque fini",
    "Almost done": "Presque terminé",
    "Almost done — finalizing…": "Presque terminé – finalisation…",
    "Almost done — preparing your suggested size.": "Presque terminé : préparez votre taille suggérée.",
    "Analyze": "Analyser",
    "Analyze by photo": "Analyser par photo",
    "ANALYZE MY SIZE": "ANALYSER MA TAILLE",
    "ANALYZING": "ANALYSE",
    "ANALYZING BODY": "ANALYSER LE CORPS",
    "ANALYZING BODY MAP": "ANALYSE DE LA CARTE CORPORELLE",
    "Analyzing body proportions": "Analyser les proportions du corps",
    "Around the base of the neck.": "Autour de la base du cou.",
    "AVERAGE": "MOYENNE",
    "BACK": "RETOUR",
    "Back & Seat": "Dossier et siège",
    "BACK & SEAT": "DOSSIER ET SIÈGE",
    "Back to brands": "Retour aux marques",
    "Back to product": "Retour au produit",
    "based on your measurements and the garment's tailoring chart.": "en fonction de vos mesures et du tableau de confection du vêtement.",
    "based on your selected brand size and foot length.": "en fonction de la taille de votre marque et de la longueur du pied sélectionnées.",
    "best match": "meilleur match",
    "BEST MATCH": "MEILLEUR MATCH",
    "BODY MEASUREMENTS": "MESURES DU CORPS",
    "Body measurements calculated!": "Mesures corporelles calculées !",
    "Bra": "Soutien-gorge",
    "BRA SIZE": "TAILLE DU SOUTIEN-GORGE",
    "BROAD": "LARGE",
    "BUST": "BUSTE",
    "Calculate My Body Parts": "Calculer mes parties du corps",
    "CALCULATE MY FIT": "CALCULER MON AJUSTEMENT",
    "CALCULATING": "CALCUL",
    "calculating...": "calculer...",
    "Calculating...": "Calcul...",
    "CALIBRATING": "CALIBRAGE",
    "Calibrating fabric drape against your body proportions": "Calibrer le drapé du tissu en fonction des proportions de votre corps",
    "CALIBRATING SCALE": "BALANCE DE CALIBRAGE",
    "Cancel": "Annuler",
    "Cancel Generation": "Annuler la génération",
    "centimeters": "centimètres",
    "Change": "Changement",
    "Checklist for accuracy": "Liste de contrôle pour l'exactitude",
    "CHEST": "POITRINE",
    "CHEST PROFILE": "PROFIL DE POITRINE",
    "Choose a method": "Choisissez une méthode",
    "Choose a plain background": "Choisissez un fond uni",
    "Choose a plain, light background": "Choisissez un fond uni et clair",
    "Choose a saved profile or create a new one before finding your best fit.": "Choisissez un profil enregistré ou créez-en un nouveau avant de trouver celui qui vous convient le mieux.",
    "Choose another photo": "Choisissez une autre photo",
    "Choose one account": "Choisissez un compte",
    "Choose size": "Choisissez la taille",
    "Choose your shoe brand": "Choisissez votre marque de chaussures",
    "Choose your usual": "Choisissez votre habitude",
    "Circumference around the upper leg.": "Circonférence autour du haut de la jambe.",
    "Circumference at the fullest point.": "Circonférence au maximum.",
    "Circumference at the natural waistline.": "Circonférence à la taille naturelle.",
    "Clear All": "Tout effacer",
    "Click or drag a close-up face photo": "Cliquez ou faites glisser une photo de visage en gros plan",
    "Click or drag a front face photo": "Cliquez ou faites glisser une photo de face",
    "Click or drag a head-and-shoulders photo": "Cliquez ou faites glisser une photo de la tête et des épaules",
    "Click to change photo": "Cliquez pour changer de photo",
    "CM": "CM",
    "Comparing your circumference to the size chart.": "En comparant votre circonférence au tableau des tailles.",
    "Comparing your measurements to the garment's size guide.": "Comparer vos mesures au guide des tailles du vêtement.",
    "Comparing your measurements to the size chart.": "Comparer vos mesures au tableau des tailles.",
    "Comparing your measurements to the size guide.": "Comparer vos mesures au guide des tailles.",
    "Complete the look": "Complétez le look",
    "Computing chest, waist, hips, sleeve and inseam from your basics.": "Calculez la poitrine, la taille, les hanches, les manches et l'entrejambe à partir de vos bases.",
    "Confirm your measurements": "Confirmez vos mesures",
    "Continue Shopping": "Continuer vos achats",
    "Could not load your saved profiles.": "Impossible de charger vos profils enregistrés.",
    "Couldn't send. Try again.": "Impossible d'envoyer. Essayer à nouveau.",
    "Country": "Pays",
    "Crafted with quality materials for everyday comfort": "Fabriqué avec des matériaux de qualité pour un confort au quotidien",
    "Create New Profile": "Créer un nouveau profil",
    "Create Profile": "Créer un profil",
    "Create your first fit profile to save your measurements, photo, and size history.": "Créez votre premier profil d'ajustement pour enregistrer vos mesures, vos photos et votre historique des tailles.",
    "Create your fit profile once.": "Créez votre profil d'ajustement une fois.",
    "Cross-checking fit against millions of garment patterns": "Vérification de l'ajustement avec des millions de modèles de vêtements",
    "Cuff a pocket square so it peeks 1–2 cm above the pocket": "Repassez une pochette de costume pour qu'elle dépasse de 1 à 2 cm au-dessus de la poche.",
    "Cuff once for a relaxed everyday feel": "Manchette une fois pour une sensation de détente au quotidien",
    "Cufflinks should sit half an inch past the jacket sleeve": "Les boutons de manchette doivent reposer à un demi-pouce au-delà de la manche de la veste.",
    "CURVED": "COURBÉ",
    "Decrease": "Diminuer",
    "DEEP": "PROFONDE",
    "DEFAULT PROFILE": "PROFIL PAR DÉFAUT",
    "Delete": "Supprimer",
    "Delete this profile?": "Supprimer ce profil ?",
    "Describe your mid-section silhouette": "Décrivez votre silhouette médiane",
    "DETAIL": "DÉTAIL",
    "Detecting body pose": "Détection de la posture du corps",
    "Detecting face": "Détection du visage",
    "DETECTING FACE": "DÉTECTION DE VISAGE",
    "Detecting head": "Tête de détection",
    "DETECTING HEAD": "TÊTE DE DÉTECTION",
    "DETECTING POSE": "DÉTECTION DE POSE",
    "Detecting pose landmarks…": "Détection des repères de pose…",
    "Display size in country": "Taille d'affichage dans le pays",
    "Distance over the nose between lenses": "Distance sur le nez entre les verres",
    "Don't apply filters or edits": "Ne pas appliquer de filtres ni de modifications",
    "Don't apply filters or heavy edits": "N'appliquez pas de filtres ni de modifications importantes",
    "Don't cover your ears, eyes, or forehead": "Ne couvrez pas vos oreilles, vos yeux ou votre front",
    "Don't crop out the top of your head": "Ne coupez pas le haut de votre tête",
    "Don't crop out your ears or top of head": "Ne coupez pas vos oreilles ou le haut de votre tête",
    "Don't sit, pose, or bend": "Ne vous asseyez pas, ne posez pas et ne vous penchez pas",
    "Don't tilt or turn your head": "N'inclinez pas et ne tournez pas la tête",
    "Don't use filters, mirrored photos, or angled selfies": "N'utilisez pas de filtres, de photos en miroir ou de selfies inclinés",
    "Don't use heavy shadows or strong backlighting": "N'utilisez pas d'ombres lourdes ou de contre-jour intense",
    "Don't use strong backlighting or flash": "N'utilisez pas de fort contre-jour ou de flash",
    "Don't wear a hat in the photo": "Ne porte pas de chapeau sur la photo",
    "Don't wear loose or baggy clothing": "Ne portez pas de vêtements amples ou amples",
    "Don't wear sunglasses or a hat in the photo": "Ne portez pas de lunettes de soleil ni de chapeau sur la photo",
    "Done": "Terminé",
    "e.g. 154": "par ex. 154",
    "e.g. 173": "par ex. 173",
    "e.g. 30": "par ex. 30",
    "e.g. 70": "par ex. 70",
    "e.g. My Measurements": "par ex. Mes mesures",
    "e.g. My Photo Profile": "par ex. Mon profil photo",
    "Edit Profile": "Modifier le profil",
    "EDITORIAL LENGTH": "DURÉE ÉDITORIALE",
    "Ensure your full body is visible for the most accurate digital tailoring scan.": "Assurez-vous que tout votre corps est visible pour l'analyse de personnalisation numérique la plus précise.",
    "Ensure your full body is visible for the most accurate virtual try-on.": "Assurez-vous que tout votre corps est visible pour un essai virtuel le plus précis possible.",
    "Enter height, weight and answer quick body shape questions.": "Entrez la taille, le poids et répondez à des questions rapides sur la forme du corps.",
    "Enter your details for a bespoke size suggestion": "Entrez vos coordonnées pour une suggestion de taille sur mesure",
    "Enter your details for accurate body estimation": "Entrez vos coordonnées pour une estimation précise du corps",
    "Enter your measurements OR upload a photo — we'll use whichever you provide.": "Entrez vos mesures OU téléchargez une photo — nous utiliserons celle que vous nous fournissez.",
    "ENTERED": "ENTRÉ",
    "ESTIMATED": "ESTIMÉ",
    "ESTIMATING BODY": "CORPS D'ESTIMATION",
    "Estimating head width and depth.": "Estimation de la largeur et de la profondeur de la tête.",
    "Estimating your measurements...": "Estimation de vos mesures...",
    "Estimation could not complete": "L'estimation n'a pas pu être terminée",
    "Face the camera directly at eye level": "Placez la caméra directement au niveau des yeux",
    "Face the camera directly, centered in frame": "Faites face à la caméra directement, centrée dans le cadre",
    "Face the camera with head and shoulders in frame": "Faites face à la caméra avec la tête et les épaules dans le cadre",
    "Face the camera with your head and shoulders in frame, leaving space above your head.": "Faites face à la caméra avec la tête et les épaules dans le cadre, en laissant un espace au-dessus de votre tête.",
    "Failed to process image": "Échec du traitement de l'image",
    "Female": "Femme",
    "FINALIZING": "FINALISATION",
    "FINALIZING RESULT": "RÉSULTAT FINALISATION",
    "FIT": "AJUSTEMENT",
    "Fit reference": "Référence d'ajustement",
    "Fit Result": "Résultat d'ajustement",
    "Fit Terms": "Conditions d'ajustement",
    "Flat": "Plat",
    "FLAT": "PLAT",
    "FOOT": "PIED",
    "Foot length unit": "Unité de longueur de pied",
    "For your safety, we cannot process photos of people under 18.": "Pour votre sécurité, nous ne pouvons pas traiter les photos de personnes de moins de 18 ans.",
    "Frame Measurements": "Mesures du cadre",
    "Full": "Plein",
    "FULL": "COMPLET",
    "Full circumference at the widest point.": "Circonférence complète au point le plus large.",
    "Full Size": "Pleine grandeur",
    "Full Size Chart": "Tableau en taille réelle",
    "Garment Spec": "Spécification du vêtement",
    "Garment Spotlight": "Pleins feux sur les vêtements",
    "Gender": "Sexe",
    "GENDER": "GENRE",
    "Generating try-on…": "Génération d'essais…",
    "Generating Your Look": "Générer votre look",
    "Generating your look...": "Générer votre look...",
    "Generating your suggested size...": "Génération de votre taille suggérée...",
    "Go back": "Retourner",
    "Good lighting, plain background": "Bon éclairage, fond uni",
    "Head and shoulders in frame": "Tête et épaules dans le cadre",
    "Headwear Measurements": "Mesures du couvre-chef",
    "Helps us refine bust measurements for tops and dresses": "Nous aide à affiner les mesures de buste pour les hauts et les robes",
    "Here's what we estimated": "Voici ce que nous avons estimé",
    "Hide Fit": "Masquer l'ajustement",
    "HIP PROFILE": "PROFIL DE HANCHE",
    "HIPS": "HANCHES",
    "Hips closer to shoulder width": "Hanches plus proches de la largeur des épaules",
    "Hips proportionate to shoulders": "Hanches proportionnées aux épaules",
    "Hips wider than shoulders": "Hanches plus larges que les épaules",
    "Hold the camera at eye level": "Tenez l'appareil photo au niveau des yeux",
    "Hold the phone at WAIST height (not eye level)": "Tenez le téléphone à la hauteur de la TAILLE (pas au niveau des yeux)",
    "How to Measure": "Comment mesurer",
    "Identifying 478 face landmarks in your photo.": "Identifier 478 repères de visage sur votre photo.",
    "Identifying body landmarks from your photo.": "Identifier les repères corporels à partir de votre photo.",
    "Identifying face landmarks in your photo.": "Identifier les points de repère du visage sur votre photo.",
    "Identity": "Identité",
    "Increase": "Augmentation",
    "Inner leg seam length.": "Longueur de couture intérieure de la jambe.",
    "INSEAM": "INSEAM",
    "Is the person in this photo 18 years or older?": "La personne sur cette photo est-elle âgée de 18 ans ou plus ?",
    "JPEG, PNG (max 10MB)": "JPEG, PNG (maximum 10 Mo)",
    "JPEG, PNG up to 10MB": "JPEG, PNG jusqu'à 10 Mo",
    "JPEG, PNG up to 10MB · click or drop": "JPEG, PNG jusqu'à 10 Mo · cliquez ou déposez",
    "JPEG, PNG, WebP, AVIF (max 10MB)": "JPEG, PNG, WebP, AVIF (maximum 10 Mo)",
    "Keep hair away from face and ears": "Gardez les cheveux loin du visage et des oreilles",
    "Keep hair away from your face and ears": "Gardez les cheveux éloignés de votre visage et de vos oreilles",
    "Keep your full face, ears, and head visible": "Gardez votre visage, vos oreilles et votre tête visibles",
    "LAST UPDATE": "DERNIÈRE MISE À JOUR",
    "Layer with a fitted base for sharper silhouette": "À superposer avec une base ajustée pour une silhouette plus nette",
    "Leave some space above your head": "Laissez un peu d'espace au dessus de votre tête",
    "Leave space above your head": "Laissez de l'espace au dessus de votre tête",
    "Leave the bottom button of a suit jacket undone": "Laisser le bouton du bas d'une veste de costume défait",
    "left": "à gauche",
    "LEGAL NOTICE": "MENTIONS LÉGALES",
    "LENGTH ADJUSTMENT": "RÉGLAGE DE LA LONGUEUR",
    "Length of the arm from hinge to tip": "Longueur du bras de la charnière à la pointe",
    "Loading your fit profile": "Chargement de votre profil d'ajustement",
    "Loading your saved measurements and body shape answers.": "Loading your saved measurements and body shape answers.",
    "long": "longtemps",
    "LOOSE": "LÂCHE",
    "Male": "Mâle",
    "MANUAL FIT": "AJUSTEMENT MANUEL",
    "MAPPING": "CARTOGRAPHIE",
    "Mapping body landmarks…": "Cartographie des repères corporels…",
    "Mapping bridge, frame width and temple fit.": "Cartographie du pont, de la largeur de la monture et de l'ajustement des branches.",
    "Mapping bridge, lens width and temple length.": "Cartographie du pont, de la largeur des verres et de la longueur des branches.",
    "MAPPING CIRCUMFERENCE": "CIRCONFÉRENCE DE CARTOGRAPHIE",
    "Mapping garment to body": "Mappage du vêtement au corps",
    "Match your belt to your shoes — never your pants": "Assortissez votre ceinture à vos chaussures – jamais à votre pantalon",
    "MATCHING FRAME SIZE": "TAILLE DE CADRE CORRESPONDANTE",
    "MATCHING HAT SIZE": "TAILLE DE CHAPEAU CORRESPONDANTE",
    "MATCHING SIZE": "TAILLE CORRESPONDANTE",
    "Measure around your wrist where the bracelet or watch sits": "Mesurez le tour de votre poignet, là où se trouve le bracelet ou la montre.",
    "Measure from heel to longest toe": "Mesurez du talon à l'orteil le plus long",
    "Measure manually": "Mesurer manuellement",
    "Measurement": "Mesure",
    "MEASUREMENT BLUEPRINT": "PLAN DE MESURE",
    "Measurement Guide": "Guide de mesure",
    "MEASURING": "MESURER",
    "MEASURING FRAME": "CADRE DE MESURE",
    "Measuring shoulders, chest, waist and hips.": "Mesurer les épaules, la poitrine, la taille et les hanches.",
    "MEN'S FIT": "COUPE HOMME",
    "Menu": "Menus",
    "mm": "mm",
    "My Sizing Profiles": "Mes profils de tailles",
    "NAME": "NOM",
    "NARROW": "ÉTROIT",
    "NECK": "COU",
    "Neutral background with good lighting": "Fond neutre avec un bon éclairage",
    "New Profile": "Nouveau profil",
    "No fit": "Pas d'ajustement",
    "No matching size": "Aucune taille correspondante",
    "NO MATCHING SIZE": "PAS DE TAILLE CORRESPONDANTE",
    "No matching size available": "Aucune taille correspondante disponible",
    "No password needed. After sign in, you will continue to the normal profile setup.": "Aucun mot de passe requis. Après vous être connecté, vous continuerez à la configuration normale du profil.",
    "No size chart available": "Aucun tableau des tailles disponible",
    "No size matches your measurements": "Aucune taille ne correspond à vos mesures",
    "No sizes match the selected options.": "Aucune taille ne correspond aux options sélectionnées.",
    "Not Suggested": "Non suggéré",
    "One Size": "Taille unique",
    "Opening...": "Ouverture...",
    "Optional note": "Remarque facultative",
    "or": "ou",
    "Or upload front face": "Ou téléchargez la face avant",
    "Our AI is mapping your proportions for a size suggestion.": "Notre IA cartographie vos proportions pour une suggestion de taille.",
    "Our AI is mapping your proportions.": "Notre IA cartographie vos proportions.",
    "Our AI is precisely mapping the garment to your unique proportions.": "Notre IA cartographie précisément le vêtement selon vos proportions uniques.",
    "Our AI works best with front-facing, full-body photos in fitted clothing. Better photos = more accurate virtual try-on!": "Notre IA fonctionne mieux avec des photos du corps entier, de face, dans des vêtements ajustés. De meilleures photos = un essai virtuel plus précis !",
    "Our model is analyzing 150+ body landmarks for your size suggestion": "Notre modèle analyse plus de 150 repères corporels pour votre suggestion de taille",
    "Pair this with neutral tones for a balanced look": "Associez-le à des tons neutres pour un look équilibré",
    "Pick a brand you know well. We'll use that size as your fit reference.": "Choisissez une marque que vous connaissez bien. Nous utiliserons cette taille comme référence d'ajustement.",
    "Please enter a profile name": "Veuillez entrer un nom de profil",
    "Please enter a valid age": "Veuillez entrer un âge valide",
    "Please enter your ": "Veuillez entrer votre",
    "Please fill in all fields": "Veuillez remplir tous les champs",
    "Please pick an option": "Veuillez choisir une option",
    "Please pick band and cup size": "Veuillez choisir la taille du bandeau et du bonnet",
    "Please select your bra band and cup size": "Veuillez sélectionner votre bandeau de soutien-gorge et votre taille de bonnet",
    "Please select your usual shoe brand and size": "Veuillez sélectionner votre marque et votre taille de chaussures habituelles",
    "Please try again or use manual measurements": "Veuillez réessayer ou utiliser des mesures manuelles",
    "Please try again or use manual measurements.": "Veuillez réessayer ou utiliser des mesures manuelles.",
    "Please upload a photo first.": "Veuillez d'abord télécharger une photo.",
    "Preparing your image": "Préparer votre image",
    "Preparing your image…": "Préparer votre image…",
    "PrimeStyleAI": "PrimeStyleAI",
    "PrimeStyleAI profile": "Profil PrimeStyleAI",
    "PrimeStyleAI profile benefits": "Avantages du profil PrimeStyleAI",
    "Pro Tip": "Conseil de pro",
    "Proceed": "Continuer",
    "Processing...": "Traitement...",
    "Product photos": "Photos du produit",
    "Profile": "Profil",
    "PROFILE": "PROFIL",
    "Profile details": "Détails du profil",
    "Profile Name": "Nom du profil",
    "Profile photo is missing. Please add a photo and try again.": "La photo de profil est manquante. Veuillez ajouter une photo et réessayer.",
    "Profile sync failed. Your local changes are still saved here.": "La synchronisation du profil a échoué. Vos modifications locales sont toujours enregistrées ici.",
    "Profile welcome": "Profil bienvenue",
    "Quick Setup": "Configuration rapide",
    "Rate try-on": "Évaluer l'essayage",
    "Rate your try-on": "Évaluez votre essai",
    "Rating": "Note",
    "Reading head landmarks from your photo.": "Lire les points de repère à partir de votre photo.",
    "READING PROFILE": "PROFIL DE LECTURE",
    "READING YOUR PROFILE": "LIRE VOTRE PROFIL",
    "Refining drape and shadows": "Affiner le drapé et les ombres",
    "Refining drape and shadows…": "Affiner le drapé et les ombres…",
    "Remove any glasses you're wearing": "Retirez toutes les lunettes que vous portez",
    "Remove photo": "Supprimer la photo",
    "Rendering shadows and highlights to match your photo's lighting": "Rendu des ombres et des hautes lumières pour correspondre à l'éclairage de votre photo",
    "Rendering the garment…": "Rendu du vêtement…",
    "RETAKE PHOTO": "REPRENDRE LA PHOTO",
    "Reuse these measurements on future products.": "Réutilisez ces mesures sur les futurs produits.",
    "Review before continuing.": "Révisez avant de continuer.",
    "Review your measurements below — you can edit them later": "Vérifiez vos mesures ci-dessous – vous pourrez les modifier plus tard",
    "Review your photo": "Revoir votre photo",
    "Roll sleeves twice for a relaxed, intentional finish": "Rouler les manches deux fois pour une finition décontractée et intentionnelle",
    "ROUND": "ROND",
    "SAVE": "ENREGISTRER",
    "Save Changes": "Enregistrer les modifications",
    "Save Profile": "Enregistrer le profil",
    "Save your fit profile": "Enregistrez votre profil d'ajustement",
    "SCANNING FRAME": "CADRE DE NUMÉRISATION",
    "SDK not configured. Please refresh and try again.": "SDK non configuré. Veuillez actualiser et réessayer.",
    "Securely reuse your measurements and photo across PrimeStyleAI experiences and partner stores.": "Réutilisez en toute sécurité vos mesures et vos photos dans les expériences PrimeStyleAI et les magasins partenaires.",
    "See how it looks on yourself": "Voyez à quoi ça ressemble par vous-même",
    "Select": "Sélectionnez",
    "SELECT": "SÉLECTIONNER",
    "Select a size to add to cart": "Sélectionnez une taille à ajouter au panier",
    "SELECT A SIZE TO ADD TO CART": "SÉLECTIONNEZ UNE TAILLE À AJOUTER AU PANIER",
    "Select bra band and cup": "Sélectionnez le bandeau et le bonnet du soutien-gorge",
    "Select the profile that best matches your chest breadth": "Sélectionnez le profil qui correspond le mieux à votre tour de poitrine",
    "SELECTED": "SÉLECTIONNÉ",
    "Selected brand": "Marque sélectionnée",
    "Send": "Envoyer",
    "Send feedback": "Envoyer des commentaires",
    "Sending": "Envoi",
    "Sent": "Envoyé",
    "Set height": "Définir la hauteur",
    "Set weight": "Définir le poids",
    "Shoe brand": "Marque de chaussures",
    "Shoe size": "Pointure des chaussures",
    "Shoe Size": "Taille de chaussure",
    "short": "court",
    "SHOULDER": "ÉPAULE",
    "Shoulder edge to shoulder edge.": "Bord d’épaule à bord d’épaule.",
    "Shoulder seam to cuff edge.": "Couture d'épaule jusqu'au bord du poignet.",
    "Show Fit": "Afficher l'ajustement",
    "Sign in": "Connectez-vous",
    "Sign out": "Se déconnecter",
    "size": "taille",
    "SIZE": "TAILLE",
    "Size Guide": "Guide des tailles",
    "SIZE GUIDE": "GUIDE DES TAILLES",
    "Sizing Profile": "Profil de dimensionnement",
    "SLEEVE": "MANCHE",
    "SLIGHT EASE": "LÉGÈRE FACILITÉ",
    "SLIGHTLY TIGHT": "LÉGÈREMENT SERRÉ",
    "Continue with Google": "Continuer avec Google",
    "Continue with Apple": "Continuer avec Apple",
    "Continue with LinkedIn": "Continuer avec LinkedIn",
    "Social login failed.": "La connexion sociale a échoué.",
    "Social login failed. Please try again.": "La connexion sociale a échoué. Veuillez réessayer.",
    "Social login must run in the browser.": "La connexion sociale doit s'exécuter dans le navigateur.",
    "Popup was blocked. Please allow popups and try again.": "La fenêtre contextuelle a été bloquée. Autorisez les fenêtres contextuelles et réessayez.",
    "Login did not finish. Please close the sign-in window and try again.": "La connexion ne s'est pas terminée. Fermez la fenêtre de connexion et réessayez.",
    "Social sign in": "Connexion sociale",
    "Stand straight and still, arms relaxed": "Tenez-vous droit et immobile, les bras détendus",
    "Standard": "Norme",
    "Standing 2-3 meters from camera": "Se tenir à 2-3 mètres de la caméra",
    "stars": "étoiles",
    "Start Fresh": "Repartir à neuf",
    "Start Try-On": "Commencer l'essai",
    "START TRY-ON": "COMMENCER L'ESSAI",
    "STEP": "ÉTAPE",
    "Step 01": "Étape 01",
    "Step 02": "Étape 02",
    "Stomach": "Estomac",
    "STOMACH PROFILE": "PROFIL DE L'ESTOMAC",
    "STRAIGHT": "DROIT",
    "Style Tip": "Conseil de style",
    "suggested": "suggéré",
    "SUGGESTED": "SUGGÉRÉ",
    "Suggested Size": "Taille suggérée",
    "Tap any section for detailed breakdown": "Appuyez sur n'importe quelle section pour une ventilation détaillée",
    "Tap any value to adjust if needed": "Appuyez sur n'importe quelle valeur pour l'ajuster si nécessaire",
    "Tap the card for detailed breakdown": "Appuyez sur la carte pour une ventilation détaillée",
    "Tap to upload": "Appuyez pour télécharger",
    "The curvature of your hips and thighs": "La courbure de vos hanches et de vos cuisses",
    "The curvature of your lower spine and seat profile": "La courbure du bas de votre colonne vertébrale et le profil de votre siège",
    "The merchant hasn't uploaded sizing data for this product yet. You can still see how it looks on you with a virtual try-on.": "Le marchand n'a pas encore téléchargé les données de taille pour ce produit. Vous pouvez toujours voir à quoi il vous va grâce à un essai virtuel.",
    "THIGH": "CUISSE",
    "This cannot be undone.": "Cela ne peut pas être annulé.",
    "This product's size chart doesn't carry a fit close enough to your body. Try another product or update your profile.": "Le tableau des tailles de ce produit ne correspond pas suffisamment à votre corps. Essayez un autre produit ou mettez à jour votre profil.",
    "This product's size chart doesn't include a reliable fit for your measurements.": "Le tableau des tailles de ce produit n'inclut pas un ajustement fiable pour vos mesures.",
    "TIGHT": "SERRÉ",
    "Top to bottom length.": "Longueur de haut en bas.",
    "TRY ANOTHER SIZE": "ESSAYEZ UNE AUTRE TAILLE",
    "Try-on failed": "L'essai a échoué",
    "Unable to connect to sizing service. Please try again.": "Impossible de se connecter au service de dimensionnement. Veuillez réessayer.",
    "Unable to connect to sizing service. Please try manual measurements.": "Impossible de se connecter au service de dimensionnement. Veuillez essayer les mesures manuelles.",
    "Unable to get a size suggestion. Please try again.": "Impossible d'obtenir une suggestion de taille. Veuillez réessayer.",
    "Unable to get a size suggestion. Please try manual measurements.": "Impossible d'obtenir une suggestion de taille. Veuillez essayer les mesures manuelles.",
    "Unit": "Unité",
    "Upload a full-body photo. Our AI computes every measurement.": "Téléchargez une photo de tout le corps. Notre IA calcule chaque mesure.",
    "Upload a photo for AI sizing": "Téléchargez une photo pour le dimensionnement de l'IA",
    "Upload front face": "Télécharger la face avant",
    "UPLOAD NOT ALLOWED": "TÉLÉCHARGEMENT NON AUTORISÉ",
    "Use a front-facing photo with your face and head clearly visible.": "Utilisez une photo de face avec votre visage et votre tête clairement visibles.",
    "Use bright, even lighting and a plain background": "Utilisez un éclairage clair et uniforme et un arrière-plan uni",
    "Use natural or even lighting": "Utilisez un éclairage naturel ou même un éclairage",
    "Use natural, even lighting": "Utilisez un éclairage naturel et uniforme",
    "Use natural, even lighting (e.g. near a window)": "Utilisez un éclairage naturel et uniforme (par exemple près d’une fenêtre)",
    "USE THIS PROFILE": "UTILISEZ CE PROFIL",
    "Used to calibrate the AI from your photo.": "Utilisé pour calibrer l'IA à partir de votre photo.",
    "USER": "UTILISATEUR",
    "Using iris size as the pixel-to-mm anchor.": "Utilisation de la taille de l'iris comme ancre pixel en mm.",
    "Using saved measurements for this fit.": "Utilisation des mesures enregistrées pour cet ajustement.",
    "VIEW CHART": "VOIR LE TABLEAU",
    "VIEW DETAILS": "VOIR LES DÉTAILS",
    "WAIST": "TAILLE",
    "We couldn't find a size that fits for this product.": "Nous n'avons pas trouvé de taille adaptée à ce produit.",
    "We noticed your entered details didn't match your photo. To give you accurate sizing, we measured your body directly from the photo.": "Nous avons remarqué que vos informations saisies ne correspondent pas à votre photo. Pour vous donner une taille précise, nous avons mesuré votre corps directement à partir de la photo.",
    "Wear fitted, simple clothing": "Portez des vêtements simples et ajustés",
    "Welcome": "Bienvenue",
    "What is my size?": "Quelle est ma taille ?",
    "Which shoe brand do you usually wear?": "Quelle marque de chaussures portez-vous habituellement ?",
    "WHILE YOU WAIT": "PENDANT QUE VOUS ATTENDEZ",
    "Width of one lens": "Largeur d'une lentille",
    "WITHIN RANGE": "À PORTÉE",
    "WOMEN'S FIT": "COUPE FEMME",
    "Wrap a tape around the widest part of your head": "Enroulez un ruban adhésif autour de la partie la plus large de votre tête",
    "Wrist Circumference": "Circonférence du poignet",
    "Wrist Measurements": "Mesures du poignet",
    "YEARS": "ANNÉES",
    "You chose": "Vous avez choisi",
    "Your Body": "Votre corps",
    "Your Choice · Not Suggested": "Votre choix · Non suggéré",
    "YOUR CHOICE · NOT SUGGESTED": "VOTRE CHOIX · NON SUGGÉRÉ",
    "Your Details": "Vos coordonnées",
    "Your Fit": "Votre coupe",
    "Your measurements": "Vos mesures",
    "Your profile is private to your PrimeStyleAI account and can be updated anytime.": "Votre profil est privé sur votre compte PrimeStyleAI et peut être mis à jour à tout moment.",
    "Your profiles": "Vos profils",
    "Your Selection": "Votre sélection",
    "YOUR SELECTION": "VOTRE SÉLECTION",
    "your selection · not suggested": "votre sélection · non suggéré",
    "Your size": "Votre taille",
    "Your size is": "Votre taille est",
    "Your try-on history": "Votre historique d'essayage",
  },
  "de": {
    "*Our sizing engine recommends": "*Unsere Größen-Engine empfiehlt",
    "✓ Pose detected — running body analysis": "✓ Pose erkannt – laufende Körperanalyse",
    "A clean close-up improves landmark detection for eyewear and headwear.": "Eine saubere Nahaufnahme verbessert die Erkennung von Orientierungspunkten für Brillen und Kopfbedeckungen.",
    "A clear head-and-shoulders photo with space above your head gives the most accurate headwear try-on.": "Ein klares Foto von Kopf und Schultern mit Platz über Ihrem Kopf ermöglicht das genaueste Anprobieren einer Kopfbedeckung.",
    "A clear, front-facing face photo — no glasses on — gives us the most accurate try-on.": "Ein klares, nach vorne gerichtetes Gesichtsfoto – ohne Brille – ermöglicht uns die genaueste Anprobe.",
    "A clear, well-lit face photo gives the most accurate eyewear try-on.": "Ein klares, gut beleuchtetes Gesichtsfoto ermöglicht die genaueste Brillenanprobe.",
    "A clear, well-lit face photo gives the most accurate fit for eyewear and headwear.": "Ein klares, gut ausgeleuchtetes Gesichtsfoto sorgt für die genaueste Passform von Brillen und Kopfbedeckungen.",
    "A tie tip should land at the middle of your belt buckle": "Eine Krawattenspitze sollte in der Mitte Ihrer Gürtelschnalle landen",
    "Active Profile": "Aktives Profil",
    "ACTIVE PROFILE": "AKTIVES PROFIL",
    "Add a name for this profile": "Fügen Sie einen Namen für dieses Profil hinzu",
    "ADD MEASUREMENTS & PHOTO": "MAßE UND FOTO HINZUFÜGEN",
    "Add them to cart.": "Fügen Sie sie dem Warenkorb hinzu.",
    "Add to Bag": "Zur Tasche hinzufügen",
    "Added to bag": "Zur Tasche hinzugefügt",
    "Adding...": "Hinzufügen...",
    "Age": "Alter",
    "Age verification": "Altersüberprüfung",
    "AGE VERIFICATION": "ALTERSVERIFIZIERUNG",
    "AI Fact": "KI-Fakt",
    "AI Powered": "KI-betrieben",
    "AI SCAN": "KI-SCAN",
    "All measurements in": "Alle Maße in",
    "almost done": "fast fertig",
    "Almost done": "Fast fertig",
    "Almost done — finalizing…": "Fast fertig – Finalisierung…",
    "Almost done — preparing your suggested size.": "Fast fertig – die vorgeschlagene Größe wird vorbereitet.",
    "Analyze": "Analysieren",
    "Analyze by photo": "Analysieren Sie anhand des Fotos",
    "ANALYZE MY SIZE": "ANALYSE MEINE GRÖSSE",
    "ANALYZING": "ANALYSIEREN",
    "ANALYZING BODY": "KÖRPERANALYSE",
    "ANALYZING BODY MAP": "ANALYSE DER KÖRPERKARTE",
    "Analyzing body proportions": "Körperproportionen analysieren",
    "Around the base of the neck.": "Um den Halsansatz herum.",
    "AVERAGE": "DURCHSCHNITT",
    "BACK": "ZURÜCK",
    "Back & Seat": "Rücken & Sitz",
    "BACK & SEAT": "RÜCKENLEHNE & SITZ",
    "Back to brands": "Zurück zu den Marken",
    "Back to product": "Zurück zum Produkt",
    "based on your measurements and the garment's tailoring chart.": "basierend auf Ihren Maßen und der Schnitttabelle des Kleidungsstücks.",
    "based on your selected brand size and foot length.": "basierend auf der von Ihnen ausgewählten Markengröße und Fußlänge.",
    "best match": "beste Übereinstimmung",
    "BEST MATCH": "BESTES SPIEL",
    "BODY MEASUREMENTS": "KÖRPERMAßE",
    "Body measurements calculated!": "Körpermaße berechnet!",
    "Bra": "BH",
    "BRA SIZE": "BH-GRÖSSE",
    "BROAD": "BREIT",
    "BUST": "Büste",
    "Calculate My Body Parts": "Berechnen Sie meine Körperteile",
    "CALCULATE MY FIT": "Berechnen Sie meine Passform",
    "CALCULATING": "RECHNEN",
    "calculating...": "berechnen...",
    "Calculating...": "Berechnen...",
    "CALIBRATING": "KALIBRIEREN",
    "Calibrating fabric drape against your body proportions": "Passt den Stofffall an Ihre Körperproportionen an",
    "CALIBRATING SCALE": "KALIBRIERWAAGE",
    "Cancel": "Abbrechen",
    "Cancel Generation": "Generierung abbrechen",
    "centimeters": "Zentimeter",
    "Change": "Veränderung",
    "Checklist for accuracy": "Checkliste für Genauigkeit",
    "CHEST": "BRUST",
    "CHEST PROFILE": "BRUSTPROFIL",
    "Choose a method": "Wählen Sie eine Methode",
    "Choose a plain background": "Wählen Sie einen einfachen Hintergrund",
    "Choose a plain, light background": "Wählen Sie einen schlichten, hellen Hintergrund",
    "Choose a saved profile or create a new one before finding your best fit.": "Wählen Sie ein gespeichertes Profil oder erstellen Sie ein neues, bevor Sie Ihr bestes Profil finden.",
    "Choose another photo": "Wählen Sie ein anderes Foto",
    "Choose one account": "Wählen Sie ein Konto",
    "Choose size": "Wählen Sie die Größe",
    "Choose your shoe brand": "Wählen Sie Ihre Schuhmarke",
    "Choose your usual": "Wählen Sie Ihr Übliches",
    "Circumference around the upper leg.": "Umfang um den Oberschenkel.",
    "Circumference at the fullest point.": "Umfang an der vollsten Stelle.",
    "Circumference at the natural waistline.": "Umfang an der natürlichen Taille.",
    "Clear All": "Alles löschen",
    "Click or drag a close-up face photo": "Klicken oder ziehen Sie ein Nahaufnahme-Gesichtsfoto",
    "Click or drag a front face photo": "Klicken oder ziehen Sie ein Foto von der Vorderseite",
    "Click or drag a head-and-shoulders photo": "Klicken oder ziehen Sie ein Kopf-Schultern-Foto",
    "Click to change photo": "Klicken Sie, um das Foto zu ändern",
    "CM": "CM",
    "Comparing your circumference to the size chart.": "Vergleichen Sie Ihren Umfang mit der Größentabelle.",
    "Comparing your measurements to the garment's size guide.": "Vergleichen Sie Ihre Maße mit der Größentabelle des Kleidungsstücks.",
    "Comparing your measurements to the size chart.": "Vergleichen Sie Ihre Maße mit der Größentabelle.",
    "Comparing your measurements to the size guide.": "Vergleichen Sie Ihre Maße mit der Größentabelle.",
    "Complete the look": "Vervollständigen Sie den Look",
    "Computing chest, waist, hips, sleeve and inseam from your basics.": "Berechnen Sie Brust, Taille, Hüfte, Ärmel und Schrittlänge anhand Ihrer Grundlagen.",
    "Confirm your measurements": "Bestätigen Sie Ihre Messungen",
    "Continue Shopping": "Weiter einkaufen",
    "Could not load your saved profiles.": "Ihre gespeicherten Profile konnten nicht geladen werden.",
    "Couldn't send. Try again.": "Konnte nicht gesendet werden. Versuchen Sie es erneut.",
    "Country": "Land",
    "Crafted with quality materials for everyday comfort": "Hergestellt aus hochwertigen Materialien für alltäglichen Komfort",
    "Create New Profile": "Neues Profil erstellen",
    "Create Profile": "Profil erstellen",
    "Create your first fit profile to save your measurements, photo, and size history.": "Erstellen Sie Ihr erstes Passformprofil, um Ihre Maße, Fotos und den Größenverlauf zu speichern.",
    "Create your fit profile once.": "Erstellen Sie einmalig Ihr Passformprofil.",
    "Cross-checking fit against millions of garment patterns": "Gegenprüfung der Passform anhand von Millionen von Kleidungsstückmustern",
    "Cuff a pocket square so it peeks 1–2 cm above the pocket": "Manschetten Sie ein Einstecktuch so, dass es 1–2 cm über die Tasche hinausragt",
    "Cuff once for a relaxed everyday feel": "Für ein entspanntes Alltagsgefühl einmal anlegen",
    "Cufflinks should sit half an inch past the jacket sleeve": "Manschettenknöpfe sollten einen halben Zoll über den Jackenärmel hinausragen",
    "CURVED": "GEBOGEN",
    "Decrease": "Abnahme",
    "DEEP": "TIEF",
    "DEFAULT PROFILE": "STANDARDPROFIL",
    "Delete": "Löschen",
    "Delete this profile?": "Dieses Profil löschen?",
    "Describe your mid-section silhouette": "Beschreiben Sie Ihre Silhouette im Mittelteil",
    "DETAIL": "DETAIL",
    "Detecting body pose": "Körperhaltung erkennen",
    "Detecting face": "Gesicht erkennen",
    "DETECTING FACE": "GESICHT ERKENNEN",
    "Detecting head": "Kopf erkennen",
    "DETECTING HEAD": "ERKENNUNG DES KOPFES",
    "DETECTING POSE": "Pose erkennen",
    "Detecting pose landmarks…": "Erkennen von Pose-Orientierungspunkten…",
    "Display size in country": "Anzeigegröße im Land",
    "Distance over the nose between lenses": "Abstand über der Nase zwischen den Linsen",
    "Don't apply filters or edits": "Wenden Sie keine Filter oder Bearbeitungen an",
    "Don't apply filters or heavy edits": "Wenden Sie keine Filter oder umfangreichen Bearbeitungen an",
    "Don't cover your ears, eyes, or forehead": "Bedecken Sie nicht Ihre Ohren, Augen oder Stirn",
    "Don't crop out the top of your head": "Schneiden Sie Ihren Oberkopf nicht ab",
    "Don't crop out your ears or top of head": "Schneiden Sie weder Ihre Ohren noch Ihren Oberkopf ab",
    "Don't sit, pose, or bend": "Sitzen, posieren oder beugen Sie sich nicht",
    "Don't tilt or turn your head": "Kippen oder drehen Sie Ihren Kopf nicht",
    "Don't use filters, mirrored photos, or angled selfies": "Verwenden Sie keine Filter, gespiegelte Fotos oder schräge Selfies",
    "Don't use heavy shadows or strong backlighting": "Verwenden Sie keine starken Schatten oder starkes Gegenlicht",
    "Don't use strong backlighting or flash": "Verwenden Sie kein starkes Gegenlicht oder Blitz",
    "Don't wear a hat in the photo": "Tragen Sie auf dem Foto keinen Hut",
    "Don't wear loose or baggy clothing": "Tragen Sie keine weite oder weite Kleidung",
    "Don't wear sunglasses or a hat in the photo": "Tragen Sie auf dem Foto keine Sonnenbrille oder einen Hut",
    "Done": "Fertig",
    "e.g. 154": "z.B. 154",
    "e.g. 173": "z.B. 173",
    "e.g. 30": "z.B. 30",
    "e.g. 70": "z.B. 70",
    "e.g. My Measurements": "z.B. Meine Maße",
    "e.g. My Photo Profile": "z.B. Mein Fotoprofil",
    "Edit Profile": "Profil bearbeiten",
    "EDITORIAL LENGTH": "REDAKTIONELLE LÄNGE",
    "Ensure your full body is visible for the most accurate digital tailoring scan.": "Stellen Sie sicher, dass Ihr ganzer Körper sichtbar ist, um den genauesten digitalen Schnittscan zu ermöglichen.",
    "Ensure your full body is visible for the most accurate virtual try-on.": "Stellen Sie sicher, dass Ihr ganzer Körper für die genaueste virtuelle Anprobe sichtbar ist.",
    "Enter height, weight and answer quick body shape questions.": "Geben Sie Größe und Gewicht ein und beantworten Sie schnelle Fragen zur Körperform.",
    "Enter your details for a bespoke size suggestion": "Geben Sie Ihre Daten ein, um einen maßgeschneiderten Größenvorschlag zu erhalten",
    "Enter your details for accurate body estimation": "Geben Sie Ihre Daten ein, um eine genaue Körperschätzung zu erhalten",
    "Enter your measurements OR upload a photo — we'll use whichever you provide.": "Geben Sie Ihre Maße ein ODER laden Sie ein Foto hoch – wir verwenden das von Ihnen angegebene Maß.",
    "ENTERED": "EINGEGEBEN",
    "ESTIMATED": "GESCHÄTZT",
    "ESTIMATING BODY": "SCHÄTZUNGSKÖRPER",
    "Estimating head width and depth.": "Schätzung der Kopfbreite und -tiefe.",
    "Estimating your measurements...": "Schätzen Sie Ihre Maße...",
    "Estimation could not complete": "Die Schätzung konnte nicht abgeschlossen werden",
    "Face the camera directly at eye level": "Richten Sie sich direkt auf Augenhöhe in die Kamera",
    "Face the camera directly, centered in frame": "Blicken Sie direkt in die Kamera, zentriert im Bild",
    "Face the camera with head and shoulders in frame": "Schauen Sie mit Kopf und Schultern in die Kamera",
    "Face the camera with your head and shoulders in frame, leaving space above your head.": "Richten Sie Ihren Kopf und Ihre Schultern im Bild in die Kamera und lassen Sie über Ihrem Kopf Platz.",
    "Failed to process image": "Bild konnte nicht verarbeitet werden",
    "Female": "Weiblich",
    "FINALIZING": "ABSCHLIESSEN",
    "FINALIZING RESULT": "ENDGÜLTIGES ERGEBNIS",
    "FIT": "FIT",
    "Fit reference": "Referenz anpassen",
    "Fit Result": "Anpassungsergebnis",
    "Fit Terms": "Passende Begriffe",
    "Flat": "Flach",
    "FLAT": "FLACH",
    "FOOT": "FUSS",
    "Foot length unit": "Fußlängeneinheit",
    "For your safety, we cannot process photos of people under 18.": "Zu Ihrer Sicherheit können wir keine Fotos von Personen unter 18 Jahren verarbeiten.",
    "Frame Measurements": "Rahmenmaße",
    "Full": "Voll",
    "FULL": "VOLL",
    "Full circumference at the widest point.": "Voller Umfang an der breitesten Stelle.",
    "Full Size": "Volle Größe",
    "Full Size Chart": "Vollständige Größentabelle",
    "Garment Spec": "Bekleidungsspezif",
    "Garment Spotlight": "Kleidungsstück im Rampenlicht",
    "Gender": "Geschlecht",
    "GENDER": "GESCHLECHT",
    "Generating try-on…": "Anprobe generieren…",
    "Generating Your Look": "Generieren Sie Ihren Look",
    "Generating your look...": "Generieren Sie Ihren Look...",
    "Generating your suggested size...": "Generieren Sie Ihre vorgeschlagene Größe...",
    "Go back": "Geh zurück",
    "Good lighting, plain background": "Gute Beleuchtung, schlichter Hintergrund",
    "Head and shoulders in frame": "Kopf und Schultern im Rahmen",
    "Headwear Measurements": "Kopfbedeckungsmessungen",
    "Helps us refine bust measurements for tops and dresses": "Hilft uns, die Brustmaße für Oberteile und Kleider zu verfeinern",
    "Here's what we estimated": "Hier ist, was wir geschätzt haben",
    "Hide Fit": "Passform ausblenden",
    "HIP PROFILE": "HÜFTPROFIL",
    "HIPS": "HÜFTEN",
    "Hips closer to shoulder width": "Hüfte näher an Schulterbreite",
    "Hips proportionate to shoulders": "Hüften proportional zu den Schultern",
    "Hips wider than shoulders": "Hüften breiter als Schultern",
    "Hold the camera at eye level": "Halten Sie die Kamera auf Augenhöhe",
    "Hold the phone at WAIST height (not eye level)": "Halten Sie das Telefon auf Hüfthöhe (nicht auf Augenhöhe).",
    "How to Measure": "So messen Sie",
    "Identifying 478 face landmarks in your photo.": "Identifizieren Sie 478 Gesichtspunkte auf Ihrem Foto.",
    "Identifying body landmarks from your photo.": "Identifizieren Sie Körperorientierungspunkte anhand Ihres Fotos.",
    "Identifying face landmarks in your photo.": "Identifizieren Sie Gesichtsorientierungspunkte auf Ihrem Foto.",
    "Identity": "Identität",
    "Increase": "Erhöhen",
    "Inner leg seam length.": "Länge der inneren Beinnaht.",
    "INSEAM": "Innennaht",
    "Is the person in this photo 18 years or older?": "Ist die Person auf diesem Foto 18 Jahre oder älter?",
    "JPEG, PNG (max 10MB)": "JPEG, PNG (max. 10 MB)",
    "JPEG, PNG up to 10MB": "JPEG, PNG bis zu 10 MB",
    "JPEG, PNG up to 10MB · click or drop": "JPEG, PNG bis zu 10 MB · Klicken oder Ablegen",
    "JPEG, PNG, WebP, AVIF (max 10MB)": "JPEG, PNG, WebP, AVIF (max. 10 MB)",
    "Keep hair away from face and ears": "Halten Sie Haare von Gesicht und Ohren fern",
    "Keep hair away from your face and ears": "Halten Sie Haare von Ihrem Gesicht und Ihren Ohren fern",
    "Keep your full face, ears, and head visible": "Halten Sie Ihr gesamtes Gesicht, Ihre Ohren und Ihren Kopf sichtbar",
    "LAST UPDATE": "LETZTES UPDATE",
    "Layer with a fitted base for sharper silhouette": "Für eine schärfere Silhouette mit einer passenden Basis schichten",
    "Leave some space above your head": "Lassen Sie etwas Platz über Ihrem Kopf",
    "Leave space above your head": "Lassen Sie Platz über Ihrem Kopf",
    "Leave the bottom button of a suit jacket undone": "Lassen Sie den unteren Knopf einer Anzugjacke offen",
    "left": "links",
    "LEGAL NOTICE": "RECHTLICHER HINWEIS",
    "LENGTH ADJUSTMENT": "LÄNGENVERSTELLUNG",
    "Length of the arm from hinge to tip": "Länge des Arms vom Scharnier bis zur Spitze",
    "Loading your fit profile": "Laden Sie Ihr Passformprofil",
    "Loading your saved measurements and body shape answers.": "Laden Ihrer gespeicherten Maße und Antworten zur Körperform.",
    "long": "lang",
    "LOOSE": "Locker",
    "Male": "Männlich",
    "MANUAL FIT": "MANUELLE ANPASSUNG",
    "MAPPING": "KARTIERUNG",
    "Mapping body landmarks…": "Kartierung von Körperorientierungspunkten…",
    "Mapping bridge, frame width and temple fit.": "Zuordnung von Steg, Rahmenbreite und Bügelpassform.",
    "Mapping bridge, lens width and temple length.": "Zuordnung von Steg, Brillenglasbreite und Bügellänge.",
    "MAPPING CIRCUMFERENCE": "KARTIERUNG DES UMFANGS",
    "Mapping garment to body": "Kleidungsstück dem Körper zuordnen",
    "Match your belt to your shoes — never your pants": "Passen Sie Ihren Gürtel an Ihre Schuhe an – niemals an Ihre Hose",
    "MATCHING FRAME SIZE": "PASSENDE RAHMENGRÖSSE",
    "MATCHING HAT SIZE": "PASSENDE HUTGRÖSSE",
    "MATCHING SIZE": "PASSENDE GRÖSSE",
    "Measure around your wrist where the bracelet or watch sits": "Messen Sie den Umfang Ihres Handgelenks, wo das Armband oder die Uhr sitzt",
    "Measure from heel to longest toe": "Messen Sie von der Ferse bis zum längsten Zeh",
    "Measure manually": "Manuell messen",
    "Measurement": "Messung",
    "MEASUREMENT BLUEPRINT": "MESSPLAN",
    "Measurement Guide": "Messanleitung",
    "MEASURING": "MESSEN",
    "MEASURING FRAME": "MESSRAHMEN",
    "Measuring shoulders, chest, waist and hips.": "Messung von Schultern, Brust, Taille und Hüfte.",
    "MEN'S FIT": "HERREN-PASSFORM",
    "Menu": "Menü",
    "mm": "mm",
    "My Sizing Profiles": "Meine Größenprofile",
    "NAME": "NAME",
    "NARROW": "SCHMAL",
    "NECK": "HALS",
    "Neutral background with good lighting": "Neutraler Hintergrund mit guter Beleuchtung",
    "New Profile": "Neues Profil",
    "No fit": "Keine Passform",
    "No matching size": "Keine passende Größe",
    "NO MATCHING SIZE": "KEINE PASSENDE GRÖSSE",
    "No matching size available": "Keine passende Größe verfügbar",
    "No password needed. After sign in, you will continue to the normal profile setup.": "Kein Passwort erforderlich. Nach der Anmeldung fahren Sie mit der normalen Profileinrichtung fort.",
    "No size chart available": "Keine Größentabelle verfügbar",
    "No size matches your measurements": "Keine Größe entspricht Ihren Maßen",
    "No sizes match the selected options.": "Keine Größe entspricht den ausgewählten Optionen.",
    "Not Suggested": "Nicht empfohlen",
    "One Size": "Einheitsgröße",
    "Opening...": "Eröffnung...",
    "Optional note": "Optionaler Hinweis",
    "or": "oder",
    "Or upload front face": "Oder laden Sie die Vorderseite hoch",
    "Our AI is mapping your proportions for a size suggestion.": "Unsere KI kartiert Ihre Proportionen für einen Größenvorschlag.",
    "Our AI is mapping your proportions.": "Unsere KI kartiert Ihre Proportionen.",
    "Our AI is precisely mapping the garment to your unique proportions.": "Unsere KI ordnet das Kleidungsstück genau Ihren individuellen Proportionen zu.",
    "Our AI works best with front-facing, full-body photos in fitted clothing. Better photos = more accurate virtual try-on!": "Unsere KI funktioniert am besten mit nach vorne gerichteten Ganzkörperfotos in taillierter Kleidung. Bessere Fotos = genauere virtuelle Anprobe!",
    "Our model is analyzing 150+ body landmarks for your size suggestion": "Unser Modell analysiert mehr als 150 Körperorientierungspunkte für Ihren Größenvorschlag",
    "Pair this with neutral tones for a balanced look": "Kombinieren Sie dies mit neutralen Tönen für einen ausgewogenen Look",
    "Pick a brand you know well. We'll use that size as your fit reference.": "Wählen Sie eine Marke, die Sie gut kennen. Wir verwenden diese Größe als Referenz für Ihre Passform.",
    "Please enter a profile name": "Bitte geben Sie einen Profilnamen ein",
    "Please enter a valid age": "Bitte geben Sie ein gültiges Alter ein",
    "Please enter your ": "Bitte geben Sie Ihre ein",
    "Please fill in all fields": "Bitte füllen Sie alle Felder aus",
    "Please pick an option": "Bitte wählen Sie eine Option aus",
    "Please pick band and cup size": "Bitte wählen Sie Band- und Körbchengröße aus",
    "Please select your bra band and cup size": "Bitte wählen Sie Ihr BH-Band und Ihre Körbchengröße aus",
    "Please select your usual shoe brand and size": "Bitte wählen Sie Ihre übliche Schuhmarke und Größe aus",
    "Please try again or use manual measurements": "Bitte versuchen Sie es erneut oder verwenden Sie manuelle Messungen",
    "Please try again or use manual measurements.": "Bitte versuchen Sie es erneut oder verwenden Sie manuelle Messungen.",
    "Please upload a photo first.": "Bitte laden Sie zuerst ein Foto hoch.",
    "Preparing your image": "Bereiten Sie Ihr Bild vor",
    "Preparing your image…": "Bereiten Sie Ihr Bild vor…",
    "PrimeStyleAI": "PrimeStyleAI",
    "PrimeStyleAI profile": "PrimeStyleAI-Profil",
    "PrimeStyleAI profile benefits": "Vorteile des PrimeStyleAI-Profils",
    "Pro Tip": "Profi-Tipp",
    "Proceed": "Fahren Sie fort",
    "Processing...": "Verarbeitung...",
    "Product photos": "Produktfotos",
    "Profile": "Profil",
    "PROFILE": "PROFIL",
    "Profile details": "Profildetails",
    "Profile Name": "Profilname",
    "Profile photo is missing. Please add a photo and try again.": "Profilfoto fehlt. Bitte fügen Sie ein Foto hinzu und versuchen Sie es erneut.",
    "Profile sync failed. Your local changes are still saved here.": "Die Profilsynchronisierung ist fehlgeschlagen. Ihre lokalen Änderungen werden weiterhin hier gespeichert.",
    "Profile welcome": "Profil willkommen",
    "Quick Setup": "Schnelle Einrichtung",
    "Rate try-on": "Anprobe bewerten",
    "Rate your try-on": "Bewerten Sie Ihre Anprobe",
    "Rating": "Bewertung",
    "Reading head landmarks from your photo.": "Lesen Sie die Orientierungspunkte Ihres Kopfes auf Ihrem Foto ab.",
    "READING PROFILE": "LESEPROFIL",
    "READING YOUR PROFILE": "LESEN SIE IHR PROFIL",
    "Refining drape and shadows": "Verfeinerung von Falten und Schatten",
    "Refining drape and shadows…": "Faltenwurf und Schatten verfeinern …",
    "Remove any glasses you're wearing": "Nehmen Sie die Brille ab, die Sie tragen",
    "Remove photo": "Foto entfernen",
    "Rendering shadows and highlights to match your photo's lighting": "Rendern Sie Schatten und Lichter passend zur Beleuchtung Ihres Fotos",
    "Rendering the garment…": "Das Kleidungsstück rendern…",
    "RETAKE PHOTO": "Foto noch einmal aufnehmen",
    "Reuse these measurements on future products.": "Verwenden Sie diese Messungen für zukünftige Produkte wieder.",
    "Review before continuing.": "Überprüfen Sie die Informationen, bevor Sie fortfahren.",
    "Review your measurements below — you can edit them later": "Überprüfen Sie unten Ihre Messungen – Sie können sie später bearbeiten",
    "Review your photo": "Überprüfen Sie Ihr Foto",
    "Roll sleeves twice for a relaxed, intentional finish": "Für einen entspannten, bewussten Abschluss die Ärmel zweimal hochkrempeln",
    "ROUND": "RUND",
    "SAVE": "SPEICHERN",
    "Save Changes": "Änderungen speichern",
    "Save Profile": "Profil speichern",
    "Save your fit profile": "Speichern Sie Ihr Passformprofil",
    "SCANNING FRAME": "SCAN-RAHMEN",
    "SDK not configured. Please refresh and try again.": "SDK nicht konfiguriert. Bitte aktualisieren Sie und versuchen Sie es erneut.",
    "Securely reuse your measurements and photo across PrimeStyleAI experiences and partner stores.": "Verwenden Sie Ihre Maße und Fotos sicher in allen PrimeStyleAI-Erlebnissen und Partnergeschäften wieder.",
    "See how it looks on yourself": "Sehen Sie selbst, wie es aussieht",
    "Select": "Auswählen",
    "SELECT": "AUSWÄHLEN",
    "Select a size to add to cart": "Wählen Sie eine Größe aus, die Sie dem Warenkorb hinzufügen möchten",
    "SELECT A SIZE TO ADD TO CART": "WÄHLEN SIE EINE GRÖSSE AUS, UM SIE IN DEN WARENKORB HINZUFÜGEN",
    "Select bra band and cup": "BH-Band und Körbchen auswählen",
    "Select the profile that best matches your chest breadth": "Wählen Sie das Profil, das am besten zu Ihrer Brustweite passt",
    "SELECTED": "AUSGEWÄHLT",
    "Selected brand": "Ausgewählte Marke",
    "Send": "Senden",
    "Send feedback": "Feedback senden",
    "Sending": "Senden",
    "Sent": "Gesendet",
    "Set height": "Höhe einstellen",
    "Set weight": "Gewicht einstellen",
    "Shoe brand": "Schuhmarke",
    "Shoe size": "Schuhgröße",
    "Shoe Size": "Schuhgröße",
    "short": "kurz",
    "SHOULDER": "SCHULTER",
    "Shoulder edge to shoulder edge.": "Schulterkante an Schulterkante.",
    "Shoulder seam to cuff edge.": "Schulternaht bis Manschettenkante.",
    "Show Fit": "Fit anzeigen",
    "Sign in": "Melden Sie sich an",
    "Sign out": "Abmelden",
    "size": "Größe",
    "SIZE": "GRÖSSE",
    "Size Guide": "Größentabelle",
    "SIZE GUIDE": "GRÖSSENTABELLE",
    "Sizing Profile": "Größenprofil",
    "SLEEVE": "ÄRMEL",
    "SLIGHT EASE": "LEICHTE EINFACHHEIT",
    "SLIGHTLY TIGHT": "ETWAS ENG",
    "Continue with Google": "Mit Google fortfahren",
    "Continue with Apple": "Mit Apple fortfahren",
    "Continue with LinkedIn": "Mit LinkedIn fortfahren",
    "Social login failed.": "Social-Login ist fehlgeschlagen.",
    "Social login failed. Please try again.": "Social-Login ist fehlgeschlagen. Bitte versuchen Sie es erneut.",
    "Social login must run in the browser.": "Der Social-Login muss im Browser ausgeführt werden.",
    "Popup was blocked. Please allow popups and try again.": "Das Popup wurde blockiert. Erlauben Sie Popups und versuchen Sie es erneut.",
    "Login did not finish. Please close the sign-in window and try again.": "Die Anmeldung wurde nicht abgeschlossen. Schließen Sie das Anmeldefenster und versuchen Sie es erneut.",
    "Social sign in": "Soziale Anmeldung",
    "Stand straight and still, arms relaxed": "Stehen Sie gerade und ruhig, die Arme entspannt",
    "Standard": "Standard",
    "Standing 2-3 meters from camera": "Stehen Sie 2-3 Meter von der Kamera entfernt",
    "stars": "Sterne",
    "Start Fresh": "Fangen Sie neu an",
    "Start Try-On": "Starten Sie die Anprobe",
    "START TRY-ON": "Beginnen Sie mit der Anprobe",
    "STEP": "SCHRITT",
    "Step 01": "Schritt 01",
    "Step 02": "Schritt 02",
    "Stomach": "Magen",
    "STOMACH PROFILE": "MAGENPROFIL",
    "STRAIGHT": "GERADE",
    "Style Tip": "Style-Tipp",
    "suggested": "vorgeschlagen",
    "SUGGESTED": "EMPFOHLEN",
    "Suggested Size": "Empfohlene Größe",
    "Tap any section for detailed breakdown": "Tippen Sie auf einen beliebigen Abschnitt, um eine detaillierte Aufschlüsselung zu erhalten",
    "Tap any value to adjust if needed": "Tippen Sie auf einen beliebigen Wert, um ihn bei Bedarf anzupassen",
    "Tap the card for detailed breakdown": "Tippen Sie auf die Karte, um eine detaillierte Aufschlüsselung zu erhalten",
    "Tap to upload": "Zum Hochladen antippen",
    "The curvature of your hips and thighs": "Die Krümmung Ihrer Hüften und Oberschenkel",
    "The curvature of your lower spine and seat profile": "Die Krümmung Ihrer unteren Wirbelsäule und Ihres Sitzprofils",
    "The merchant hasn't uploaded sizing data for this product yet. You can still see how it looks on you with a virtual try-on.": "Der Händler hat noch keine Größendaten für dieses Produkt hochgeladen. Bei einer virtuellen Anprobe können Sie noch sehen, wie es Ihnen steht.",
    "THIGH": "Oberschenkel",
    "This cannot be undone.": "Dies kann nicht rückgängig gemacht werden.",
    "This product's size chart doesn't carry a fit close enough to your body. Try another product or update your profile.": "Die Größentabelle dieses Produkts passt nicht eng genug an Ihren Körper. Probieren Sie ein anderes Produkt aus oder aktualisieren Sie Ihr Profil.",
    "This product's size chart doesn't include a reliable fit for your measurements.": "Die Größentabelle dieses Produkts gibt keine verlässliche Passform für Ihre Maße an.",
    "TIGHT": "ENG",
    "Top to bottom length.": "Länge von oben nach unten.",
    "TRY ANOTHER SIZE": "PROBIEREN SIE EINE ANDERE GRÖSSE",
    "Try-on failed": "Anprobe fehlgeschlagen",
    "Unable to connect to sizing service. Please try again.": "Es konnte keine Verbindung zum Größenbestimmungsdienst hergestellt werden. Bitte versuchen Sie es erneut.",
    "Unable to connect to sizing service. Please try manual measurements.": "Es konnte keine Verbindung zum Größenbestimmungsdienst hergestellt werden. Bitte versuchen Sie es mit manuellen Messungen.",
    "Unable to get a size suggestion. Please try again.": "Es kann kein Größenvorschlag erhalten werden. Bitte versuchen Sie es erneut.",
    "Unable to get a size suggestion. Please try manual measurements.": "Es kann kein Größenvorschlag erhalten werden. Bitte versuchen Sie es mit manuellen Messungen.",
    "Unit": "Einheit",
    "Upload a full-body photo. Our AI computes every measurement.": "Laden Sie ein Ganzkörperfoto hoch. Unsere KI berechnet jede Messung.",
    "Upload a photo for AI sizing": "Laden Sie ein Foto zur AI-Größenbestimmung hoch",
    "Upload front face": "Vorderseite hochladen",
    "UPLOAD NOT ALLOWED": "Hochladen nicht erlaubt",
    "Use a front-facing photo with your face and head clearly visible.": "Verwenden Sie ein nach vorne gerichtetes Foto, auf dem Gesicht und Kopf deutlich sichtbar sind.",
    "Use bright, even lighting and a plain background": "Verwenden Sie eine helle, gleichmäßige Beleuchtung und einen schlichten Hintergrund",
    "Use natural or even lighting": "Verwenden Sie natürliches oder gleichmäßiges Licht",
    "Use natural, even lighting": "Verwenden Sie natürliches, gleichmäßiges Licht",
    "Use natural, even lighting (e.g. near a window)": "Nutzen Sie natürliches, gleichmäßiges Licht (z. B. in der Nähe eines Fensters)",
    "USE THIS PROFILE": "NUTZEN SIE DIESES PROFIL",
    "Used to calibrate the AI from your photo.": "Wird verwendet, um die KI anhand Ihres Fotos zu kalibrieren.",
    "USER": "BENUTZER",
    "Using iris size as the pixel-to-mm anchor.": "Verwendung der Irisgröße als Pixel-zu-mm-Anker.",
    "Using saved measurements for this fit.": "Für diese Passform werden gespeicherte Maße verwendet.",
    "VIEW CHART": "Diagramm ansehen",
    "VIEW DETAILS": "DETAILS ANZEIGEN",
    "WAIST": "TAILLE",
    "We couldn't find a size that fits for this product.": "Wir konnten keine passende Größe für dieses Produkt finden.",
    "We noticed your entered details didn't match your photo. To give you accurate sizing, we measured your body directly from the photo.": "Wir haben festgestellt, dass Ihre eingegebenen Daten nicht mit Ihrem Foto übereinstimmen. Um Ihnen eine genaue Größenbestimmung zu ermöglichen, haben wir Ihren Körper direkt anhand des Fotos gemessen.",
    "Wear fitted, simple clothing": "Tragen Sie figurbetonte, schlichte Kleidung",
    "Welcome": "Willkommen",
    "What is my size?": "Was ist meine Größe?",
    "Which shoe brand do you usually wear?": "Welche Schuhmarke trägst du normalerweise?",
    "WHILE YOU WAIT": "WÄHREND SIE WARTEN",
    "Width of one lens": "Breite einer Linse",
    "WITHIN RANGE": "IN REICHWEITE",
    "WOMEN'S FIT": "FRAUENPASSFORM",
    "Wrap a tape around the widest part of your head": "Wickeln Sie ein Klebeband um die breiteste Stelle Ihres Kopfes",
    "Wrist Circumference": "Handgelenkumfang",
    "Wrist Measurements": "Handgelenksmessungen",
    "YEARS": "JAHRE",
    "You chose": "Du hast gewählt",
    "Your Body": "Dein Körper",
    "Your Choice · Not Suggested": "Ihre Wahl · Nicht empfohlen",
    "YOUR CHOICE · NOT SUGGESTED": "IHRE WAHL · NICHT EMPFOHLEN",
    "Your Details": "Ihre Daten",
    "Your Fit": "Deine Passform",
    "Your measurements": "Ihre Maße",
    "Your profile is private to your PrimeStyleAI account and can be updated anytime.": "Ihr Profil ist privat für Ihr PrimeStyleAI-Konto und kann jederzeit aktualisiert werden.",
    "Your profiles": "Ihre Profile",
    "Your Selection": "Ihre Auswahl",
    "YOUR SELECTION": "IHRE AUSWAHL",
    "your selection · not suggested": "Ihre Auswahl · nicht vorgeschlagen",
    "Your size": "Deine Größe",
    "Your size is": "Deine Größe ist",
    "Your try-on history": "Ihre Anprobehistorie",
  },
  "it": {
    "*Our sizing engine recommends": "*Our sizing engine recommends",
    "✓ Pose detected — running body analysis": "✓ Posa rilevata: analisi del corpo in corso",
    "A clean close-up improves landmark detection for eyewear and headwear.": "Un primo piano pulito migliora il rilevamento dei punti di riferimento per occhiali e copricapi.",
    "A clear head-and-shoulders photo with space above your head gives the most accurate headwear try-on.": "Una foto chiara di testa e spalle con spazio sopra la testa offre la prova più accurata del copricapo.",
    "A clear, front-facing face photo — no glasses on — gives us the most accurate try-on.": "Una foto chiara del viso frontale, senza occhiali, ci offre la prova più accurata.",
    "A clear, well-lit face photo gives the most accurate eyewear try-on.": "Una foto del viso chiara e ben illuminata consente la prova degli occhiali più accurata.",
    "A clear, well-lit face photo gives the most accurate fit for eyewear and headwear.": "Una foto del viso chiara e ben illuminata offre la vestibilità più precisa per occhiali e copricapo.",
    "A tie tip should land at the middle of your belt buckle": "La punta della cravatta dovrebbe arrivare al centro della fibbia della cintura",
    "Active Profile": "Active Profile",
    "ACTIVE PROFILE": "ACTIVE PROFILE",
    "Add a name for this profile": "Aggiungi un nome per questo profilo",
    "ADD MEASUREMENTS & PHOTO": "AGGIUNGI MISURE E FOTO",
    "Add them to cart.": "Aggiungili al carrello.",
    "Add to Bag": "Aggiungi al carrello",
    "Added to bag": "Aggiunto al carrello",
    "Adding...": "Aggiunta...",
    "Age": "Età",
    "Age verification": "Verifica dell'età",
    "AGE VERIFICATION": "VERIFICA DELL'ETÀ",
    "AI Fact": "Fatto dell'IA",
    "AI Powered": "Alimentato dall'intelligenza artificiale",
    "AI SCAN": "SCANSIONE AI",
    "All measurements in": "Tutte le misurazioni in",
    "almost done": "quasi finito",
    "Almost done": "Quasi finito",
    "Almost done — finalizing…": "Quasi finito: finalizzazione...",
    "Almost done — preparing your suggested size.": "Quasi finito: preparo la taglia suggerita.",
    "Analyze": "Analizzare",
    "Analyze by photo": "Analizzare per foto",
    "ANALYZE MY SIZE": "ANALIZZA LA MIA TAGLIA",
    "ANALYZING": "ANALIZZANDO",
    "ANALYZING BODY": "CORPO ANALIZZATO",
    "ANALYZING BODY MAP": "ANALIZZARE LA MAPPA CORPOREA",
    "Analyzing body proportions": "Analisi delle proporzioni del corpo",
    "Around the base of the neck.": "Intorno alla base del collo.",
    "AVERAGE": "MEDIA",
    "BACK": "INDIETRO",
    "Back & Seat": "Schienale e sedile",
    "BACK & SEAT": "SCHIENALE E SEDILE",
    "Back to brands": "Torniamo ai marchi",
    "Back to product": "Torna al prodotto",
    "based on your measurements and the garment's tailoring chart.": "in base alle tue misure e alla tabella sartoriale del capo.",
    "based on your selected brand size and foot length.": "in base alla taglia del marchio selezionato e alla lunghezza del piede.",
    "best match": "migliore corrispondenza",
    "BEST MATCH": "MIGLIOR PARTITA",
    "BODY MEASUREMENTS": "MISURE DEL CORPO",
    "Body measurements calculated!": "Misure del corpo calcolate!",
    "Bra": "Reggiseno",
    "BRA SIZE": "TAGLIA DEL REGGISENO",
    "BROAD": "AMPIO",
    "BUST": "BUSTO",
    "Calculate My Body Parts": "Calcola le parti del mio corpo",
    "CALCULATE MY FIT": "CALCOLA LA MIA VESTIBILITÀ",
    "CALCULATING": "CALCOLO",
    "calculating...": "calcolando...",
    "Calculating...": "Calcolo...",
    "CALIBRATING": "CALIBRAZIONE",
    "Calibrating fabric drape against your body proportions": "Calibrazione del drappeggio in tessuto rispetto alle proporzioni del corpo",
    "CALIBRATING SCALE": "SCALA DI CALIBRAZIONE",
    "Cancel": "Annulla",
    "Cancel Generation": "Annulla generazione",
    "centimeters": "centimetri",
    "Change": "Cambiare",
    "Checklist for accuracy": "Lista di controllo per l'accuratezza",
    "CHEST": "PETTO",
    "CHEST PROFILE": "PROFILO DEL PETTO",
    "Choose a method": "Scegli un metodo",
    "Choose a plain background": "Scegli uno sfondo semplice",
    "Choose a plain, light background": "Scegli uno sfondo semplice e chiaro",
    "Choose a saved profile or create a new one before finding your best fit.": "Scegli un profilo salvato o creane uno nuovo prima di trovare la soluzione migliore.",
    "Choose another photo": "Scegli un'altra foto",
    "Choose one account": "Scegli un account",
    "Choose size": "Scegli la taglia",
    "Choose your shoe brand": "Scegli la marca delle tue scarpe",
    "Choose your usual": "Scegli il tuo solito",
    "Circumference around the upper leg.": "Circonferenza attorno alla parte superiore della gamba.",
    "Circumference at the fullest point.": "Circonferenza nel punto più pieno.",
    "Circumference at the natural waistline.": "Circonferenza al punto vita naturale.",
    "Clear All": "Cancella tutto",
    "Click or drag a close-up face photo": "Fai clic o trascina la foto di un volto in primo piano",
    "Click or drag a front face photo": "Fare clic o trascinare una foto del volto anteriore",
    "Click or drag a head-and-shoulders photo": "Fare clic o trascinare una foto testa e spalle",
    "Click to change photo": "Fare clic per cambiare foto",
    "CM": "CM",
    "Comparing your circumference to the size chart.": "Confrontando la tua circonferenza con la tabella delle taglie.",
    "Comparing your measurements to the garment's size guide.": "Confrontando le tue misure con la guida alle taglie del capo.",
    "Comparing your measurements to the size chart.": "Confrontando le tue misure con la tabella delle taglie.",
    "Comparing your measurements to the size guide.": "Confrontando le tue misure con la guida alle taglie.",
    "Complete the look": "Completa il look",
    "Computing chest, waist, hips, sleeve and inseam from your basics.": "Calcola il petto, la vita, i fianchi, le maniche e la cucitura interna partendo dalle tue basi.",
    "Confirm your measurements": "Conferma le tue misurazioni",
    "Continue Shopping": "Continua a fare acquisti",
    "Could not load your saved profiles.": "Impossibile caricare i profili salvati.",
    "Couldn't send. Try again.": "Impossibile inviare. Riprova.",
    "Country": "Paese",
    "Crafted with quality materials for everyday comfort": "Realizzato con materiali di qualità per il comfort quotidiano",
    "Create New Profile": "Crea nuovo profilo",
    "Create Profile": "Crea profilo",
    "Create your first fit profile to save your measurements, photo, and size history.": "Crea il tuo primo profilo di vestibilità per salvare misurazioni, foto e cronologia delle taglie.",
    "Create your fit profile once.": "Crea il tuo profilo di forma una volta.",
    "Cross-checking fit against millions of garment patterns": "Controllo incrociato della vestibilità rispetto a milioni di modelli di indumenti",
    "Cuff a pocket square so it peeks 1–2 cm above the pocket": "Rifinisci un fazzoletto da taschino in modo che sporga 1–2 cm sopra la tasca",
    "Cuff once for a relaxed everyday feel": "Polsino una volta per una sensazione rilassata di tutti i giorni",
    "Cufflinks should sit half an inch past the jacket sleeve": "I gemelli dovrebbero trovarsi mezzo pollice oltre la manica della giacca",
    "CURVED": "CURVO",
    "Decrease": "Diminuire",
    "DEEP": "PROFONDO",
    "DEFAULT PROFILE": "PROFILO PREDEFINITO",
    "Delete": "Elimina",
    "Delete this profile?": "Eliminare questo profilo?",
    "Describe your mid-section silhouette": "Descrivi la tua silhouette a metà sezione",
    "DETAIL": "DETTAGLIO",
    "Detecting body pose": "Rilevamento della posa del corpo",
    "Detecting face": "Rilevamento del volto",
    "DETECTING FACE": "RILEVAMENTO DEL VOLTO",
    "Detecting head": "Testa di rilevamento",
    "DETECTING HEAD": "TESTA DI RILEVAMENTO",
    "DETECTING POSE": "RILEVAMENTO DELLA POSA",
    "Detecting pose landmarks…": "Rilevamento dei punti di riferimento della posa…",
    "Display size in country": "Visualizza le dimensioni nel paese",
    "Distance over the nose between lenses": "Distanza sopra il naso tra le lenti",
    "Don't apply filters or edits": "Non applicare filtri o modifiche",
    "Don't apply filters or heavy edits": "Non applicare filtri o modifiche pesanti",
    "Don't cover your ears, eyes, or forehead": "Non coprire le orecchie, gli occhi o la fronte",
    "Don't crop out the top of your head": "Non ritagliare la parte superiore della testa",
    "Don't crop out your ears or top of head": "Non tagliare le orecchie o la parte superiore della testa",
    "Don't sit, pose, or bend": "Non sederti, metterti in posa o piegarti",
    "Don't tilt or turn your head": "Non inclinare o girare la testa",
    "Don't use filters, mirrored photos, or angled selfies": "Non utilizzare filtri, foto specchiate o selfie angolati",
    "Don't use heavy shadows or strong backlighting": "Non utilizzare ombre pesanti o forti retroilluminazione",
    "Don't use strong backlighting or flash": "Non utilizzare una forte retroilluminazione o flash",
    "Don't wear a hat in the photo": "Non indossare un cappello nella foto",
    "Don't wear loose or baggy clothing": "Non indossare abiti larghi o larghi",
    "Don't wear sunglasses or a hat in the photo": "Non indossare occhiali da sole o cappelli nella foto",
    "Done": "Fatto",
    "e.g. 154": "ad es. 154",
    "e.g. 173": "ad es. 173",
    "e.g. 30": "ad es. 30",
    "e.g. 70": "ad es. 70",
    "e.g. My Measurements": "ad es. Le mie misure",
    "e.g. My Photo Profile": "per esempio. Il mio profilo fotografico",
    "Edit Profile": "Modifica profilo",
    "EDITORIAL LENGTH": "DURATA EDITORIALE",
    "Ensure your full body is visible for the most accurate digital tailoring scan.": "Assicurati che tutto il tuo corpo sia visibile per una scansione sartoriale digitale più accurata.",
    "Ensure your full body is visible for the most accurate virtual try-on.": "Assicurati che tutto il tuo corpo sia visibile per una prova virtuale più accurata.",
    "Enter height, weight and answer quick body shape questions.": "Inserisci altezza, peso e rispondi a domande rapide sulla forma del corpo.",
    "Enter your details for a bespoke size suggestion": "Inserisci i tuoi dati per un suggerimento sulla taglia personalizzata",
    "Enter your details for accurate body estimation": "Inserisci i tuoi dati per una stima corporea accurata",
    "Enter your measurements OR upload a photo — we'll use whichever you provide.": "Inserisci le tue misure OPPURE carica una foto: utilizzeremo quella fornita.",
    "ENTERED": "INSERITO",
    "ESTIMATED": "STIMATO",
    "ESTIMATING BODY": "ENTE DI STIMA",
    "Estimating head width and depth.": "Stima della larghezza e della profondità della testa.",
    "Estimating your measurements...": "Stima delle tue misurazioni...",
    "Estimation could not complete": "Impossibile completare la stima",
    "Face the camera directly at eye level": "Rivolgi la fotocamera direttamente all'altezza degli occhi",
    "Face the camera directly, centered in frame": "Rivolgiti direttamente alla fotocamera, centrata nell'inquadratura",
    "Face the camera with head and shoulders in frame": "Rivolgiti alla fotocamera con la testa e le spalle nell'inquadratura",
    "Face the camera with your head and shoulders in frame, leaving space above your head.": "Rivolgi la fotocamera con la testa e le spalle nell'inquadratura, lasciando spazio sopra la testa.",
    "Failed to process image": "Impossibile elaborare l'immagine",
    "Female": "Femmina",
    "FINALIZING": "FINALIZZAZIONE",
    "FINALIZING RESULT": "RISULTATO FINALIZZATO",
    "FIT": "ADATTO",
    "Fit reference": "Riferimento adatto",
    "Fit Result": "Risultato adatto",
    "Fit Terms": "Termini adatti",
    "Flat": "Piatto",
    "FLAT": "PIATTO",
    "FOOT": "PIEDE",
    "Foot length unit": "Unità di lunghezza del piede",
    "For your safety, we cannot process photos of people under 18.": "Per la tua sicurezza, non possiamo elaborare foto di persone di età inferiore a 18 anni.",
    "Frame Measurements": "Misure del telaio",
    "Full": "Pieno",
    "FULL": "COMPLETO",
    "Full circumference at the widest point.": "Circonferenza completa nel punto più largo.",
    "Full Size": "Dimensione intera",
    "Full Size Chart": "Grafico a grandezza naturale",
    "Garment Spec": "Specifiche dell'indumento",
    "Garment Spotlight": "Riflettori sull'abbigliamento",
    "Gender": "Genere",
    "GENDER": "GENERE",
    "Generating try-on…": "Generazione della prova in corso…",
    "Generating Your Look": "Genera il tuo look",
    "Generating your look...": "Generazione del tuo look...",
    "Generating your suggested size...": "Generazione della taglia suggerita...",
    "Go back": "Torna indietro",
    "Good lighting, plain background": "Buona illuminazione, sfondo semplice",
    "Head and shoulders in frame": "Testa e spalle in cornice",
    "Headwear Measurements": "Misure del copricapo",
    "Helps us refine bust measurements for tops and dresses": "Ci aiuta a perfezionare le misure del busto per top e abiti",
    "Here's what we estimated": "Ecco cosa abbiamo stimato",
    "Hide Fit": "Nascondi Adatta",
    "HIP PROFILE": "PROFILO ANCA",
    "HIPS": "FIANCHI",
    "Hips closer to shoulder width": "Fianchi più vicini alla larghezza delle spalle",
    "Hips proportionate to shoulders": "Fianchi proporzionati alle spalle",
    "Hips wider than shoulders": "Fianchi più larghi delle spalle",
    "Hold the camera at eye level": "Tieni la fotocamera all'altezza degli occhi",
    "Hold the phone at WAIST height (not eye level)": "Tieni il telefono all'altezza della VITA (non all'altezza degli occhi)",
    "How to Measure": "Come misurare",
    "Identifying 478 face landmarks in your photo.": "Identificazione di 478 punti di riferimento del volto nella tua foto.",
    "Identifying body landmarks from your photo.": "Identificare i punti di riferimento del corpo dalla tua foto.",
    "Identifying face landmarks in your photo.": "Identificazione dei punti di riferimento del viso nella foto.",
    "Identity": "Identità",
    "Increase": "Aumentare",
    "Inner leg seam length.": "Lunghezza cucitura interno gamba.",
    "INSEAM": "INTERNO",
    "Is the person in this photo 18 years or older?": "La persona in questa foto ha 18 anni o più?",
    "JPEG, PNG (max 10MB)": "JPEG, PNG (massimo 10 MB)",
    "JPEG, PNG up to 10MB": "JPEG, PNG fino a 10 MB",
    "JPEG, PNG up to 10MB · click or drop": "JPEG, PNG fino a 10 MB · fare clic o rilasciare",
    "JPEG, PNG, WebP, AVIF (max 10MB)": "JPEG, PNG, WebP, AVIF (massimo 10MB)",
    "Keep hair away from face and ears": "Tenere i capelli lontani dal viso e dalle orecchie",
    "Keep hair away from your face and ears": "Tieni i capelli lontani dal viso e dalle orecchie",
    "Keep your full face, ears, and head visible": "Mantieni il viso, le orecchie e la testa completamente visibili",
    "LAST UPDATE": "ULTIMO AGGIORNAMENTO",
    "Layer with a fitted base for sharper silhouette": "Strato con base aderente per una silhouette più nitida",
    "Leave some space above your head": "Lascia un po' di spazio sopra la testa",
    "Leave space above your head": "Lascia spazio sopra la testa",
    "Leave the bottom button of a suit jacket undone": "Lascia aperto il bottone inferiore della giacca",
    "left": "sinistra",
    "LEGAL NOTICE": "AVVISO LEGALE",
    "LENGTH ADJUSTMENT": "REGOLAZIONE DELLA LUNGHEZZA",
    "Length of the arm from hinge to tip": "Lunghezza del braccio dalla cerniera alla punta",
    "Loading your fit profile": "Caricamento del tuo profilo di vestibilità",
    "Loading your saved measurements and body shape answers.": "Caricamento delle misurazioni salvate e delle risposte sulla forma del corpo.",
    "long": "lungo",
    "LOOSE": "SCIOLTO",
    "Male": "Maschio",
    "MANUAL FIT": "INSERIMENTO MANUALE",
    "MAPPING": "MAPPATURA",
    "Mapping body landmarks…": "Mappatura dei punti di riferimento del corpo...",
    "Mapping bridge, frame width and temple fit.": "Mappatura di ponte, larghezza della montatura e vestibilità delle aste.",
    "Mapping bridge, lens width and temple length.": "Mappatura ponte, larghezza lente e lunghezza aste.",
    "MAPPING CIRCUMFERENCE": "CIRCONFERENZA MAPPATA",
    "Mapping garment to body": "Mappatura dell'indumento al corpo",
    "Match your belt to your shoes — never your pants": "Abbina la cintura alle scarpe, mai ai pantaloni",
    "MATCHING FRAME SIZE": "DIMENSIONI DEL TELAIO CORRISPONDENTI",
    "MATCHING HAT SIZE": "TAGLIA DEL CAPPELLO ABBINATA",
    "MATCHING SIZE": "TAGLIA CORRISPONDENTE",
    "Measure around your wrist where the bracelet or watch sits": "Misura intorno al polso dove si trova il braccialetto o l'orologio",
    "Measure from heel to longest toe": "Misura dal tallone alla punta più lunga",
    "Measure manually": "Misura manualmente",
    "Measurement": "Misurazione",
    "MEASUREMENT BLUEPRINT": "PROGETTO DI MISURAZIONE",
    "Measurement Guide": "Guida alla misurazione",
    "MEASURING": "MISURARE",
    "MEASURING FRAME": "TELAIO DI MISURA",
    "Measuring shoulders, chest, waist and hips.": "Misurare spalle, petto, vita e fianchi.",
    "MEN'S FIT": "VESTIBILITA' DA UOMO",
    "Menu": "Menù",
    "mm": "mm",
    "My Sizing Profiles": "I miei profili di dimensionamento",
    "NAME": "NOME",
    "NARROW": "STRETTO",
    "NECK": "COLLO",
    "Neutral background with good lighting": "Sfondo neutro con buona illuminazione",
    "New Profile": "Nuovo profilo",
    "No fit": "Non adatto",
    "No matching size": "Nessuna taglia corrispondente",
    "NO MATCHING SIZE": "NESSUNA TAGLIA CORRISPONDENTE",
    "No matching size available": "Nessuna taglia corrispondente disponibile",
    "No password needed. After sign in, you will continue to the normal profile setup.": "Nessuna password necessaria. Dopo l'accesso, proseguirai con la normale configurazione del profilo.",
    "No size chart available": "Nessuna tabella delle taglie disponibile",
    "No size matches your measurements": "Nessuna taglia corrisponde alle tue misure",
    "No sizes match the selected options.": "Nessuna taglia corrisponde alle opzioni selezionate.",
    "Not Suggested": "Non consigliato",
    "One Size": "Taglia unica",
    "Opening...": "Apertura...",
    "Optional note": "Nota facoltativa",
    "or": "o",
    "Or upload front face": "Oppure carica la faccia anteriore",
    "Our AI is mapping your proportions for a size suggestion.": "La nostra intelligenza artificiale sta mappando le tue proporzioni per suggerirti una taglia.",
    "Our AI is mapping your proportions.": "La nostra intelligenza artificiale sta mappando le tue proporzioni.",
    "Our AI is precisely mapping the garment to your unique proportions.": "La nostra intelligenza artificiale sta mappando con precisione il capo in base alle tue proporzioni uniche.",
    "Our AI works best with front-facing, full-body photos in fitted clothing. Better photos = more accurate virtual try-on!": "La nostra intelligenza artificiale funziona meglio con foto di tutto il corpo rivolte frontalmente in abiti aderenti. Foto migliori = prova virtuale più accurata!",
    "Our model is analyzing 150+ body landmarks for your size suggestion": "Il nostro modello sta analizzando oltre 150 punti di riferimento del corpo per suggerire la tua taglia",
    "Pair this with neutral tones for a balanced look": "Abbinalo a toni neutri per un look equilibrato",
    "Pick a brand you know well. We'll use that size as your fit reference.": "Scegli un marchio che conosci bene. Utilizzeremo quella taglia come riferimento di vestibilità.",
    "Please enter a profile name": "Inserisci un nome per il profilo",
    "Please enter a valid age": "Inserisci un'età valida",
    "Please enter your ": "Per favore inserisci il tuo",
    "Please fill in all fields": "Si prega di compilare tutti i campi",
    "Please pick an option": "Scegli un'opzione",
    "Please pick band and cup size": "Scegli la taglia della fascia e della coppa",
    "Please select your bra band and cup size": "Seleziona la fascia del reggiseno e la taglia della coppa",
    "Please select your usual shoe brand and size": "Seleziona la marca e la taglia delle tue scarpe abituali",
    "Please try again or use manual measurements": "Riprova o utilizza le misurazioni manuali",
    "Please try again or use manual measurements.": "Riprova o utilizza le misurazioni manuali.",
    "Please upload a photo first.": "Per favore carica prima una foto.",
    "Preparing your image": "Preparare la tua immagine",
    "Preparing your image…": "Preparare l'immagine...",
    "PrimeStyleAI": "PrimeStyleAI",
    "PrimeStyleAI profile": "Profilo PrimeStyleAI",
    "PrimeStyleAI profile benefits": "Vantaggi del profilo PrimeStyleAI",
    "Pro Tip": "Suggerimento professionale",
    "Proceed": "Procedi",
    "Processing...": "Elaborazione...",
    "Product photos": "Foto del prodotto",
    "Profile": "Profilo",
    "PROFILE": "PROFILO",
    "Profile details": "Dettagli del profilo",
    "Profile Name": "Nome del profilo",
    "Profile photo is missing. Please add a photo and try again.": "Manca la foto del profilo. Aggiungi una foto e riprova.",
    "Profile sync failed. Your local changes are still saved here.": "Sincronizzazione del profilo non riuscita. Le modifiche locali vengono comunque salvate qui.",
    "Profile welcome": "Benvenuto nel profilo",
    "Quick Setup": "Configurazione rapida",
    "Rate try-on": "Valuta la prova",
    "Rate your try-on": "Valuta la tua prova",
    "Rating": "Valutazione",
    "Reading head landmarks from your photo.": "Leggere i punti di riferimento della testa dalla tua foto.",
    "READING PROFILE": "PROFILO DI LETTURA",
    "READING YOUR PROFILE": "LEGGERE IL TUO PROFILO",
    "Refining drape and shadows": "Perfezionamento del drappeggio e delle ombre",
    "Refining drape and shadows…": "Perfezionamento di drappeggi e ombre...",
    "Remove any glasses you're wearing": "Togli tutti gli occhiali che indossi",
    "Remove photo": "Rimuovi foto",
    "Rendering shadows and highlights to match your photo's lighting": "Rendering di ombre e luci per adattarle all'illuminazione della foto",
    "Rendering the garment…": "Rendere il capo...",
    "RETAKE PHOTO": "RIPETERE LA FOTO",
    "Reuse these measurements on future products.": "Riutilizzare queste misurazioni sui prodotti futuri.",
    "Review before continuing.": "Rivedere prima di continuare.",
    "Review your measurements below — you can edit them later": "Controlla le tue misurazioni qui sotto: puoi modificarle in seguito",
    "Review your photo": "Rivedi la tua foto",
    "Roll sleeves twice for a relaxed, intentional finish": "Arrotolare le maniche due volte per una finitura rilassata e intenzionale",
    "ROUND": "TONDO",
    "SAVE": "SALVA",
    "Save Changes": "Salva modifiche",
    "Save Profile": "Salva profilo",
    "Save your fit profile": "Salva il tuo profilo di forma",
    "SCANNING FRAME": "CORNICE DI SCANSIONE",
    "SDK not configured. Please refresh and try again.": "SDK non configurato. Aggiorna e riprova.",
    "Securely reuse your measurements and photo across PrimeStyleAI experiences and partner stores.": "Riutilizza in modo sicuro le tue misurazioni e foto nelle esperienze PrimeStyleAI e nei negozi partner.",
    "See how it looks on yourself": "Guarda come ti sembra",
    "Select": "Seleziona",
    "SELECT": "SELEZIONA",
    "Select a size to add to cart": "Seleziona una taglia da aggiungere al carrello",
    "SELECT A SIZE TO ADD TO CART": "SELEZIONA UNA TAGLIA DA AGGIUNGERE AL CARRELLO",
    "Select bra band and cup": "Seleziona la fascia e la coppa del reggiseno",
    "Select the profile that best matches your chest breadth": "Seleziona il profilo che meglio si adatta alla tua ampiezza del torace",
    "SELECTED": "SELEZIONATO",
    "Selected brand": "Marchio selezionato",
    "Send": "Invia",
    "Send feedback": "Invia feedback",
    "Sending": "Invio",
    "Sent": "Inviato",
    "Set height": "Imposta l'altezza",
    "Set weight": "Imposta il peso",
    "Shoe brand": "Marchio di scarpe",
    "Shoe size": "Misura della scarpa",
    "Shoe Size": "Misura della scarpa",
    "short": "breve",
    "SHOULDER": "SPALLA",
    "Shoulder edge to shoulder edge.": "Da bordo spalla a bordo spalla.",
    "Shoulder seam to cuff edge.": "Cucitura della spalla sul bordo del polsino.",
    "Show Fit": "Mostra adattamento",
    "Sign in": "Accedi",
    "Sign out": "Esci",
    "size": "dimensione",
    "SIZE": "DIMENSIONE",
    "Size Guide": "Guida alle taglie",
    "SIZE GUIDE": "GUIDA ALLE TAGLIE",
    "Sizing Profile": "Profilo di dimensionamento",
    "SLEEVE": "MANICA",
    "SLIGHT EASE": "LEGGERA FACILITÀ",
    "SLIGHTLY TIGHT": "LEGGERMENTE STRETTO",
    "Continue with Google": "Continua con Google",
    "Continue with Apple": "Continua con Apple",
    "Continue with LinkedIn": "Continua con LinkedIn",
    "Social login failed.": "Accesso social non riuscito.",
    "Social login failed. Please try again.": "Accesso social non riuscito. Per favore riprova.",
    "Social login must run in the browser.": "L'accesso social deve essere eseguito nel browser.",
    "Popup was blocked. Please allow popups and try again.": "Il popup è stato bloccato. Consenti i popup e riprova.",
    "Login did not finish. Please close the sign-in window and try again.": "L'accesso non è stato completato. Chiudi la finestra di accesso e riprova.",
    "Social sign in": "Accesso sociale",
    "Stand straight and still, arms relaxed": "Stai dritto e fermo, con le braccia rilassate",
    "Standard": "Norma",
    "Standing 2-3 meters from camera": "Stare a 2-3 metri dalla telecamera",
    "stars": "stelle",
    "Start Fresh": "Ricominciare da capo",
    "Start Try-On": "Inizia la prova",
    "START TRY-ON": "INIZIA A PROVARE",
    "STEP": "PASSO",
    "Step 01": "Passaggio 01",
    "Step 02": "Passaggio 02",
    "Stomach": "Stomaco",
    "STOMACH PROFILE": "PROFILO DELLO STOMACO",
    "STRAIGHT": "DRITTO",
    "Style Tip": "Consiglio di stile",
    "suggested": "suggerito",
    "SUGGESTED": "CONSIGLIATO",
    "Suggested Size": "Dimensione suggerita",
    "Tap any section for detailed breakdown": "Tocca qualsiasi sezione per un'analisi dettagliata",
    "Tap any value to adjust if needed": "Tocca qualsiasi valore per modificarlo, se necessario",
    "Tap the card for detailed breakdown": "Tocca la scheda per un'analisi dettagliata",
    "Tap to upload": "Tocca per caricare",
    "The curvature of your hips and thighs": "La curvatura dei fianchi e delle cosce",
    "The curvature of your lower spine and seat profile": "La curvatura della parte inferiore della colonna vertebrale e del profilo del sedile",
    "The merchant hasn't uploaded sizing data for this product yet. You can still see how it looks on you with a virtual try-on.": "Il commerciante non ha ancora caricato i dati sulle taglie per questo prodotto. Puoi ancora vedere come ti sta con una prova virtuale.",
    "THIGH": "COSCIA",
    "This cannot be undone.": "Questa operazione non può essere annullata.",
    "This product's size chart doesn't carry a fit close enough to your body. Try another product or update your profile.": "La tabella delle taglie di questo prodotto non veste abbastanza vicino al tuo corpo. Prova un altro prodotto o aggiorna il tuo profilo.",
    "This product's size chart doesn't include a reliable fit for your measurements.": "La tabella delle taglie di questo prodotto non include una vestibilità affidabile per le tue misurazioni.",
    "TIGHT": "STRETTO",
    "Top to bottom length.": "Lunghezza dall'alto verso il basso.",
    "TRY ANOTHER SIZE": "PROVA UN'ALTRA TAGLIA",
    "Try-on failed": "Prova non riuscita",
    "Unable to connect to sizing service. Please try again.": "Impossibile connettersi al servizio di dimensionamento. Per favore riprova.",
    "Unable to connect to sizing service. Please try manual measurements.": "Impossibile connettersi al servizio di dimensionamento. Si prega di provare le misurazioni manuali.",
    "Unable to get a size suggestion. Please try again.": "Impossibile ottenere un suggerimento sulla taglia. Per favore riprova.",
    "Unable to get a size suggestion. Please try manual measurements.": "Impossibile ottenere un suggerimento sulla taglia. Si prega di provare le misurazioni manuali.",
    "Unit": "Unità",
    "Upload a full-body photo. Our AI computes every measurement.": "Carica una foto a figura intera. La nostra intelligenza artificiale calcola ogni misurazione.",
    "Upload a photo for AI sizing": "Carica una foto per il dimensionamento AI",
    "Upload front face": "Carica la faccia anteriore",
    "UPLOAD NOT ALLOWED": "CARICAMENTO NON CONSENTITO",
    "Use a front-facing photo with your face and head clearly visible.": "Utilizza una foto frontale con il viso e la testa chiaramente visibili.",
    "Use bright, even lighting and a plain background": "Utilizza un'illuminazione brillante e uniforme e uno sfondo semplice",
    "Use natural or even lighting": "Usa l'illuminazione naturale o uniforme",
    "Use natural, even lighting": "Usa un'illuminazione naturale e uniforme",
    "Use natural, even lighting (e.g. near a window)": "Utilizzare un'illuminazione naturale e uniforme (ad esempio vicino a una finestra)",
    "USE THIS PROFILE": "USA QUESTO PROFILO",
    "Used to calibrate the AI from your photo.": "Utilizzato per calibrare l'intelligenza artificiale dalla tua foto.",
    "USER": "UTENTE",
    "Using iris size as the pixel-to-mm anchor.": "Utilizzando la dimensione dell'iride come ancoraggio da pixel a mm.",
    "Using saved measurements for this fit.": "Utilizzo delle misurazioni salvate per questa vestibilità.",
    "VIEW CHART": "VISUALIZZA TABELLA",
    "VIEW DETAILS": "VISUALIZZA DETTAGLI",
    "WAIST": "VITA",
    "We couldn't find a size that fits for this product.": "Non siamo riusciti a trovare una taglia adatta a questo prodotto.",
    "We noticed your entered details didn't match your photo. To give you accurate sizing, we measured your body directly from the photo.": "Abbiamo notato che i dettagli inseriti non corrispondono alla tua foto. Per darti una taglia precisa, abbiamo misurato il tuo corpo direttamente dalla foto.",
    "Wear fitted, simple clothing": "Indossa abiti aderenti e semplici",
    "Welcome": "Benvenuto",
    "What is my size?": "Qual è la mia taglia?",
    "Which shoe brand do you usually wear?": "Quale marca di scarpe indossi solitamente?",
    "WHILE YOU WAIT": "MENTRE ASPETTI",
    "Width of one lens": "Larghezza di una lente",
    "WITHIN RANGE": "ENTRO LA GAMMA",
    "WOMEN'S FIT": "VESTIBILITA' DONNA",
    "Wrap a tape around the widest part of your head": "Avvolgi un nastro attorno alla parte più ampia della testa",
    "Wrist Circumference": "Circonferenza del polso",
    "Wrist Measurements": "Misure del polso",
    "YEARS": "ANNI",
    "You chose": "Hai scelto",
    "Your Body": "Il tuo corpo",
    "Your Choice · Not Suggested": "La tua scelta · Non consigliato",
    "YOUR CHOICE · NOT SUGGESTED": "LA TUA SCELTA · NON CONSIGLIATO",
    "Your Details": "I tuoi dettagli",
    "Your Fit": "La tua forma",
    "Your measurements": "Le tue misure",
    "Your profile is private to your PrimeStyleAI account and can be updated anytime.": "Il tuo profilo è privato per il tuo account PrimeStyleAI e può essere aggiornato in qualsiasi momento.",
    "Your profiles": "I tuoi profili",
    "Your Selection": "La tua selezione",
    "YOUR SELECTION": "LA TUA SELEZIONE",
    "your selection · not suggested": "la tua selezione · non suggerito",
    "Your size": "La tua taglia",
    "Your size is": "La tua taglia è",
    "Your try-on history": "La tua cronologia delle prove",
  },
  "pt": {
    "*Our sizing engine recommends": "*Nosso mecanismo de dimensionamento recomenda",
    "✓ Pose detected — running body analysis": "✓ Pose detectada — executando análise corporal",
    "A clean close-up improves landmark detection for eyewear and headwear.": "Um close-up limpo melhora a detecção de pontos de referência para óculos e chapéus.",
    "A clear head-and-shoulders photo with space above your head gives the most accurate headwear try-on.": "Uma foto nítida da cabeça e dos ombros com espaço acima da cabeça proporciona uma prova mais precisa do acessório para a cabeça.",
    "A clear, front-facing face photo — no glasses on — gives us the most accurate try-on.": "Uma foto nítida do rosto frontal - sem óculos - nos dá a experiência mais precisa.",
    "A clear, well-lit face photo gives the most accurate eyewear try-on.": "Uma foto de rosto nítida e bem iluminada proporciona uma experiência de óculos mais precisa.",
    "A clear, well-lit face photo gives the most accurate fit for eyewear and headwear.": "Uma foto de rosto nítida e bem iluminada proporciona o ajuste mais preciso para óculos e chapéus.",
    "A tie tip should land at the middle of your belt buckle": "A ponta da gravata deve ficar no meio da fivela do cinto",
    "Active Profile": "Perfil ativo",
    "ACTIVE PROFILE": "PERFIL ATIVO",
    "Add a name for this profile": "Adicione um nome para este perfil",
    "ADD MEASUREMENTS & PHOTO": "ADICIONE MEDIDAS E FOTO",
    "Add them to cart.": "Adicione-os ao carrinho.",
    "Add to Bag": "Adicionar à sacola",
    "Added to bag": "Adicionado ao saco",
    "Adding...": "Adicionando...",
    "Age": "Idade",
    "Age verification": "Verificação de idade",
    "AGE VERIFICATION": "VERIFICAÇÃO DE IDADE",
    "AI Fact": "Fato sobre IA",
    "AI Powered": "Alimentado por IA",
    "AI SCAN": "VARREDURA DE IA",
    "All measurements in": "Todas as medições em",
    "almost done": "quase pronto",
    "Almost done": "Quase pronto",
    "Almost done — finalizing…": "Quase pronto – finalizando…",
    "Almost done — preparing your suggested size.": "Quase pronto - preparando o tamanho sugerido.",
    "Analyze": "Analisar",
    "Analyze by photo": "Analisar por foto",
    "ANALYZE MY SIZE": "ANALISE MEU TAMANHO",
    "ANALYZING": "ANÁLISE",
    "ANALYZING BODY": "ANALISANDO O CORPO",
    "ANALYZING BODY MAP": "ANALISANDO MAPA CORPORAL",
    "Analyzing body proportions": "Analisando proporções corporais",
    "Around the base of the neck.": "Ao redor da base do pescoço.",
    "AVERAGE": "MÉDIA",
    "BACK": "VOLTAR",
    "Back & Seat": "Encosto e Assento",
    "BACK & SEAT": "COSTAS E ASSENTO",
    "Back to brands": "Voltar às marcas",
    "Back to product": "Voltar ao produto",
    "based on your measurements and the garment's tailoring chart.": "com base em suas medidas e na tabela de alfaiataria da peça.",
    "based on your selected brand size and foot length.": "com base no tamanho da marca selecionada e no comprimento do pé.",
    "best match": "melhor combinação",
    "BEST MATCH": "MELHOR PARTIDA",
    "BODY MEASUREMENTS": "MEDIDAS CORPORAIS",
    "Body measurements calculated!": "Medidas corporais calculadas!",
    "Bra": "Sutiã",
    "BRA SIZE": "TAMANHO DO SUTIÃ",
    "BROAD": "AMPLO",
    "BUST": "BUSTO",
    "Calculate My Body Parts": "Calcule minhas partes do corpo",
    "CALCULATE MY FIT": "CALCULAR MEU AJUSTE",
    "CALCULATING": "CÁLCULO",
    "calculating...": "calculando...",
    "Calculating...": "Calculando...",
    "CALIBRATING": "CALIBRANDO",
    "Calibrating fabric drape against your body proportions": "Calibrando a cortina de tecido de acordo com as proporções do seu corpo",
    "CALIBRATING SCALE": "ESCALA DE CALIBRAÇÃO",
    "Cancel": "Cancelar",
    "Cancel Generation": "Cancelar geração",
    "centimeters": "centímetros",
    "Change": "Mudança",
    "Checklist for accuracy": "Lista de verificação para precisão",
    "CHEST": "PEITO",
    "CHEST PROFILE": "PERFIL DE PEITO",
    "Choose a method": "Escolha um método",
    "Choose a plain background": "Escolha um fundo simples",
    "Choose a plain, light background": "Escolha um fundo simples e claro",
    "Choose a saved profile or create a new one before finding your best fit.": "Escolha um perfil salvo ou crie um novo antes de encontrar o que melhor se adapta.",
    "Choose another photo": "Escolha outra foto",
    "Choose one account": "Escolha uma conta",
    "Choose size": "Escolha o tamanho",
    "Choose your shoe brand": "Escolha a marca do seu calçado",
    "Choose your usual": "Escolha o seu habitual",
    "Circumference around the upper leg.": "Circunferência ao redor da parte superior da perna.",
    "Circumference at the fullest point.": "Circunferência no ponto mais cheio.",
    "Circumference at the natural waistline.": "Circunferência na cintura natural.",
    "Clear All": "Limpar tudo",
    "Click or drag a close-up face photo": "Clique ou arraste uma foto de rosto em close",
    "Click or drag a front face photo": "Clique ou arraste uma foto frontal",
    "Click or drag a head-and-shoulders photo": "Clique ou arraste uma foto de cabeça e ombros",
    "Click to change photo": "Clique para alterar a foto",
    "CM": "CM",
    "Comparing your circumference to the size chart.": "Comparando sua circunferência com a tabela de tamanhos.",
    "Comparing your measurements to the garment's size guide.": "Comparando suas medidas com o guia de tamanhos da roupa.",
    "Comparing your measurements to the size chart.": "Comparando suas medidas com a tabela de tamanhos.",
    "Comparing your measurements to the size guide.": "Comparando suas medidas com o guia de tamanhos.",
    "Complete the look": "Complete o visual",
    "Computing chest, waist, hips, sleeve and inseam from your basics.": "Calculando peito, cintura, quadris, manga e costura interna a partir do básico.",
    "Confirm your measurements": "Confirme suas medidas",
    "Continue Shopping": "Continuar comprando",
    "Could not load your saved profiles.": "Não foi possível carregar seus perfis salvos.",
    "Couldn't send. Try again.": "Não foi possível enviar. Tente novamente.",
    "Country": "País",
    "Crafted with quality materials for everyday comfort": "Fabricado com materiais de qualidade para conforto diário",
    "Create New Profile": "Criar novo perfil",
    "Create Profile": "Criar perfil",
    "Create your first fit profile to save your measurements, photo, and size history.": "Crie seu primeiro perfil de ajuste para salvar suas medidas, fotos e histórico de tamanhos.",
    "Create your fit profile once.": "Crie seu perfil de ajuste uma vez.",
    "Cross-checking fit against millions of garment patterns": "Verificação cruzada do ajuste com milhões de padrões de vestuário",
    "Cuff a pocket square so it peeks 1–2 cm above the pocket": "Algeme um lenço de bolso de forma que ele fique 1–2 cm acima do bolso",
    "Cuff once for a relaxed everyday feel": "Cuff uma vez para uma sensação descontraída no dia a dia",
    "Cufflinks should sit half an inch past the jacket sleeve": "As abotoaduras devem ficar meia polegada além da manga da jaqueta",
    "CURVED": "CURVO",
    "Decrease": "Diminuir",
    "DEEP": "PROFUNDO",
    "DEFAULT PROFILE": "PERFIL PADRÃO",
    "Delete": "Excluir",
    "Delete this profile?": "Excluir este perfil?",
    "Describe your mid-section silhouette": "Descreva a silhueta da sua seção intermediária",
    "DETAIL": "DETALHE",
    "Detecting body pose": "Detectando pose corporal",
    "Detecting face": "Detectando rosto",
    "DETECTING FACE": "DETECÇÃO DE ROSTO",
    "Detecting head": "Cabeça de detecção",
    "DETECTING HEAD": "CABEÇA DE DETECÇÃO",
    "DETECTING POSE": "DETECÇÃO DE POSIÇÃO",
    "Detecting pose landmarks…": "Detectando pontos de referência de pose…",
    "Display size in country": "Tamanho de exibição no país",
    "Distance over the nose between lenses": "Distância sobre o nariz entre as lentes",
    "Don't apply filters or edits": "Não aplique filtros ou edições",
    "Don't apply filters or heavy edits": "Não aplique filtros ou edições pesadas",
    "Don't cover your ears, eyes, or forehead": "Não cubra seus ouvidos, olhos ou testa",
    "Don't crop out the top of your head": "Não corte o topo da sua cabeça",
    "Don't crop out your ears or top of head": "Não corte as orelhas ou o topo da cabeça",
    "Don't sit, pose, or bend": "Não sente, pose ou se curve",
    "Don't tilt or turn your head": "Não incline ou vire a cabeça",
    "Don't use filters, mirrored photos, or angled selfies": "Não use filtros, fotos espelhadas ou selfies em ângulo",
    "Don't use heavy shadows or strong backlighting": "Não use sombras fortes ou luz de fundo forte",
    "Don't use strong backlighting or flash": "Não use luz de fundo forte ou flash",
    "Don't wear a hat in the photo": "Não use chapéu na foto",
    "Don't wear loose or baggy clothing": "Não use roupas largas ou largas",
    "Don't wear sunglasses or a hat in the photo": "Não use óculos escuros ou chapéu na foto",
    "Done": "Concluído",
    "e.g. 154": "por exemplo 154",
    "e.g. 173": "por exemplo 173",
    "e.g. 30": "por exemplo 30",
    "e.g. 70": "por exemplo 70",
    "e.g. My Measurements": "por exemplo Minhas medidas",
    "e.g. My Photo Profile": "por exemplo Meu perfil fotográfico",
    "Edit Profile": "Editar perfil",
    "EDITORIAL LENGTH": "COMPRIMENTO EDITORIAL",
    "Ensure your full body is visible for the most accurate digital tailoring scan.": "Certifique-se de que todo o seu corpo esteja visível para uma digitalização de alfaiataria digital mais precisa.",
    "Ensure your full body is visible for the most accurate virtual try-on.": "Certifique-se de que todo o seu corpo esteja visível para uma prova virtual mais precisa.",
    "Enter height, weight and answer quick body shape questions.": "Insira altura, peso e responda perguntas rápidas sobre formato corporal.",
    "Enter your details for a bespoke size suggestion": "Insira seus dados para uma sugestão de tamanho sob medida",
    "Enter your details for accurate body estimation": "Insira seus dados para uma estimativa precisa do corpo",
    "Enter your measurements OR upload a photo — we'll use whichever you provide.": "Insira suas medidas OU carregue uma foto - usaremos a que você fornecer.",
    "ENTERED": "INSCRITO",
    "ESTIMATED": "ESTIMADO",
    "ESTIMATING BODY": "ESTIMATIVA DO CORPO",
    "Estimating head width and depth.": "Estimando a largura e a profundidade da cabeça.",
    "Estimating your measurements...": "Estimando suas medidas...",
    "Estimation could not complete": "A estimativa não pôde ser concluída",
    "Face the camera directly at eye level": "Fique de frente para a câmera diretamente no nível dos olhos",
    "Face the camera directly, centered in frame": "Fique de frente para a câmera diretamente, centralizado no quadro",
    "Face the camera with head and shoulders in frame": "Fique de frente para a câmera com a cabeça e os ombros enquadrados",
    "Face the camera with your head and shoulders in frame, leaving space above your head.": "Fique de frente para a câmera com a cabeça e os ombros enquadrados, deixando espaço acima da cabeça.",
    "Failed to process image": "Falha ao processar imagem",
    "Female": "Feminino",
    "FINALIZING": "FINALIZANDO",
    "FINALIZING RESULT": "RESULTADO FINALIZANDO",
    "FIT": "AJUSTE",
    "Fit reference": "Referência de ajuste",
    "Fit Result": "Resultado de ajuste",
    "Fit Terms": "Termos de ajuste",
    "Flat": "Plano",
    "FLAT": "PLANO",
    "FOOT": "PÉ",
    "Foot length unit": "Unidade de comprimento do pé",
    "For your safety, we cannot process photos of people under 18.": "Para sua segurança, não podemos processar fotos de menores de 18 anos.",
    "Frame Measurements": "Medidas de quadro",
    "Full": "Completo",
    "FULL": "COMPLETO",
    "Full circumference at the widest point.": "Circunferência completa no ponto mais largo.",
    "Full Size": "Tamanho completo",
    "Full Size Chart": "Gráfico de tamanho completo",
    "Garment Spec": "Especificações de vestuário",
    "Garment Spotlight": "Destaque de vestuário",
    "Gender": "Gênero",
    "GENDER": "GÊNERO",
    "Generating try-on…": "Gerando teste…",
    "Generating Your Look": "Gerando seu visual",
    "Generating your look...": "Gerando seu olhar...",
    "Generating your suggested size...": "Gerando seu tamanho sugerido...",
    "Go back": "Volte",
    "Good lighting, plain background": "Boa iluminação, fundo liso",
    "Head and shoulders in frame": "Cabeça e ombros no quadro",
    "Headwear Measurements": "Medições de chapéus",
    "Helps us refine bust measurements for tops and dresses": "Ajuda-nos a refinar as medidas do busto para tops e vestidos",
    "Here's what we estimated": "Aqui está o que estimamos",
    "Hide Fit": "Ocultar ajuste",
    "HIP PROFILE": "PERFIL DO QUADRIL",
    "HIPS": "QUADRIS",
    "Hips closer to shoulder width": "Quadris mais próximos da largura dos ombros",
    "Hips proportionate to shoulders": "Quadris proporcionais aos ombros",
    "Hips wider than shoulders": "Quadris mais largos que os ombros",
    "Hold the camera at eye level": "Segure a câmera na altura dos olhos",
    "Hold the phone at WAIST height (not eye level)": "Segure o telefone na altura da CINTURA (não no nível dos olhos)",
    "How to Measure": "Como Medir",
    "Identifying 478 face landmarks in your photo.": "Identificando 478 pontos de referência faciais em sua foto.",
    "Identifying body landmarks from your photo.": "Identificando pontos de referência do corpo em sua foto.",
    "Identifying face landmarks in your photo.": "Identificando pontos de referência faciais em sua foto.",
    "Identity": "Identidade",
    "Increase": "Aumentar",
    "Inner leg seam length.": "Comprimento da costura interna da perna.",
    "INSEAM": "INSEAM",
    "Is the person in this photo 18 years or older?": "A pessoa nesta foto tem 18 anos ou mais?",
    "JPEG, PNG (max 10MB)": "JPEG, PNG (máx. 10 MB)",
    "JPEG, PNG up to 10MB": "JPEG, PNG até 10MB",
    "JPEG, PNG up to 10MB · click or drop": "JPEG, PNG até 10 MB · clique ou solte",
    "JPEG, PNG, WebP, AVIF (max 10MB)": "JPEG, PNG, WebP, AVIF (máx. 10 MB)",
    "Keep hair away from face and ears": "Mantenha o cabelo longe do rosto e das orelhas",
    "Keep hair away from your face and ears": "Mantenha o cabelo longe do rosto e das orelhas",
    "Keep your full face, ears, and head visible": "Mantenha todo o rosto, orelhas e cabeça visíveis",
    "LAST UPDATE": "ÚLTIMA ATUALIZAÇÃO",
    "Layer with a fitted base for sharper silhouette": "Camada com base ajustada para silhueta mais nítida",
    "Leave some space above your head": "Deixe algum espaço acima de sua cabeça",
    "Leave space above your head": "Deixe espaço acima de sua cabeça",
    "Leave the bottom button of a suit jacket undone": "Deixe o botão inferior do paletó desabotoado",
    "left": "esquerda",
    "LEGAL NOTICE": "AVISO LEGAL",
    "LENGTH ADJUSTMENT": "AJUSTE DE COMPRIMENTO",
    "Length of the arm from hinge to tip": "Comprimento do braço da dobradiça até a ponta",
    "Loading your fit profile": "Carregando seu perfil de ajuste",
    "Loading your saved measurements and body shape answers.": "Carregando suas medidas salvas e respostas de formato corporal.",
    "long": "longo",
    "LOOSE": "SOLTO",
    "Male": "Masculino",
    "MANUAL FIT": "AJUSTE MANUAL",
    "MAPPING": "MAPEAMENTO",
    "Mapping body landmarks…": "Mapeando pontos de referência do corpo…",
    "Mapping bridge, frame width and temple fit.": "Mapeamento da ponte, largura da moldura e ajuste da haste.",
    "Mapping bridge, lens width and temple length.": "Mapeamento da ponte, largura da lente e comprimento da têmpora.",
    "MAPPING CIRCUMFERENCE": "CIRCUNFERÊNCIA DE MAPEAMENTO",
    "Mapping garment to body": "Mapeando a roupa para o corpo",
    "Match your belt to your shoes — never your pants": "Combine o cinto com os sapatos – nunca com as calças",
    "MATCHING FRAME SIZE": "TAMANHO DO QUADRO CORRESPONDENTE",
    "MATCHING HAT SIZE": "TAMANHO DO CHAPÉU CORRESPONDENTE",
    "MATCHING SIZE": "TAMANHO CORRESPONDENTE",
    "Measure around your wrist where the bracelet or watch sits": "Meça ao redor do seu pulso onde fica a pulseira ou o relógio",
    "Measure from heel to longest toe": "Meça do calcanhar ao dedo mais longo",
    "Measure manually": "Medir manualmente",
    "Measurement": "Medição",
    "MEASUREMENT BLUEPRINT": "MODELO DE MEDIÇÃO",
    "Measurement Guide": "Guia de medição",
    "MEASURING": "MEDIÇÃO",
    "MEASURING FRAME": "QUADRO DE MEDIÇÃO",
    "Measuring shoulders, chest, waist and hips.": "Medindo ombros, peito, cintura e quadris.",
    "MEN'S FIT": "AJUSTE MASCULINO",
    "Menu": "Cardápio",
    "mm": "milímetros",
    "My Sizing Profiles": "Meus perfis de dimensionamento",
    "NAME": "NOME",
    "NARROW": "ESTREITO",
    "NECK": "PESCOÇO",
    "Neutral background with good lighting": "Fundo neutro com boa iluminação",
    "New Profile": "Novo perfil",
    "No fit": "Não cabe",
    "No matching size": "Nenhum tamanho correspondente",
    "NO MATCHING SIZE": "SEM TAMANHO CORRESPONDENTE",
    "No matching size available": "Nenhum tamanho correspondente disponível",
    "No password needed. After sign in, you will continue to the normal profile setup.": "Nenhuma senha necessária. Após fazer login, você continuará com a configuração normal do perfil.",
    "No size chart available": "Nenhuma tabela de tamanhos disponível",
    "No size matches your measurements": "Nenhum tamanho corresponde às suas medidas",
    "No sizes match the selected options.": "Nenhum tamanho corresponde às opções selecionadas.",
    "Not Suggested": "Não sugerido",
    "One Size": "Tamanho único",
    "Opening...": "Abrindo...",
    "Optional note": "Nota opcional",
    "or": "ou",
    "Or upload front face": "Ou carregue a face frontal",
    "Our AI is mapping your proportions for a size suggestion.": "Nossa IA está mapeando suas proporções para uma sugestão de tamanho.",
    "Our AI is mapping your proportions.": "Nossa IA está mapeando suas proporções.",
    "Our AI is precisely mapping the garment to your unique proportions.": "Nossa IA mapeia com precisão a roupa de acordo com suas proporções únicas.",
    "Our AI works best with front-facing, full-body photos in fitted clothing. Better photos = more accurate virtual try-on!": "Nossa IA funciona melhor com fotos frontais de corpo inteiro em roupas justas. Melhores fotos = teste virtual mais preciso!",
    "Our model is analyzing 150+ body landmarks for your size suggestion": "Nosso modelo está analisando mais de 150 pontos de referência corporais para sua sugestão de tamanho",
    "Pair this with neutral tones for a balanced look": "Combine isso com tons neutros para um visual equilibrado",
    "Pick a brand you know well. We'll use that size as your fit reference.": "Escolha uma marca que você conheça bem. Usaremos esse tamanho como referência de ajuste.",
    "Please enter a profile name": "Por favor insira um nome de perfil",
    "Please enter a valid age": "Insira uma idade válida",
    "Please enter your ": "Por favor insira o seu",
    "Please fill in all fields": "Por favor preencha todos os campos",
    "Please pick an option": "Escolha uma opção",
    "Please pick band and cup size": "Escolha o tamanho da faixa e do copo",
    "Please select your bra band and cup size": "Selecione a faixa do sutiã e o tamanho do copo",
    "Please select your usual shoe brand and size": "Selecione a marca e o tamanho de calçado habitual",
    "Please try again or use manual measurements": "Por favor, tente novamente ou use medições manuais",
    "Please try again or use manual measurements.": "Por favor, tente novamente ou use medições manuais.",
    "Please upload a photo first.": "Por favor carregue uma foto primeiro.",
    "Preparing your image": "Preparando sua imagem",
    "Preparing your image…": "Preparando sua imagem…",
    "PrimeStyleAI": "PrimeStyleAI",
    "PrimeStyleAI profile": "Perfil PrimeStyleAI",
    "PrimeStyleAI profile benefits": "Benefícios do perfil PrimeStyleAI",
    "Pro Tip": "Dica profissional",
    "Proceed": "Prosseguir",
    "Processing...": "Processando...",
    "Product photos": "Fotos do produto",
    "Profile": "Perfil",
    "PROFILE": "PERFIL",
    "Profile details": "Detalhes do perfil",
    "Profile Name": "Nome do perfil",
    "Profile photo is missing. Please add a photo and try again.": "A foto do perfil está faltando. Adicione uma foto e tente novamente.",
    "Profile sync failed. Your local changes are still saved here.": "Falha na sincronização do perfil. Suas alterações locais ainda estão salvas aqui.",
    "Profile welcome": "Bem-vindo ao perfil",
    "Quick Setup": "Configuração rápida",
    "Rate try-on": "Avalie o teste",
    "Rate your try-on": "Avalie sua experiência",
    "Rating": "Avaliação",
    "Reading head landmarks from your photo.": "Lendo pontos de referência da sua foto.",
    "READING PROFILE": "PERFIL DE LEITURA",
    "READING YOUR PROFILE": "LENDO SEU PERFIL",
    "Refining drape and shadows": "Refinando cortinas e sombras",
    "Refining drape and shadows…": "Refinando cortinas e sombras…",
    "Remove any glasses you're wearing": "Remova todos os óculos que você estiver usando",
    "Remove photo": "Remover foto",
    "Rendering shadows and highlights to match your photo's lighting": "Renderizando sombras e realces para combinar com a iluminação da sua foto",
    "Rendering the garment…": "Renderizando a roupa…",
    "RETAKE PHOTO": "RETIRAR FOTO",
    "Reuse these measurements on future products.": "Reutilize essas medições em produtos futuros.",
    "Review before continuing.": "Revise antes de continuar.",
    "Review your measurements below — you can edit them later": "Revise suas medidas abaixo – você pode editá-las mais tarde",
    "Review your photo": "Revise sua foto",
    "Roll sleeves twice for a relaxed, intentional finish": "Enrole as mangas duas vezes para um acabamento descontraído e intencional",
    "ROUND": "REDONDA",
    "SAVE": "SALVAR",
    "Save Changes": "Salvar alterações",
    "Save Profile": "Salvar perfil",
    "Save your fit profile": "Salve seu perfil de ajuste",
    "SCANNING FRAME": "QUADRO DE DIGITALIZAÇÃO",
    "SDK not configured. Please refresh and try again.": "SDK não configurado. Atualize e tente novamente.",
    "Securely reuse your measurements and photo across PrimeStyleAI experiences and partner stores.": "Reutilize com segurança suas medidas e fotos nas experiências PrimeStyleAI e lojas parceiras.",
    "See how it looks on yourself": "Veja como fica em você",
    "Select": "Selecione",
    "SELECT": "SELECIONAR",
    "Select a size to add to cart": "Selecione um tamanho para adicionar ao carrinho",
    "SELECT A SIZE TO ADD TO CART": "SELECIONE UM TAMANHO PARA ADICIONAR AO CARRINHO",
    "Select bra band and cup": "Selecione a faixa do sutiã e o copo",
    "Select the profile that best matches your chest breadth": "Selecione o perfil que melhor corresponde à largura do seu peito",
    "SELECTED": "SELECIONADO",
    "Selected brand": "Marca selecionada",
    "Send": "Enviar",
    "Send feedback": "Enviar comentários",
    "Sending": "Enviando",
    "Sent": "Enviado",
    "Set height": "Definir altura",
    "Set weight": "Definir peso",
    "Shoe brand": "Marca de calçados",
    "Shoe size": "Tamanho do sapato",
    "Shoe Size": "Tamanho do sapato",
    "short": "curto",
    "SHOULDER": "OMBRO",
    "Shoulder edge to shoulder edge.": "Borda do ombro a borda do ombro.",
    "Shoulder seam to cuff edge.": "Costura do ombro até a borda do punho.",
    "Show Fit": "Mostrar ajuste",
    "Sign in": "Faça login",
    "Sign out": "Sair",
    "size": "tamanho",
    "SIZE": "TAMANHO",
    "Size Guide": "Guia de tamanhos",
    "SIZE GUIDE": "GUIA DE TAMANHOS",
    "Sizing Profile": "Perfil de dimensionamento",
    "SLEEVE": "MANGA",
    "SLIGHT EASE": "LEVE FACILIDADE",
    "SLIGHTLY TIGHT": "LEVEMENTE APERTADO",
    "Continue with Google": "Continuar com Google",
    "Continue with Apple": "Continuar com Apple",
    "Continue with LinkedIn": "Continuar com LinkedIn",
    "Social login failed.": "Falha no login social.",
    "Social login failed. Please try again.": "Falha no login social. Por favor, tente novamente.",
    "Social login must run in the browser.": "O login social deve ser executado no navegador.",
    "Popup was blocked. Please allow popups and try again.": "O pop-up foi bloqueado. Permita pop-ups e tente novamente.",
    "Login did not finish. Please close the sign-in window and try again.": "O login não foi concluído. Feche a janela de login e tente novamente.",
    "Social sign in": "Login social",
    "Stand straight and still, arms relaxed": "Fique em pé e parado, com os braços relaxados",
    "Standard": "Padrão",
    "Standing 2-3 meters from camera": "Ficar a 2-3 metros da câmera",
    "stars": "estrelas",
    "Start Fresh": "Comece do zero",
    "Start Try-On": "Iniciar teste",
    "START TRY-ON": "COMECE A EXPERIMENTAR",
    "STEP": "ETAPA",
    "Step 01": "Passo 01",
    "Step 02": "Etapa 02",
    "Stomach": "Estômago",
    "STOMACH PROFILE": "PERFIL DO ESTÔMAGO",
    "STRAIGHT": "DIRETO",
    "Style Tip": "Dica de estilo",
    "suggested": "sugerido",
    "SUGGESTED": "SUGERIDO",
    "Suggested Size": "Tamanho sugerido",
    "Tap any section for detailed breakdown": "Toque em qualquer seção para detalhamento detalhado",
    "Tap any value to adjust if needed": "Toque em qualquer valor para ajustar, se necessário",
    "Tap the card for detailed breakdown": "Toque no cartão para detalhamento detalhado",
    "Tap to upload": "Toque para fazer upload",
    "The curvature of your hips and thighs": "A curvatura de seus quadris e coxas",
    "The curvature of your lower spine and seat profile": "A curvatura da parte inferior da coluna e o perfil do assento",
    "The merchant hasn't uploaded sizing data for this product yet. You can still see how it looks on you with a virtual try-on.": "O comerciante ainda não carregou os dados de tamanho deste produto. Você ainda pode ver como fica em você com uma prova virtual.",
    "THIGH": "COXA",
    "This cannot be undone.": "Isto não pode ser desfeito.",
    "This product's size chart doesn't carry a fit close enough to your body. Try another product or update your profile.": "A tabela de tamanhos deste produto não se ajusta suficientemente ao seu corpo. Experimente outro produto ou atualize seu perfil.",
    "This product's size chart doesn't include a reliable fit for your measurements.": "A tabela de tamanhos deste produto não inclui um ajuste confiável para suas medidas.",
    "TIGHT": "APERTADO",
    "Top to bottom length.": "Comprimento de cima para baixo.",
    "TRY ANOTHER SIZE": "TENTE OUTRO TAMANHO",
    "Try-on failed": "Falha na tentativa",
    "Unable to connect to sizing service. Please try again.": "Não foi possível conectar-se ao serviço de dimensionamento. Por favor, tente novamente.",
    "Unable to connect to sizing service. Please try manual measurements.": "Não foi possível conectar-se ao serviço de dimensionamento. Por favor, tente medições manuais.",
    "Unable to get a size suggestion. Please try again.": "Não foi possível obter uma sugestão de tamanho. Por favor, tente novamente.",
    "Unable to get a size suggestion. Please try manual measurements.": "Não foi possível obter uma sugestão de tamanho. Por favor, tente medições manuais.",
    "Unit": "Unidade",
    "Upload a full-body photo. Our AI computes every measurement.": "Carregue uma foto de corpo inteiro. Nossa IA calcula todas as medições.",
    "Upload a photo for AI sizing": "Carregue uma foto para dimensionamento de IA",
    "Upload front face": "Carregar face frontal",
    "UPLOAD NOT ALLOWED": "CARREGAR NÃO PERMITIDO",
    "Use a front-facing photo with your face and head clearly visible.": "Use uma foto frontal com rosto e cabeça claramente visíveis.",
    "Use bright, even lighting and a plain background": "Use iluminação brilhante e uniforme e um fundo simples",
    "Use natural or even lighting": "Use iluminação natural ou uniforme",
    "Use natural, even lighting": "Use iluminação natural e uniforme",
    "Use natural, even lighting (e.g. near a window)": "Use iluminação natural e uniforme (por exemplo, perto de uma janela)",
    "USE THIS PROFILE": "USE ESTE PERFIL",
    "Used to calibrate the AI from your photo.": "Usado para calibrar a IA da sua foto.",
    "USER": "USUÁRIO",
    "Using iris size as the pixel-to-mm anchor.": "Usando o tamanho da íris como âncora pixel a mm.",
    "Using saved measurements for this fit.": "Usando medidas salvas para este ajuste.",
    "VIEW CHART": "VER TABELA",
    "VIEW DETAILS": "VER DETALHES",
    "WAIST": "CINTURA",
    "We couldn't find a size that fits for this product.": "Não encontramos um tamanho adequado para este produto.",
    "We noticed your entered details didn't match your photo. To give you accurate sizing, we measured your body directly from the photo.": "Notamos que os dados inseridos não correspondem à sua foto. Para fornecer um tamanho preciso, medimos seu corpo diretamente na foto.",
    "Wear fitted, simple clothing": "Use roupas justas e simples",
    "Welcome": "Bem vindo",
    "What is my size?": "Qual é o meu tamanho?",
    "Which shoe brand do you usually wear?": "Qual marca de calçado você costuma usar?",
    "WHILE YOU WAIT": "ENQUANTO VOCÊ ESPERA",
    "Width of one lens": "Largura de uma lente",
    "WITHIN RANGE": "DENTRO DO INTERVALO",
    "WOMEN'S FIT": "AJUSTE FEMININO",
    "Wrap a tape around the widest part of your head": "Enrole uma fita em volta da parte mais larga da sua cabeça",
    "Wrist Circumference": "Circunferência do pulso",
    "Wrist Measurements": "Medições de pulso",
    "YEARS": "ANOS",
    "You chose": "Você escolheu",
    "Your Body": "Seu corpo",
    "Your Choice · Not Suggested": "Sua escolha · Não sugerido",
    "YOUR CHOICE · NOT SUGGESTED": "SUA ESCOLHA · NÃO SUGERIDO",
    "Your Details": "Seus detalhes",
    "Your Fit": "Seu ajuste",
    "Your measurements": "Suas medidas",
    "Your profile is private to your PrimeStyleAI account and can be updated anytime.": "Seu perfil é privado da sua conta PrimeStyleAI e pode ser atualizado a qualquer momento.",
    "Your profiles": "Seus perfis",
    "Your Selection": "Sua seleção",
    "YOUR SELECTION": "SUA SELEÇÃO",
    "your selection · not suggested": "sua seleção · não sugerido",
    "Your size": "Seu tamanho",
    "Your size is": "Seu tamanho é",
    "Your try-on history": "Seu histórico de experimentação",
  },
  "ja": {
    "*Our sizing engine recommends": "*当社のサイジングエンジンは推奨します",
    "✓ Pose detected — running body analysis": "✓ 姿勢の検出 - ランニングボディ分析",
    "A clean close-up improves landmark detection for eyewear and headwear.": "きれいにクローズアップすると、眼鏡や帽子のランドマーク検出が向上します。",
    "A clear head-and-shoulders photo with space above your head gives the most accurate headwear try-on.": "頭上にスペースがあり、頭と肩がはっきりと写った写真があれば、最も正確に帽子を試着できます。",
    "A clear, front-facing face photo — no glasses on — gives us the most accurate try-on.": "メガネをかけていない、鮮明な正面の顔写真があれば、最も正確な試着が可能になります。",
    "A clear, well-lit face photo gives the most accurate eyewear try-on.": "鮮明で明るい顔の写真により、最も正確なアイウェアの試着が可能になります。",
    "A clear, well-lit face photo gives the most accurate fit for eyewear and headwear.": "鮮明で明るい顔の写真により、眼鏡や帽子が最も正確にフィットします。",
    "A tie tip should land at the middle of your belt buckle": "ネクタイの先端がベルトのバックルの中央に来るようにする",
    "Active Profile": "アクティブなプロファイル",
    "ACTIVE PROFILE": "アクティブなプロファイル",
    "Add a name for this profile": "このプロファイルの名前を追加します",
    "ADD MEASUREMENTS & PHOTO": "寸法と写真を追加",
    "Add them to cart.": "カートに追加してください。",
    "Add to Bag": "バッグに追加",
    "Added to bag": "バッグに追加されました",
    "Adding...": "追加中...",
    "Age": "年齢",
    "Age verification": "年齢確認",
    "AGE VERIFICATION": "年齢認証",
    "AI Fact": "AI の事実",
    "AI Powered": "AI を活用した",
    "AI SCAN": "AIスキャン",
    "All measurements in": "すべての測定値",
    "almost done": "ほぼ完了",
    "Almost done": "ほぼ完了",
    "Almost done — finalizing…": "ほぼ完了 — 仕上げ中…",
    "Almost done — preparing your suggested size.": "提案サイズの準備がほぼ完了しました。",
    "Analyze": "分析する",
    "Analyze by photo": "写真で分析する",
    "ANALYZE MY SIZE": "私のサイズを分析する",
    "ANALYZING": "分析中",
    "ANALYZING BODY": "身体の分析",
    "ANALYZING BODY MAP": "ボディマップの分析",
    "Analyzing body proportions": "体のプロポーションを分析する",
    "Around the base of the neck.": "首の付け根あたり。",
    "AVERAGE": "平均",
    "BACK": "戻る",
    "Back & Seat": "背もたれと座面",
    "BACK & SEAT": "背もたれと座席",
    "Back to brands": "ブランドに戻る",
    "Back to product": "製品に戻る",
    "based on your measurements and the garment's tailoring chart.": "あなたの測定値と衣服の仕立て表に基づいてください。",
    "based on your selected brand size and foot length.": "選択したブランドのサイズと足の長さに基づいてください。",
    "best match": "ベストマッチ",
    "BEST MATCH": "ベストマッチ",
    "BODY MEASUREMENTS": "身体の寸法",
    "Body measurements calculated!": "身体測定値が計算されました!",
    "Bra": "ブラジャー",
    "BRA SIZE": "ブラジャーのサイズ",
    "BROAD": "幅広い",
    "BUST": "バスト",
    "Calculate My Body Parts": "私の体の部位を計算する",
    "CALCULATE MY FIT": "自分のフィット感を計算する",
    "CALCULATING": "計算中",
    "calculating...": "計算中...",
    "Calculating...": "計算中...",
    "CALIBRATING": "校正中",
    "Calibrating fabric drape against your body proportions": "身体のプロポーションに合わせて生地のドレープを調整する",
    "CALIBRATING SCALE": "校正スケール",
    "Cancel": "キャンセル",
    "Cancel Generation": "生成のキャンセル",
    "centimeters": "センチメートル",
    "Change": "変更",
    "Checklist for accuracy": "正確性のためのチェックリスト",
    "CHEST": "胸",
    "CHEST PROFILE": "胸のプロフィール",
    "Choose a method": "方法を選択してください",
    "Choose a plain background": "無地の背景を選択してください",
    "Choose a plain, light background": "無地の明るい背景を選択してください",
    "Choose a saved profile or create a new one before finding your best fit.": "最適なプロファイルを見つける前に、保存されているプロファイルを選択するか、新しいプロファイルを作成してください。",
    "Choose another photo": "別の写真を選択してください",
    "Choose one account": "アカウントを 1 つ選択してください",
    "Choose size": "サイズを選択してください",
    "Choose your shoe brand": "靴のブランドを選択してください",
    "Choose your usual": "いつものものを選んでください",
    "Circumference around the upper leg.": "脚上部の周囲。",
    "Circumference at the fullest point.": "最大部分の周囲。",
    "Circumference at the natural waistline.": "自然なウエストラインの周囲。",
    "Clear All": "すべてクリア",
    "Click or drag a close-up face photo": "顔のアップ写真をクリックまたはドラッグします",
    "Click or drag a front face photo": "正面写真をクリックまたはドラッグします",
    "Click or drag a head-and-shoulders photo": "頭と肩の写真をクリックまたはドラッグします",
    "Click to change photo": "クリックして写真を変更します",
    "CM": "CM",
    "Comparing your circumference to the size chart.": "自分の周囲をサイズ表と比較してください。",
    "Comparing your measurements to the garment's size guide.": "測定値を衣服のサイズガイドと比較してください。",
    "Comparing your measurements to the size chart.": "測定値をサイズ表と比較してください。",
    "Comparing your measurements to the size guide.": "測定値をサイズガイドと比較してください。",
    "Complete the look": "見た目を完成させる",
    "Computing chest, waist, hips, sleeve and inseam from your basics.": "胸、ウエスト、ヒップ、袖、股下を基本から計算します。",
    "Confirm your measurements": "測定値を確認する",
    "Continue Shopping": "買い物を続ける",
    "Could not load your saved profiles.": "保存したプロファイルをロードできませんでした。",
    "Couldn't send. Try again.": "送信できませんでした。もう一度やり直してください。",
    "Country": "国",
    "Crafted with quality materials for everyday comfort": "毎日の快適さを追求した高品質の素材で作られています",
    "Create New Profile": "新しいプロファイルの作成",
    "Create Profile": "プロファイルの作成",
    "Create your first fit profile to save your measurements, photo, and size history.": "最初のフィットプロファイルを作成して、測定値、写真、サイズ履歴を保存します。",
    "Create your fit profile once.": "フィットプロファイルを一度作成してください。",
    "Cross-checking fit against millions of garment patterns": "数百万の衣服のパターンに対してフィット感をクロスチェック",
    "Cuff a pocket square so it peeks 1–2 cm above the pocket": "ポケットチーフの袖口をポケットから 1 ～ 2 cm 上に覗かせるようにします。",
    "Cuff once for a relaxed everyday feel": "袖口を一度締めるだけでリラックスした日常感が楽しめます",
    "Cufflinks should sit half an inch past the jacket sleeve": "カフリンクスはジャケットの袖から 0.5 インチ先にある必要があります",
    "CURVED": "湾曲した",
    "Decrease": "減少",
    "DEEP": "ディープ",
    "DEFAULT PROFILE": "デフォルトのプロファイル",
    "Delete": "削除",
    "Delete this profile?": "このプロフィールを削除しますか?",
    "Describe your mid-section silhouette": "中央部のシルエットを説明してください",
    "DETAIL": "詳細",
    "Detecting body pose": "体の姿勢の検出",
    "Detecting face": "顔を検出する",
    "DETECTING FACE": "顔を検出中",
    "Detecting head": "検出ヘッド",
    "DETECTING HEAD": "検出ヘッド",
    "DETECTING POSE": "ポーズの検出",
    "Detecting pose landmarks…": "ポーズのランドマークを検出中…",
    "Display size in country": "国別の表示サイズ",
    "Distance over the nose between lenses": "鼻の上のレンズ間の距離",
    "Don't apply filters or edits": "フィルターや編集を適用しないでください",
    "Don't apply filters or heavy edits": "フィルターや大幅な編集を適用しないでください",
    "Don't cover your ears, eyes, or forehead": "耳、目、額を覆わないでください",
    "Don't crop out the top of your head": "頭のてっぺんを切り取らないでください",
    "Don't crop out your ears or top of head": "耳や頭頂部を切り取らないでください",
    "Don't sit, pose, or bend": "座ったり、ポーズをとったり、かがんだりしないでください",
    "Don't tilt or turn your head": "頭を傾けたり回したりしないでください",
    "Don't use filters, mirrored photos, or angled selfies": "フィルター、鏡に映した写真、斜めに撮った自撮り写真は使用しないでください",
    "Don't use heavy shadows or strong backlighting": "濃い影や強い逆光を使用しないでください",
    "Don't use strong backlighting or flash": "強い逆光やフラッシュを使用しないでください",
    "Don't wear a hat in the photo": "写真では帽子をかぶらないでください",
    "Don't wear loose or baggy clothing": "だぶだぶの服を着ないでください",
    "Don't wear sunglasses or a hat in the photo": "写真ではサングラスや帽子を着用しないでください",
    "Done": "完了",
    "e.g. 154": "例: 154",
    "e.g. 173": "例: 173",
    "e.g. 30": "例: 30",
    "e.g. 70": "例: 70",
    "e.g. My Measurements": "例:私の測定値",
    "e.g. My Photo Profile": "例えば私の写真プロフィール",
    "Edit Profile": "プロフィールの編集",
    "EDITORIAL LENGTH": "編集長",
    "Ensure your full body is visible for the most accurate digital tailoring scan.": "最も正確なデジタル テーラーリング スキャンを行うために、全身が見えるようにしてください。",
    "Ensure your full body is visible for the most accurate virtual try-on.": "最も正確な仮想試着を行うために、全身が見えるようにしてください。",
    "Enter height, weight and answer quick body shape questions.": "身長、体重を入力し、体型に関する簡単な質問に答えます。",
    "Enter your details for a bespoke size suggestion": "オーダーメイドのサイズ提案のために詳細を入力してください",
    "Enter your details for accurate body estimation": "正確な体型推定のために詳細を入力してください",
    "Enter your measurements OR upload a photo — we'll use whichever you provide.": "寸法を入力するか、写真をアップロードしてください。指定された方を使用します。",
    "ENTERED": "入力されました",
    "ESTIMATED": "推定",
    "ESTIMATING BODY": "推定本体",
    "Estimating head width and depth.": "ヘッドの幅と深さを推定します。",
    "Estimating your measurements...": "測定値を見積もっています...",
    "Estimation could not complete": "見積もりを完了できませんでした",
    "Face the camera directly at eye level": "目の高さでカメラを直接向ける",
    "Face the camera directly, centered in frame": "フレームの中央に、カメラを直接向けます",
    "Face the camera with head and shoulders in frame": "頭と肩をフレーム内に収めてカメラに向かう",
    "Face the camera with your head and shoulders in frame, leaving space above your head.": "頭と肩がフレーム内に収まるようにカメラに向かい、頭の上にスペースを残します。",
    "Failed to process image": "画像の処理に失敗しました",
    "Female": "女性",
    "FINALIZING": "仕上げ中",
    "FINALIZING RESULT": "最終的な結果",
    "FIT": "フィット",
    "Fit reference": "適合基準",
    "Fit Result": "フィット結果",
    "Fit Terms": "用語の適合",
    "Flat": "フラット",
    "FLAT": "フラット",
    "FOOT": "足",
    "Foot length unit": "足の長さの単位",
    "For your safety, we cannot process photos of people under 18.": "安全のため、18 歳未満の人の写真は加工できません。",
    "Frame Measurements": "フレームの測定",
    "Full": "フル",
    "FULL": "フル",
    "Full circumference at the widest point.": "最も広い部分の全周。",
    "Full Size": "フルサイズ",
    "Full Size Chart": "フルサイズチャート",
    "Garment Spec": "衣服の仕様",
    "Garment Spotlight": "衣服のスポットライト",
    "Gender": "性別",
    "GENDER": "性別",
    "Generating try-on…": "試着を生成中…",
    "Generating Your Look": "自分の見た目を生成する",
    "Generating your look...": "見た目を生成中...",
    "Generating your suggested size...": "推奨サイズを生成しています...",
    "Go back": "戻る",
    "Good lighting, plain background": "適切な照明、無地の背景",
    "Head and shoulders in frame": "フレーム内の頭と肩",
    "Headwear Measurements": "帽子の寸法",
    "Helps us refine bust measurements for tops and dresses": "トップスやドレスのバスト寸法を修正するのに役立ちます",
    "Here's what we estimated": "私たちが推定したものは次のとおりです",
    "Hide Fit": "フィットを隠す",
    "HIP PROFILE": "ヒッププロファイル",
    "HIPS": "ヒップ",
    "Hips closer to shoulder width": "ヒップを肩幅に近づける",
    "Hips proportionate to shoulders": "腰は肩に比例する",
    "Hips wider than shoulders": "腰は肩より広い",
    "Hold the camera at eye level": "カメラを目の高さに持ってください",
    "Hold the phone at WAIST height (not eye level)": "携帯電話をウエストの高さ（目の高さではなく）に持ちます",
    "How to Measure": "測定方法",
    "Identifying 478 face landmarks in your photo.": "写真内の 478 個の顔のランドマークを特定します。",
    "Identifying body landmarks from your photo.": "写真から体のランドマークを特定します。",
    "Identifying face landmarks in your photo.": "写真内の顔のランドマークを特定します。",
    "Identity": "アイデンティティ",
    "Increase": "増やす",
    "Inner leg seam length.": "内股の縫い目の長さ。",
    "INSEAM": "股下",
    "Is the person in this photo 18 years or older?": "この写真に写っている人は18歳以上ですか?",
    "JPEG, PNG (max 10MB)": "JPEG、PNG（最大10MB）",
    "JPEG, PNG up to 10MB": "JPEG、PNG 10MBまで",
    "JPEG, PNG up to 10MB · click or drop": "JPEG、PNG 最大 10MB · クリックまたはドロップ",
    "JPEG, PNG, WebP, AVIF (max 10MB)": "JPEG、PNG、WebP、AVIF（最大10MB）",
    "Keep hair away from face and ears": "髪が顔や耳にかからないようにする",
    "Keep hair away from your face and ears": "髪が顔や耳にかからないようにする",
    "Keep your full face, ears, and head visible": "顔全体、耳、頭が見えるようにしてください",
    "LAST UPDATE": "最終更新日",
    "Layer with a fitted base for sharper silhouette": "フィットしたベースと重ねて、よりシャープなシルエットを実現",
    "Leave some space above your head": "頭上にスペースを残す",
    "Leave space above your head": "頭の上にスペースを残す",
    "Leave the bottom button of a suit jacket undone": "スーツのジャケットの下のボタンは外したままにする",
    "left": "左",
    "LEGAL NOTICE": "法的通知",
    "LENGTH ADJUSTMENT": "長さの調整",
    "Length of the arm from hinge to tip": "ヒンジから先端までのアームの長さ",
    "Loading your fit profile": "フィットプロファイルをロードしています",
    "Loading your saved measurements and body shape answers.": "保存した測定値と体型の回答を読み込みます。",
    "long": "長い",
    "LOOSE": "ルーズ",
    "Male": "男性",
    "MANUAL FIT": "マニュアルフィット",
    "MAPPING": "マッピング",
    "Mapping body landmarks…": "体のランドマークをマッピング中…",
    "Mapping bridge, frame width and temple fit.": "ブリッジ、フレーム幅、テンプルのフィット感をマッピング。",
    "Mapping bridge, lens width and temple length.": "ブリッジ、レンズ幅、テンプルの長さをマッピングします。",
    "MAPPING CIRCUMFERENCE": "マッピングの周囲",
    "Mapping garment to body": "衣服を体にマッピングする",
    "Match your belt to your shoes — never your pants": "ベルトを靴に合わせてください。決してパンツに合わせないでください。",
    "MATCHING FRAME SIZE": "適合するフレームサイズ",
    "MATCHING HAT SIZE": "一致する帽子のサイズ",
    "MATCHING SIZE": "適合するサイズ",
    "Measure around your wrist where the bracelet or watch sits": "ブレスレットや時計を取り付ける手首の周囲を測ります",
    "Measure from heel to longest toe": "かかとから一番長いつま先までを測ります",
    "Measure manually": "手動で測定する",
    "Measurement": "測定",
    "MEASUREMENT BLUEPRINT": "測定の青写真",
    "Measurement Guide": "測定ガイド",
    "MEASURING": "測定",
    "MEASURING FRAME": "測定フレーム",
    "Measuring shoulders, chest, waist and hips.": "肩、胸囲、ウエスト、ヒップを測ります。",
    "MEN'S FIT": "メンズフィット",
    "Menu": "メニュー",
    "mm": "mm",
    "My Sizing Profiles": "私のサイジングプロファイル",
    "NAME": "名前",
    "NARROW": "狭い",
    "NECK": "ネック",
    "Neutral background with good lighting": "適切な照明を備えたニュートラルな背景",
    "New Profile": "新しいプロフィール",
    "No fit": "フィットしない",
    "No matching size": "一致するサイズがありません",
    "NO MATCHING SIZE": "一致するサイズがありません",
    "No matching size available": "一致するサイズはありません",
    "No password needed. After sign in, you will continue to the normal profile setup.": "パスワードは必要ありません。サインイン後、通常のプロファイル設定に進みます。",
    "No size chart available": "サイズ表はありません",
    "No size matches your measurements": "測定値と一致するサイズがありません",
    "No sizes match the selected options.": "選択したオプションに一致するサイズはありません。",
    "Not Suggested": "推奨されません",
    "One Size": "ワンサイズ",
    "Opening...": "オープニング...",
    "Optional note": "オプションのメモ",
    "or": "または",
    "Or upload front face": "または正面をアップロードしてください",
    "Our AI is mapping your proportions for a size suggestion.": "当社の AI があなたのプロポーションをマッピングしてサイズを提案します。",
    "Our AI is mapping your proportions.": "私たちの AI があなたのプロポーションをマッピングしています。",
    "Our AI is precisely mapping the garment to your unique proportions.": "当社の AI は、衣服をお客様独自のプロポーションに正確にマッピングします。",
    "Our AI works best with front-facing, full-body photos in fitted clothing. Better photos = more accurate virtual try-on!": "当社の AI は、体にフィットした衣服を着た正面向きの全身写真に最適に機能します。より良い写真 = より正確な仮想試着!",
    "Our model is analyzing 150+ body landmarks for your size suggestion": "私たちのモデルは、サイズ提案のために 150 以上の体のランドマークを分析しています",
    "Pair this with neutral tones for a balanced look": "ニュートラルトーンと合わせるとバランスの取れた外観になります",
    "Pick a brand you know well. We'll use that size as your fit reference.": "よく知っているブランドを選択してください。そのサイズをフィットの参考として使用します。",
    "Please enter a profile name": "プロフィール名を入力してください",
    "Please enter a valid age": "有効な年齢を入力してください",
    "Please enter your ": "を入力してください",
    "Please fill in all fields": "すべてのフィールドに入力してください",
    "Please pick an option": "オプションを選択してください",
    "Please pick band and cup size": "バンドとカップのサイズを選択してください",
    "Please select your bra band and cup size": "ブラバンドとカップサイズを選択してください",
    "Please select your usual shoe brand and size": "普段履いている靴のブランドとサイズを選択してください",
    "Please try again or use manual measurements": "もう一度試すか、手動測定を使用してください",
    "Please try again or use manual measurements.": "もう一度試すか、手動測定を使用してください。",
    "Please upload a photo first.": "まずは写真をアップロードしてください。",
    "Preparing your image": "画像の準備",
    "Preparing your image…": "画像を準備しています…",
    "PrimeStyleAI": "プライムスタイルAI",
    "PrimeStyleAI profile": "PrimeStyleAI プロフィール",
    "PrimeStyleAI profile benefits": "PrimeStyleAI プロファイルの利点",
    "Pro Tip": "プロのヒント",
    "Proceed": "続行",
    "Processing...": "処理中...",
    "Product photos": "製品写真",
    "Profile": "プロフィール",
    "PROFILE": "プロフィール",
    "Profile details": "プロフィールの詳細",
    "Profile Name": "プロファイル名",
    "Profile photo is missing. Please add a photo and try again.": "プロフィール写真がありません。写真を追加してもう一度お試しください。",
    "Profile sync failed. Your local changes are still saved here.": "プロファイルの同期に失敗しました。ローカルでの変更は引き続きここに保存されます。",
    "Profile welcome": "プロフィールへようこそ",
    "Quick Setup": "クイックセットアップ",
    "Rate try-on": "試着を評価する",
    "Rate your try-on": "試着を評価してください",
    "Rating": "評価",
    "Reading head landmarks from your photo.": "写真から頭のランドマークを読み取ります。",
    "READING PROFILE": "読書プロフィール",
    "READING YOUR PROFILE": "プロフィールを読む",
    "Refining drape and shadows": "ドレープとシャドウの洗練",
    "Refining drape and shadows…": "ドレープと影を洗練する…",
    "Remove any glasses you're wearing": "着用しているメガネを外してください",
    "Remove photo": "写真を削除",
    "Rendering shadows and highlights to match your photo's lighting": "写真の照明に合わせてシャドウとハイライトをレンダリングする",
    "Rendering the garment…": "衣服をレンダリング中…",
    "RETAKE PHOTO": "写真を撮り直す",
    "Reuse these measurements on future products.": "これらの測定値を将来の製品で再利用します。",
    "Review before continuing.": "続行する前に確認してください。",
    "Review your measurements below — you can edit them later": "以下の測定値を確認してください - 後で編集できます",
    "Review your photo": "写真を確認してください",
    "Roll sleeves twice for a relaxed, intentional finish": "袖を2回ロールアップしてリラックス感のある意図的な仕上がりに",
    "ROUND": "ラウンド",
    "SAVE": "保存",
    "Save Changes": "変更を保存",
    "Save Profile": "プロファイルの保存",
    "Save your fit profile": "フィットプロファイルを保存する",
    "SCANNING FRAME": "スキャンフレーム",
    "SDK not configured. Please refresh and try again.": "SDKが設定されていません。更新してもう一度お試しください。",
    "Securely reuse your measurements and photo across PrimeStyleAI experiences and partner stores.": "PrimeStyleAI エクスペリエンスとパートナー ストア全体で測定値と写真を安全に再利用します。",
    "See how it looks on yourself": "自分自身にどう見えるか見てみましょう",
    "Select": "選択",
    "SELECT": "選択",
    "Select a size to add to cart": "カートに追加するサイズを選択してください",
    "SELECT A SIZE TO ADD TO CART": "カートに追加するサイズを選択してください",
    "Select bra band and cup": "ブラバンドとカップを選ぶ",
    "Select the profile that best matches your chest breadth": "自分の胸囲に最も合うプロファイルを選択してください",
    "SELECTED": "選択済み",
    "Selected brand": "選択されたブランド",
    "Send": "送信",
    "Send feedback": "フィードバックを送信する",
    "Sending": "送信中",
    "Sent": "送信済み",
    "Set height": "高さを設定する",
    "Set weight": "設定重量",
    "Shoe brand": "シューズブランド",
    "Shoe size": "靴のサイズ",
    "Shoe Size": "靴のサイズ",
    "short": "短い",
    "SHOULDER": "肩",
    "Shoulder edge to shoulder edge.": "ショルダーエッジからショルダーエッジまで。",
    "Shoulder seam to cuff edge.": "肩の縫い目から袖口の端まで。",
    "Show Fit": "フィットを表示",
    "Sign in": "サインイン",
    "Sign out": "サインアウト",
    "size": "サイズ",
    "SIZE": "サイズ",
    "Size Guide": "サイズガイド",
    "SIZE GUIDE": "サイズガイド",
    "Sizing Profile": "サイズプロファイル",
    "SLEEVE": "スリーブ",
    "SLIGHT EASE": "わずかな緩和",
    "SLIGHTLY TIGHT": "ややきつい",
    "Continue with Google": "Google で続行",
    "Continue with Apple": "Apple で続行",
    "Continue with LinkedIn": "LinkedIn で続行",
    "Social login failed.": "ソーシャルログインに失敗しました。",
    "Social login failed. Please try again.": "ソーシャルログインに失敗しました。もう一度試してください。",
    "Social login must run in the browser.": "ソーシャルログインはブラウザで実行する必要があります。",
    "Popup was blocked. Please allow popups and try again.": "ポップアップがブロックされました。ポップアップを許可してもう一度お試しください。",
    "Login did not finish. Please close the sign-in window and try again.": "ログインが完了しませんでした。サインイン画面を閉じてもう一度お試しください。",
    "Social sign in": "ソーシャルサインイン",
    "Stand straight and still, arms relaxed": "腕をリラックスさせてまっすぐに静止して立ちます",
    "Standard": "標準",
    "Standing 2-3 meters from camera": "カメラから 2 ～ 3 メートル離れた場所に立ってください",
    "stars": "星",
    "Start Fresh": "新たに始める",
    "Start Try-On": "試着を開始する",
    "START TRY-ON": "試着を開始する",
    "STEP": "ステップ",
    "Step 01": "ステップ01",
    "Step 02": "ステップ02",
    "Stomach": "胃",
    "STOMACH PROFILE": "胃のプロフィール",
    "STRAIGHT": "ストレート",
    "Style Tip": "スタイルのヒント",
    "suggested": "提案された",
    "SUGGESTED": "提案",
    "Suggested Size": "推奨サイズ",
    "Tap any section for detailed breakdown": "任意のセクションをタップすると詳細な内訳が表示されます",
    "Tap any value to adjust if needed": "必要に応じて値をタップして調整します",
    "Tap the card for detailed breakdown": "カードをタップすると詳細な内訳が表示されます",
    "Tap to upload": "タップしてアップロード",
    "The curvature of your hips and thighs": "腰と太ももの曲がり",
    "The curvature of your lower spine and seat profile": "下部背骨の湾曲と座席の輪郭",
    "The merchant hasn't uploaded sizing data for this product yet. You can still see how it looks on you with a virtual try-on.": "販売者はこの商品のサイズ データをまだアップロードしていません。仮想試着で実際にどのように見えるかを確認できます。",
    "THIGH": "太もも",
    "This cannot be undone.": "これを元に戻すことはできません。",
    "This product's size chart doesn't carry a fit close enough to your body. Try another product or update your profile.": "この製品のサイズ表は体にぴったりフィットするものではありません。別の製品を試すか、プロフィールを更新してください。",
    "This product's size chart doesn't include a reliable fit for your measurements.": "この製品のサイズ表には、お客様の測定値に対する確実なフィット感は含まれていません。",
    "TIGHT": "きつい",
    "Top to bottom length.": "上から下までの長さ。",
    "TRY ANOTHER SIZE": "別のサイズを試してください",
    "Try-on failed": "試着失敗",
    "Unable to connect to sizing service. Please try again.": "サイズ調整サービスに接続できません。もう一度試してください。",
    "Unable to connect to sizing service. Please try manual measurements.": "サイズ調整サービスに接続できません。手動測定を試してください。",
    "Unable to get a size suggestion. Please try again.": "サイズの提案が得られません。もう一度試してください。",
    "Unable to get a size suggestion. Please try manual measurements.": "サイズの提案が得られません。手動測定を試してください。",
    "Unit": "単位",
    "Upload a full-body photo. Our AI computes every measurement.": "全身写真をアップロードします。当社の AI はあらゆる測定値を計算します。",
    "Upload a photo for AI sizing": "写真をアップロードして AI サイズ調整を行う",
    "Upload front face": "正面をアップロードする",
    "UPLOAD NOT ALLOWED": "アップロードは許可されていません",
    "Use a front-facing photo with your face and head clearly visible.": "顔と頭がはっきりと見える正面向きの写真を使用してください。",
    "Use bright, even lighting and a plain background": "明るく均一な照明と無地の背景を使用する",
    "Use natural or even lighting": "自然光または均等な照明を使用する",
    "Use natural, even lighting": "自然で均一な照明を使用する",
    "Use natural, even lighting (e.g. near a window)": "自然で均一な照明を使用してください（窓の近くなど）",
    "USE THIS PROFILE": "このプロフィールを使用してください",
    "Used to calibrate the AI from your photo.": "写真から AI を調整するために使用されます。",
    "USER": "ユーザー",
    "Using iris size as the pixel-to-mm anchor.": "ピクセルからミリメートルへのアンカーとして虹彩サイズを使用します。",
    "Using saved measurements for this fit.": "このフィットには保存された測定値を使用します。",
    "VIEW CHART": "チャートを見る",
    "VIEW DETAILS": "詳細を見る",
    "WAIST": "ウエスト",
    "We couldn't find a size that fits for this product.": "この商品に合うサイズが見つかりませんでした。",
    "We noticed your entered details didn't match your photo. To give you accurate sizing, we measured your body directly from the photo.": "入力された詳細が写真と一致しないことがわかりました。正確なサイズを提供するために、写真から直接身体を測定しました。",
    "Wear fitted, simple clothing": "体にフィットしたシンプルな服装を着用してください",
    "Welcome": "ようこそ",
    "What is my size?": "私のサイズはどれくらいですか？",
    "Which shoe brand do you usually wear?": "普段どの靴のブランドを履いていますか？",
    "WHILE YOU WAIT": "待っている間",
    "Width of one lens": "片方のレンズの幅",
    "WITHIN RANGE": "範囲内",
    "WOMEN'S FIT": "ウィメンズフィット",
    "Wrap a tape around the widest part of your head": "頭の一番広い部分にテープを巻きます",
    "Wrist Circumference": "手首周囲",
    "Wrist Measurements": "手首の寸法",
    "YEARS": "年",
    "You chose": "あなたが選んだのは",
    "Your Body": "あなたの体",
    "Your Choice · Not Suggested": "あなたの選択 · 推奨されません",
    "YOUR CHOICE · NOT SUGGESTED": "あなたの選択 · 推奨されません",
    "Your Details": "あなたの詳細",
    "Your Fit": "あなたのフィット感",
    "Your measurements": "あなたの測定値",
    "Your profile is private to your PrimeStyleAI account and can be updated anytime.": "あなたのプロフィールは PrimeStyleAI アカウントに対してプライベートであり、いつでも更新できます。",
    "Your profiles": "あなたのプロフィール",
    "Your Selection": "あなたの選択",
    "YOUR SELECTION": "あなたの選択",
    "your selection · not suggested": "あなたの選択 · 提案されません",
    "Your size": "あなたのサイズ",
    "Your size is": "あなたのサイズは",
    "Your try-on history": "あなたの試着履歴",
  },
  "zh": {
    "*Our sizing engine recommends": "*我们的选型引擎推荐",
    "✓ Pose detected — running body analysis": "✓ 姿势检测——跑步身体分析",
    "A clean close-up improves landmark detection for eyewear and headwear.": "清晰的特写镜头可改善眼镜和头饰的地标检测。",
    "A clear head-and-shoulders photo with space above your head gives the most accurate headwear try-on.": "清晰的头肩部照片以及头顶上方的空间可以提供最准确的头饰试戴效果。",
    "A clear, front-facing face photo — no glasses on — gives us the most accurate try-on.": "一张清晰的正面脸部照片（不戴眼镜）可以为我们提供最准确的试戴效果。",
    "A clear, well-lit face photo gives the most accurate eyewear try-on.": "一张清晰、光线充足的脸部照片可以提供最准确的眼镜试戴效果。",
    "A clear, well-lit face photo gives the most accurate fit for eyewear and headwear.": "清晰、光线充足的脸部照片可以最准确地匹配眼镜和头饰。",
    "A tie tip should land at the middle of your belt buckle": "领带尖应落在皮带扣的中间",
    "Active Profile": "活动档案",
    "ACTIVE PROFILE": "活跃的档案",
    "Add a name for this profile": "为此配置文件添加名称",
    "ADD MEASUREMENTS & PHOTO": "添加测量值和照片",
    "Add them to cart.": "将它们添加到购物车。",
    "Add to Bag": "添加到购物袋",
    "Added to bag": "已添加至购物袋",
    "Adding...": "添加...",
    "Age": "年龄",
    "Age verification": "年龄验证",
    "AGE VERIFICATION": "年龄验证",
    "AI Fact": "人工智能事实",
    "AI Powered": "人工智能驱动",
    "AI SCAN": "人工智能扫描",
    "All measurements in": "所有测量值均在",
    "almost done": "快完成了",
    "Almost done": "快完成了",
    "Almost done — finalizing…": "快完成了——最终确定……",
    "Almost done — preparing your suggested size.": "快完成了——准备好您建议的尺寸。",
    "Analyze": "分析",
    "Analyze by photo": "通过照片分析",
    "ANALYZE MY SIZE": "分析我的尺寸",
    "ANALYZING": "分析",
    "ANALYZING BODY": "分析身体",
    "ANALYZING BODY MAP": "分析身体图",
    "Analyzing body proportions": "分析身体比例",
    "Around the base of the neck.": "脖子根部周围。",
    "AVERAGE": "平均",
    "BACK": "返回",
    "Back & Seat": "靠背和座椅",
    "BACK & SEAT": "靠背和座椅",
    "Back to brands": "返回品牌",
    "Back to product": "返回产品",
    "based on your measurements and the garment's tailoring chart.": "根据您的尺寸和服装的剪裁表。",
    "based on your selected brand size and foot length.": "根据您选择的品牌尺码和脚长。",
    "best match": "最佳匹配",
    "BEST MATCH": "最佳匹配",
    "BODY MEASUREMENTS": "身体尺寸",
    "Body measurements calculated!": "身体三围计算出来了！",
    "Bra": "胸罩",
    "BRA SIZE": "文胸尺码",
    "BROAD": "远大",
    "BUST": "胸围",
    "Calculate My Body Parts": "计算我的身体部位",
    "CALCULATE MY FIT": "计算我的适合度",
    "CALCULATING": "计算",
    "calculating...": "计算...",
    "Calculating...": "正在计算...",
    "CALIBRATING": "校准",
    "Calibrating fabric drape against your body proportions": "根据您的身体比例校准面料的垂感",
    "CALIBRATING SCALE": "校准秤",
    "Cancel": "取消",
    "Cancel Generation": "取消生成",
    "centimeters": "厘米",
    "Change": "改变",
    "Checklist for accuracy": "准确性检查表",
    "CHEST": "胸部",
    "CHEST PROFILE": "胸部轮廓",
    "Choose a method": "选择一种方法",
    "Choose a plain background": "选择简单的背景",
    "Choose a plain, light background": "选择简单、浅色的背景",
    "Choose a saved profile or create a new one before finding your best fit.": "在找到最适合您的之前，选择已保存的个人资料或创建新的个人资料。",
    "Choose another photo": "选择另一张照片",
    "Choose one account": "选择一个账户",
    "Choose size": "选择尺码",
    "Choose your shoe brand": "选择您的鞋子品牌",
    "Choose your usual": "选择你平时的",
    "Circumference around the upper leg.": "大腿周围的周长。",
    "Circumference at the fullest point.": "最满点的周长。",
    "Circumference at the natural waistline.": "自然腰围处的周长。",
    "Clear All": "全部清除",
    "Click or drag a close-up face photo": "单击或拖动脸部特写照片",
    "Click or drag a front face photo": "单击或拖动正面照片",
    "Click or drag a head-and-shoulders photo": "单击或拖动头像照片",
    "Click to change photo": "点击更换照片",
    "CM": "CM",
    "Comparing your circumference to the size chart.": "将您的周长与尺码表进行比较。",
    "Comparing your measurements to the garment's size guide.": "将您的测量值与服装尺码指南进行比较。",
    "Comparing your measurements to the size chart.": "将您的测量值与尺码表进行比较。",
    "Comparing your measurements to the size guide.": "将您的测量值与尺码指南进行比较。",
    "Complete the look": "完成外观",
    "Computing chest, waist, hips, sleeve and inseam from your basics.": "从基础数据出发计算胸围、腰围、臀围、袖子和内缝。",
    "Confirm your measurements": "确认您的测量结果",
    "Continue Shopping": "继续购物",
    "Could not load your saved profiles.": "无法加载您保存的配置文件。",
    "Couldn't send. Try again.": "无法发送。再试一次。",
    "Country": "国家",
    "Crafted with quality materials for everyday comfort": "采用优质材料精心打造，带来日常舒适感",
    "Create New Profile": "创建新的个人资料",
    "Create Profile": "创建个人资料",
    "Create your first fit profile to save your measurements, photo, and size history.": "创建您的第一个合身配置文件以保存您的测量值、照片和尺码历史记录。",
    "Create your fit profile once.": "一次创建您的合身档案。",
    "Cross-checking fit against millions of garment patterns": "对照数百万种服装图案交叉检查合身性",
    "Cuff a pocket square so it peeks 1–2 cm above the pocket": "将口袋巾套在袖口上，使其在口袋上方 1-2 厘米处可见",
    "Cuff once for a relaxed everyday feel": "戴上一次袖口即可享受轻松的日常感觉",
    "Cufflinks should sit half an inch past the jacket sleeve": "袖扣应距夹克袖子半英寸",
    "CURVED": "弯曲",
    "Decrease": "减少",
    "DEEP": "深度",
    "DEFAULT PROFILE": "默认配置文件",
    "Delete": "删除",
    "Delete this profile?": "删除此个人资料吗？",
    "Describe your mid-section silhouette": "描述一下你的中部轮廓",
    "DETAIL": "详情",
    "Detecting body pose": "检测身体姿势",
    "Detecting face": "检测人脸",
    "DETECTING FACE": "检测人脸",
    "Detecting head": "检测头",
    "DETECTING HEAD": "检测头",
    "DETECTING POSE": "检测姿势",
    "Detecting pose landmarks…": "检测姿势地标...",
    "Display size in country": "国家/地区的显示尺寸",
    "Distance over the nose between lenses": "镜片之间距离鼻子",
    "Don't apply filters or edits": "不应用过滤器或编辑",
    "Don't apply filters or heavy edits": "不要应用过滤器或大量编辑",
    "Don't cover your ears, eyes, or forehead": "不要遮住耳朵、眼睛或额头",
    "Don't crop out the top of your head": "不要剪掉你的头顶",
    "Don't crop out your ears or top of head": "不要剪掉耳朵或头顶",
    "Don't sit, pose, or bend": "不要坐着、摆姿势或弯腰",
    "Don't tilt or turn your head": "不要倾斜或转动头部",
    "Don't use filters, mirrored photos, or angled selfies": "不要使用滤镜、镜像照片或倾斜自拍",
    "Don't use heavy shadows or strong backlighting": "不要使用浓阴影或强背光",
    "Don't use strong backlighting or flash": "不要使用强逆光或闪光灯",
    "Don't wear a hat in the photo": "照片中不要戴帽子",
    "Don't wear loose or baggy clothing": "不要穿宽松或宽松的衣服",
    "Don't wear sunglasses or a hat in the photo": "照片中请勿戴墨镜或帽子",
    "Done": "完成",
    "e.g. 154": "例如154",
    "e.g. 173": "例如173",
    "e.g. 30": "例如30",
    "e.g. 70": "例如70",
    "e.g. My Measurements": "例如我的测量",
    "e.g. My Photo Profile": "例如我的照片个人资料",
    "Edit Profile": "编辑个人资料",
    "EDITORIAL LENGTH": "编辑长度",
    "Ensure your full body is visible for the most accurate digital tailoring scan.": "确保您的全身清晰可见，以进行最准确的数字裁剪扫描。",
    "Ensure your full body is visible for the most accurate virtual try-on.": "确保您的全身可见，以便进行最准确的虚拟试穿。",
    "Enter height, weight and answer quick body shape questions.": "输入身高、体重并回答快速体型问题。",
    "Enter your details for a bespoke size suggestion": "输入您的详细信息以获得定制尺寸建议",
    "Enter your details for accurate body estimation": "输入您的详细信息以进行准确的身体估计",
    "Enter your measurements OR upload a photo — we'll use whichever you provide.": "输入您的尺寸或上传照片 - 我们将使用您提供的任何内容。",
    "ENTERED": "已输入",
    "ESTIMATED": "预计",
    "ESTIMATING BODY": "估计身体",
    "Estimating head width and depth.": "估计头部宽度和深度。",
    "Estimating your measurements...": "正在估计您的测量结果...",
    "Estimation could not complete": "估计无法完成",
    "Face the camera directly at eye level": "将相机直接面向眼睛",
    "Face the camera directly, centered in frame": "直接面向相机，位于画面中央",
    "Face the camera with head and shoulders in frame": "面对相机，头和肩膀在画面中",
    "Face the camera with your head and shoulders in frame, leaving space above your head.": "面对相机，头和肩膀在画面中，在头顶上方留出空间。",
    "Failed to process image": "处理图像失败",
    "Female": "女",
    "FINALIZING": "定稿",
    "FINALIZING RESULT": "最终结果",
    "FIT": "散客",
    "Fit reference": "合身参考",
    "Fit Result": "拟合结果",
    "Fit Terms": "适合条款",
    "Flat": "平",
    "FLAT": "平面",
    "FOOT": "脚",
    "Foot length unit": "脚长单位",
    "For your safety, we cannot process photos of people under 18.": "为了您的安全，我们无法处理 18 岁以下人士的照片。",
    "Frame Measurements": "框架测量",
    "Full": "满",
    "FULL": "已满",
    "Full circumference at the widest point.": "最宽处的全周长。",
    "Full Size": "全尺寸",
    "Full Size Chart": "全尺寸图表",
    "Garment Spec": "服装规格",
    "Garment Spotlight": "服装聚光灯",
    "Gender": "性别",
    "GENDER": "性别",
    "Generating try-on…": "正在生成试穿...",
    "Generating Your Look": "打造你的造型",
    "Generating your look...": "生成你的外观...",
    "Generating your suggested size...": "正在生成您的建议尺寸...",
    "Go back": "返回",
    "Good lighting, plain background": "光线好，背景朴素",
    "Head and shoulders in frame": "头部和肩膀在框架中",
    "Headwear Measurements": "头饰测量",
    "Helps us refine bust measurements for tops and dresses": "帮助我们完善上衣和连衣裙的胸围尺寸",
    "Here's what we estimated": "这是我们的估计",
    "Hide Fit": "隐藏适合",
    "HIP PROFILE": "臀部轮廓",
    "HIPS": "高抗冲聚苯乙烯",
    "Hips closer to shoulder width": "臀部接近肩宽",
    "Hips proportionate to shoulders": "臀部与肩膀成比例",
    "Hips wider than shoulders": "臀部比肩膀宽",
    "Hold the camera at eye level": "将相机保持在视线水平",
    "Hold the phone at WAIST height (not eye level)": "将手机保持在腰部高度（而不是与眼睛齐平）",
    "How to Measure": "如何测量",
    "Identifying 478 face landmarks in your photo.": "识别照片中的 478 个面部特征。",
    "Identifying body landmarks from your photo.": "从照片中识别身体标志。",
    "Identifying face landmarks in your photo.": "识别照片中的面部特征。",
    "Identity": "身份",
    "Increase": "增加",
    "Inner leg seam length.": "腿内侧接缝长度。",
    "INSEAM": "欧洲工商管理学院",
    "Is the person in this photo 18 years or older?": "照片中的人是否年满 18 岁？",
    "JPEG, PNG (max 10MB)": "JPEG、PNG（最大 10MB）",
    "JPEG, PNG up to 10MB": "JPEG、PNG 最大 10MB",
    "JPEG, PNG up to 10MB · click or drop": "JPEG、PNG 最大 10MB · 单击或拖放",
    "JPEG, PNG, WebP, AVIF (max 10MB)": "JPEG、PNG、WebP、AVIF（最大 10MB）",
    "Keep hair away from face and ears": "让头发远离脸部和耳朵",
    "Keep hair away from your face and ears": "让头发远离脸部和耳朵",
    "Keep your full face, ears, and head visible": "让您的整个脸部、耳朵和头部可见",
    "LAST UPDATE": "最后更新",
    "Layer with a fitted base for sharper silhouette": "搭配合身底座叠搭，打造更清晰的轮廓",
    "Leave some space above your head": "在头顶上方留出一些空间",
    "Leave space above your head": "在头顶上方留出空间",
    "Leave the bottom button of a suit jacket undone": "将西装外套最下面的纽扣解开",
    "left": "左",
    "LEGAL NOTICE": "法律声明",
    "LENGTH ADJUSTMENT": "长度调整",
    "Length of the arm from hinge to tip": "从铰链到尖端的臂长",
    "Loading your fit profile": "加载您的合身资料",
    "Loading your saved measurements and body shape answers.": "加载您保存的测量值和体型答案。",
    "long": "长",
    "LOOSE": "松动",
    "Male": "男",
    "MANUAL FIT": "手动安装",
    "MAPPING": "测绘",
    "Mapping body landmarks…": "绘制身体标志...",
    "Mapping bridge, frame width and temple fit.": "绘制鼻桥、镜框宽度和镜腿贴合度。",
    "Mapping bridge, lens width and temple length.": "映射鼻梁架、镜片宽度和镜腿长度。",
    "MAPPING CIRCUMFERENCE": "绘制周长",
    "Mapping garment to body": "将服装映射到身体",
    "Match your belt to your shoes — never your pants": "将腰带与鞋子相匹配，而不是与裤子相匹配",
    "MATCHING FRAME SIZE": "匹配框架尺寸",
    "MATCHING HAT SIZE": "匹配帽子尺寸",
    "MATCHING SIZE": "配套尺寸",
    "Measure around your wrist where the bracelet or watch sits": "测量手腕周围手环或手表所在的位置",
    "Measure from heel to longest toe": "测量从脚跟到最长脚趾的距离",
    "Measure manually": "手动测量",
    "Measurement": "测量",
    "MEASUREMENT BLUEPRINT": "测量蓝图",
    "Measurement Guide": "测量指南",
    "MEASURING": "测量",
    "MEASURING FRAME": "测量框架",
    "Measuring shoulders, chest, waist and hips.": "测量肩、胸、腰、臀。",
    "MEN'S FIT": "男士版型",
    "Menu": "菜单",
    "mm": "毫米",
    "My Sizing Profiles": "我的尺码资料",
    "NAME": "姓名",
    "NARROW": "狭窄",
    "NECK": "颈部",
    "Neutral background with good lighting": "中性背景，光线良好",
    "New Profile": "新档案",
    "No fit": "不适合",
    "No matching size": "没有匹配的尺寸",
    "NO MATCHING SIZE": "没有匹配的尺寸",
    "No matching size available": "没有可用的匹配尺寸",
    "No password needed. After sign in, you will continue to the normal profile setup.": "无需密码。登录后，您将继续正常的配置文件设置。",
    "No size chart available": "没有可用的尺码表",
    "No size matches your measurements": "没有尺寸符合您的测量值",
    "No sizes match the selected options.": "没有与所选选项匹配的尺寸。",
    "Not Suggested": "不建议",
    "One Size": "一种尺寸",
    "Opening...": "开幕...",
    "Optional note": "可选备注",
    "or": "或",
    "Or upload front face": "或者上传正面",
    "Our AI is mapping your proportions for a size suggestion.": "我们的人工智能会绘制您的比例以提供尺码建议。",
    "Our AI is mapping your proportions.": "我们的人工智能正在绘制您的比例。",
    "Our AI is precisely mapping the garment to your unique proportions.": "我们的人工智能可以根据您独特的比例精确地绘制服装。",
    "Our AI works best with front-facing, full-body photos in fitted clothing. Better photos = more accurate virtual try-on!": "我们的人工智能最适合处理穿着合身衣服的正面全身照片。更好的照片=更准确的虚拟试穿！",
    "Our model is analyzing 150+ body landmarks for your size suggestion": "我们的模型正在分析 150 多个身体标志，为您提供尺码建议",
    "Pair this with neutral tones for a balanced look": "与中性色调搭配，打造平衡外观",
    "Pick a brand you know well. We'll use that size as your fit reference.": "选择一个您熟悉的品牌。我们将使用该尺寸作为您的合身参考。",
    "Please enter a profile name": "请输入个人资料名称",
    "Please enter a valid age": "请输入有效年龄",
    "Please enter your ": "请输入您的",
    "Please fill in all fields": "请填写所有字段",
    "Please pick an option": "请选择一个选项",
    "Please pick band and cup size": "请选择胸围和罩杯尺寸",
    "Please select your bra band and cup size": "请选择您的文胸带和罩杯尺寸",
    "Please select your usual shoe brand and size": "请选择您常用的鞋子品牌和尺码",
    "Please try again or use manual measurements": "请重试或使用手动测量",
    "Please try again or use manual measurements.": "请重试或使用手动测量。",
    "Please upload a photo first.": "请先上传照片。",
    "Preparing your image": "准备你的图像",
    "Preparing your image…": "正在准备您的图像...",
    "PrimeStyleAI": "PrimeStyle人工智能",
    "PrimeStyleAI profile": "PrimeStyleAI简介",
    "PrimeStyleAI profile benefits": "PrimeStyleAI 配置文件的优势",
    "Pro Tip": "专业提示",
    "Proceed": "继续",
    "Processing...": "处理中...",
    "Product photos": "产品照片",
    "Profile": "公司简介",
    "PROFILE": "公司简介",
    "Profile details": "个人资料详情",
    "Profile Name": "个人资料名称",
    "Profile photo is missing. Please add a photo and try again.": "个人资料照片丢失。请添加照片并重试。",
    "Profile sync failed. Your local changes are still saved here.": "配置文件同步失败。您的本地更改仍保存在此处。",
    "Profile welcome": "欢迎简介",
    "Quick Setup": "快速设置",
    "Rate try-on": "评价试穿",
    "Rate your try-on": "评价您的试穿",
    "Rating": "评级",
    "Reading head landmarks from your photo.": "从您的照片中读取头部地标。",
    "READING PROFILE": "阅读简介",
    "READING YOUR PROFILE": "阅读您的个人资料",
    "Refining drape and shadows": "细化悬垂感和阴影",
    "Refining drape and shadows…": "完善悬垂感和阴影……",
    "Remove any glasses you're wearing": "摘下您所佩戴的所有眼镜",
    "Remove photo": "删除照片",
    "Rendering shadows and highlights to match your photo's lighting": "渲染阴影和高光以匹配照片的灯光",
    "Rendering the garment…": "渲染服装...",
    "RETAKE PHOTO": "重拍照片",
    "Reuse these measurements on future products.": "在未来的产品上重复使用这些测量结果。",
    "Review before continuing.": "继续之前先回顾一下。",
    "Review your measurements below — you can edit them later": "在下面查看您的测量结果 - 您可以稍后编辑它们",
    "Review your photo": "查看您的照片",
    "Roll sleeves twice for a relaxed, intentional finish": "将袖子卷两次，营造轻松、有意的效果",
    "ROUND": "圆形",
    "SAVE": "保存",
    "Save Changes": "保存更改",
    "Save Profile": "保存个人资料",
    "Save your fit profile": "保存您的健身资料",
    "SCANNING FRAME": "扫描架",
    "SDK not configured. Please refresh and try again.": "SDK未配置。请刷新并重试。",
    "Securely reuse your measurements and photo across PrimeStyleAI experiences and partner stores.": "在 PrimeStyleAI 体验和合作伙伴商店中安全地重复使用您的测量结果和照片。",
    "See how it looks on yourself": "看看你自己看起来如何",
    "Select": "选择",
    "SELECT": "选择",
    "Select a size to add to cart": "选择要添加到购物车的尺码",
    "SELECT A SIZE TO ADD TO CART": "选择尺码添加到购物车",
    "Select bra band and cup": "选择胸带和罩杯",
    "Select the profile that best matches your chest breadth": "选择最适合您胸宽的轮廓",
    "SELECTED": "已选",
    "Selected brand": "所选品牌",
    "Send": "发送",
    "Send feedback": "发送反馈",
    "Sending": "发送",
    "Sent": "已发送",
    "Set height": "设置高度",
    "Set weight": "设定重量",
    "Shoe brand": "鞋品牌",
    "Shoe size": "鞋码",
    "Shoe Size": "鞋码",
    "short": "短",
    "SHOULDER": "肩部",
    "Shoulder edge to shoulder edge.": "肩缘到肩缘。",
    "Shoulder seam to cuff edge.": "肩缝至袖口边缘。",
    "Show Fit": "秀身材",
    "Sign in": "登录",
    "Sign out": "退出",
    "size": "尺寸",
    "SIZE": "尺寸",
    "Size Guide": "尺码指南",
    "SIZE GUIDE": "尺码指南",
    "Sizing Profile": "尺码简介",
    "SLEEVE": "袖子",
    "SLIGHT EASE": "轻微的轻松",
    "SLIGHTLY TIGHT": "稍紧",
    "Continue with Google": "使用 Google 继续",
    "Continue with Apple": "使用 Apple 继续",
    "Continue with LinkedIn": "使用 LinkedIn 继续",
    "Social login failed.": "社交登录失败。",
    "Social login failed. Please try again.": "社交登录失败。请再试一次。",
    "Social login must run in the browser.": "社交登录必须在浏览器中运行。",
    "Popup was blocked. Please allow popups and try again.": "弹窗被阻止。请允许弹窗后重试。",
    "Login did not finish. Please close the sign-in window and try again.": "登录未完成。请关闭登录窗口后重试。",
    "Social sign in": "社交登录",
    "Stand straight and still, arms relaxed": "站直，保持静止，双臂放松",
    "Standard": "标准型",
    "Standing 2-3 meters from camera": "站在距离相机2-3米处",
    "stars": "星星",
    "Start Fresh": "重新开始",
    "Start Try-On": "开始试穿",
    "START TRY-ON": "开始试穿",
    "STEP": "步骤",
    "Step 01": "步骤01",
    "Step 02": "步骤02",
    "Stomach": "胃",
    "STOMACH PROFILE": "胃部轮廓",
    "STRAIGHT": "直",
    "Style Tip": "风格提示",
    "suggested": "建议",
    "SUGGESTED": "建议",
    "Suggested Size": "建议尺寸",
    "Tap any section for detailed breakdown": "点击任意部分即可查看详细细分",
    "Tap any value to adjust if needed": "如果需要，点击任意值进行调整",
    "Tap the card for detailed breakdown": "点击卡片可查看详细的分类",
    "Tap to upload": "点击上传",
    "The curvature of your hips and thighs": "臀部和大腿的曲度",
    "The curvature of your lower spine and seat profile": "下脊柱的曲率和座椅轮廓",
    "The merchant hasn't uploaded sizing data for this product yet. You can still see how it looks on you with a virtual try-on.": "商家尚未上传该商品的尺码数据。您仍然可以通过虚拟试穿来查看它穿在您身上的样子。",
    "THIGH": "大腿",
    "This cannot be undone.": "此操作无法撤消。",
    "This product's size chart doesn't carry a fit close enough to your body. Try another product or update your profile.": "该产品的尺码表不够贴合您的身体。尝试其他产品或更新您的个人资料。",
    "This product's size chart doesn't include a reliable fit for your measurements.": "该产品的尺码表不包含适合您尺寸的可靠尺码。",
    "TIGHT": "紧",
    "Top to bottom length.": "从上到下的长度。",
    "TRY ANOTHER SIZE": "尝试其他尺寸",
    "Try-on failed": "试戴失败",
    "Unable to connect to sizing service. Please try again.": "无法连接到尺寸调整服务。请再试一次。",
    "Unable to connect to sizing service. Please try manual measurements.": "无法连接到尺寸调整服务。请尝试手动测量。",
    "Unable to get a size suggestion. Please try again.": "无法获得尺寸建议。请再试一次。",
    "Unable to get a size suggestion. Please try manual measurements.": "无法获得尺寸建议。请尝试手动测量。",
    "Unit": "单位",
    "Upload a full-body photo. Our AI computes every measurement.": "上传一张全身照片。我们的人工智能会计算每个测量结果。",
    "Upload a photo for AI sizing": "上传照片进行 AI 尺寸调整",
    "Upload front face": "上传正面",
    "UPLOAD NOT ALLOWED": "不允许上传",
    "Use a front-facing photo with your face and head clearly visible.": "使用脸部和头部清晰可见的正面照片。",
    "Use bright, even lighting and a plain background": "使用明亮、均匀的灯光和朴素的背景",
    "Use natural or even lighting": "使用自然光或均匀光",
    "Use natural, even lighting": "使用自然、均匀的照明",
    "Use natural, even lighting (e.g. near a window)": "使用自然、均匀的照明（例如靠近窗户）",
    "USE THIS PROFILE": "使用此配置文件",
    "Used to calibrate the AI from your photo.": "用于根据照片校准 AI。",
    "USER": "用户",
    "Using iris size as the pixel-to-mm anchor.": "使用虹膜大小作为像素到毫米的锚点。",
    "Using saved measurements for this fit.": "使用保存的测量值进行此拟合。",
    "VIEW CHART": "查看图表",
    "VIEW DETAILS": "查看详情",
    "WAIST": "腰部",
    "We couldn't find a size that fits for this product.": "我们找不到适合该产品的尺寸。",
    "We noticed your entered details didn't match your photo. To give you accurate sizing, we measured your body directly from the photo.": "我们注意到您输入的详细信息与您的照片不符。为了给您提供准确的尺码，我们直接根据照片测量您的身体尺寸。",
    "Wear fitted, simple clothing": "穿合身、简单的衣服",
    "Welcome": "欢迎",
    "What is my size?": "我的尺码是多少？",
    "Which shoe brand do you usually wear?": "你平时穿什么牌子的鞋？",
    "WHILE YOU WAIT": "当你等待时",
    "Width of one lens": "一颗镜片的宽度",
    "WITHIN RANGE": "范围内",
    "WOMEN'S FIT": "女装",
    "Wrap a tape around the widest part of your head": "将胶带缠绕在头部最宽的部分",
    "Wrist Circumference": "腕围",
    "Wrist Measurements": "手腕测量",
    "YEARS": "年",
    "You chose": "你选择了",
    "Your Body": "你的身体",
    "Your Choice · Not Suggested": "您的选择 · 不建议",
    "YOUR CHOICE · NOT SUGGESTED": "您的选择·不建议",
    "Your Details": "您的详细信息",
    "Your Fit": "适合您",
    "Your measurements": "您的测量值",
    "Your profile is private to your PrimeStyleAI account and can be updated anytime.": "您的个人资料对您的 PrimeStyleAI 帐户来说是私有的，并且可以随时更新。",
    "Your profiles": "您的个人资料",
    "Your Selection": "您的选择",
    "YOUR SELECTION": "您的选择",
    "your selection · not suggested": "您的选择 · 不建议",
    "Your size": "您的尺码",
    "Your size is": "你的尺码是",
    "Your try-on history": "您的试穿历史",
  },
  "ko": {
    "*Our sizing engine recommends": "*저희 사이징 엔진에서는 다음을 권장합니다.",
    "✓ Pose detected — running body analysis": "✓ 포즈 감지 — 신체 분석 실행",
    "A clean close-up improves landmark detection for eyewear and headwear.": "깨끗한 클로즈업은 안경과 모자의 랜드마크 감지를 향상시킵니다.",
    "A clear head-and-shoulders photo with space above your head gives the most accurate headwear try-on.": "머리 위에 공간이 있는 선명한 머리와 어깨 사진이 가장 정확한 모자 착용을 제공합니다.",
    "A clear, front-facing face photo — no glasses on — gives us the most accurate try-on.": "안경을 쓰지 않은 채 선명한 정면 얼굴 사진을 통해 가장 정확한 시착이 가능합니다.",
    "A clear, well-lit face photo gives the most accurate eyewear try-on.": "선명하고 조명이 밝은 얼굴 사진은 가장 정확한 안경 시착을 제공합니다.",
    "A clear, well-lit face photo gives the most accurate fit for eyewear and headwear.": "선명하고 조명이 밝은 얼굴 사진은 안경과 모자에 가장 정확한 핏을 제공합니다.",
    "A tie tip should land at the middle of your belt buckle": "넥타이 끝이 벨트 버클 중앙에 위치해야 합니다.",
    "Active Profile": "활성 프로필",
    "ACTIVE PROFILE": "활성 프로필",
    "Add a name for this profile": "이 프로필의 이름을 추가하세요.",
    "ADD MEASUREMENTS & PHOTO": "측정값 및 사진 추가",
    "Add them to cart.": "장바구니에 추가하세요.",
    "Add to Bag": "장바구니에 담기",
    "Added to bag": "장바구니에 추가됨",
    "Adding...": "추가 중...",
    "Age": "나이",
    "Age verification": "연령 확인",
    "AGE VERIFICATION": "연령 확인",
    "AI Fact": "AI 사실",
    "AI Powered": "AI 기반",
    "AI SCAN": "AI 스캔",
    "All measurements in": "모든 측정값",
    "almost done": "거의 다 끝났어",
    "Almost done": "거의 완료됨",
    "Almost done — finalizing…": "거의 완료되었습니다. 마무리 중입니다…",
    "Almost done — preparing your suggested size.": "거의 완료되었습니다. 권장 사이즈를 준비 중입니다.",
    "Analyze": "분석하다",
    "Analyze by photo": "사진으로 분석",
    "ANALYZE MY SIZE": "내 사이즈 분석",
    "ANALYZING": "분석 중",
    "ANALYZING BODY": "신체 분석",
    "ANALYZING BODY MAP": "신체 지도 분석",
    "Analyzing body proportions": "신체 비율 분석",
    "Around the base of the neck.": "목 밑 부분.",
    "AVERAGE": "평균",
    "BACK": "뒤로",
    "Back & Seat": "등받이 및 좌석",
    "BACK & SEAT": "등 & 좌석",
    "Back to brands": "브랜드로 돌아가기",
    "Back to product": "제품으로 돌아가기",
    "based on your measurements and the garment's tailoring chart.": "귀하의 치수와 의류 테일러링 차트를 기반으로 합니다.",
    "based on your selected brand size and foot length.": "선택한 브랜드 사이즈와 발 길이를 기준으로 합니다.",
    "best match": "가장 잘 어울리는",
    "BEST MATCH": "베스트 매치",
    "BODY MEASUREMENTS": "신체 측정",
    "Body measurements calculated!": "신체 치수가 계산되었습니다!",
    "Bra": "브라",
    "BRA SIZE": "브래지어 사이즈",
    "BROAD": "광범위",
    "BUST": "흉상",
    "Calculate My Body Parts": "내 신체 부위 계산",
    "CALCULATE MY FIT": "내 핏 계산하기",
    "CALCULATING": "계산 중",
    "calculating...": "계산 중...",
    "Calculating...": "계산 중...",
    "CALIBRATING": "교정 중",
    "Calibrating fabric drape against your body proportions": "신체 비율에 맞춰 패브릭 드레이프 보정",
    "CALIBRATING SCALE": "스케일 교정",
    "Cancel": "취소",
    "Cancel Generation": "생성 취소",
    "centimeters": "센티미터",
    "Change": "변경",
    "Checklist for accuracy": "정확성을 위한 체크리스트",
    "CHEST": "가슴",
    "CHEST PROFILE": "가슴 프로필",
    "Choose a method": "방법을 선택하세요",
    "Choose a plain background": "일반 배경을 선택하세요",
    "Choose a plain, light background": "평범하고 밝은 배경을 선택하세요",
    "Choose a saved profile or create a new one before finding your best fit.": "가장 적합한 프로필을 찾기 전에 저장된 프로필을 선택하거나 새 프로필을 만드세요.",
    "Choose another photo": "다른 사진을 선택하세요",
    "Choose one account": "하나의 계정을 선택하세요",
    "Choose size": "사이즈 선택",
    "Choose your shoe brand": "신발 브랜드를 선택하세요",
    "Choose your usual": "평소 선택",
    "Circumference around the upper leg.": "위쪽 다리 주위의 둘레입니다.",
    "Circumference at the fullest point.": "가장 높은 지점의 둘레.",
    "Circumference at the natural waistline.": "자연스러운 허리 둘레의 둘레입니다.",
    "Clear All": "모두 지우기",
    "Click or drag a close-up face photo": "클로즈업된 얼굴 사진을 클릭하거나 드래그하세요.",
    "Click or drag a front face photo": "정면 사진을 클릭하거나 드래그하세요.",
    "Click or drag a head-and-shoulders photo": "머리와 어깨 사진을 클릭하거나 드래그하세요.",
    "Click to change photo": "사진을 변경하려면 클릭하세요.",
    "CM": "CM",
    "Comparing your circumference to the size chart.": "사이즈표와 둘레를 비교해보세요.",
    "Comparing your measurements to the garment's size guide.": "측정한 치수를 의류 사이즈 가이드와 비교하세요.",
    "Comparing your measurements to the size chart.": "측정값을 사이즈 차트와 비교하세요.",
    "Comparing your measurements to the size guide.": "측정값을 사이즈 가이드와 비교하세요.",
    "Complete the look": "룩을 완성해보세요",
    "Computing chest, waist, hips, sleeve and inseam from your basics.": "가슴, 허리, 엉덩이, 소매, 밑아래를 기본부터 계산합니다.",
    "Confirm your measurements": "측정값 확인",
    "Continue Shopping": "계속 쇼핑하기",
    "Could not load your saved profiles.": "저장된 프로필을 로드할 수 없습니다.",
    "Couldn't send. Try again.": "보낼 수 없습니다. 다시 시도해 보세요.",
    "Country": "국가",
    "Crafted with quality materials for everyday comfort": "일상의 편안함을 위해 고품질 소재로 제작되었습니다.",
    "Create New Profile": "새 프로필 만들기",
    "Create Profile": "프로필 만들기",
    "Create your first fit profile to save your measurements, photo, and size history.": "측정값, 사진, 사이즈 기록을 저장하려면 첫 번째 핏 프로필을 만드세요.",
    "Create your fit profile once.": "핏 프로필을 한 번만 만들어 보세요.",
    "Cross-checking fit against millions of garment patterns": "수백만 개의 의류 패턴에 대한 교차 검사 핏",
    "Cuff a pocket square so it peeks 1–2 cm above the pocket": "포켓스퀘어를 주머니 위로 1~2cm 정도 보이도록 자릅니다.",
    "Cuff once for a relaxed everyday feel": "편안한 일상의 느낌을 위해 한 번 커프",
    "Cufflinks should sit half an inch past the jacket sleeve": "커프스 단추는 재킷 소매보다 0.5인치 정도 지나야 합니다.",
    "CURVED": "곡선",
    "Decrease": "감소",
    "DEEP": "깊은",
    "DEFAULT PROFILE": "기본 프로필",
    "Delete": "삭제",
    "Delete this profile?": "이 프로필을 삭제하시겠습니까?",
    "Describe your mid-section silhouette": "중간 부분의 실루엣을 설명해주세요",
    "DETAIL": "세부사항",
    "Detecting body pose": "신체 자세 감지",
    "Detecting face": "얼굴 감지",
    "DETECTING FACE": "얼굴 감지 중",
    "Detecting head": "헤드 감지",
    "DETECTING HEAD": "헤드 감지",
    "DETECTING POSE": "포즈 감지 중",
    "Detecting pose landmarks…": "포즈 랜드마크 감지 중…",
    "Display size in country": "국가별 디스플레이 크기",
    "Distance over the nose between lenses": "렌즈 사이의 코 위 거리",
    "Don't apply filters or edits": "필터나 수정사항을 적용하지 마세요.",
    "Don't apply filters or heavy edits": "필터나 과도한 편집을 적용하지 마세요.",
    "Don't cover your ears, eyes, or forehead": "귀, 눈, 이마를 가리지 마세요.",
    "Don't crop out the top of your head": "머리 꼭대기를 자르지 마세요.",
    "Don't crop out your ears or top of head": "귀나 머리 꼭대기를 자르지 마십시오.",
    "Don't sit, pose, or bend": "앉거나, 자세를 취하거나, 구부리지 마세요.",
    "Don't tilt or turn your head": "고개를 기울이거나 돌리지 마세요.",
    "Don't use filters, mirrored photos, or angled selfies": "필터, 거울에 비친 사진, 기울어진 셀카를 사용하지 마세요.",
    "Don't use heavy shadows or strong backlighting": "무거운 그림자나 강한 역광을 사용하지 마세요.",
    "Don't use strong backlighting or flash": "강한 역광이나 플래시를 사용하지 마세요.",
    "Don't wear a hat in the photo": "사진 속 모자를 쓰지 마세요",
    "Don't wear loose or baggy clothing": "헐렁하거나 헐렁한 옷을 입지 마세요",
    "Don't wear sunglasses or a hat in the photo": "사진에 선글라스나 모자를 착용하지 마세요.",
    "Done": "완료",
    "e.g. 154": "예를 들어 154",
    "e.g. 173": "예를 들어 173",
    "e.g. 30": "예를 들어 30",
    "e.g. 70": "예를 들어 70",
    "e.g. My Measurements": "예를 들어 내 측정",
    "e.g. My Photo Profile": "예를 들어 내 사진 프로필",
    "Edit Profile": "프로필 편집",
    "EDITORIAL LENGTH": "편집 길이",
    "Ensure your full body is visible for the most accurate digital tailoring scan.": "가장 정확한 디지털 테일러링 스캔을 위해 전신이 보이도록 하세요.",
    "Ensure your full body is visible for the most accurate virtual try-on.": "가장 정확한 가상 체험을 위해 전신이 보이는지 확인하세요.",
    "Enter height, weight and answer quick body shape questions.": "키, 몸무게를 입력하고 빠른 체형 질문에 답하세요.",
    "Enter your details for a bespoke size suggestion": "맞춤형 사이즈 제안을 위해 세부 정보를 입력하세요.",
    "Enter your details for accurate body estimation": "정확한 신체 추정을 위해 세부 정보를 입력하세요.",
    "Enter your measurements OR upload a photo — we'll use whichever you provide.": "측정값을 입력하거나 사진을 업로드하세요. 제공하신 정보를 사용하겠습니다.",
    "ENTERED": "입력됨",
    "ESTIMATED": "추정",
    "ESTIMATING BODY": "신체 추정",
    "Estimating head width and depth.": "머리 너비와 깊이를 추정합니다.",
    "Estimating your measurements...": "측정값을 추정하는 중...",
    "Estimation could not complete": "추정을 완료할 수 없습니다.",
    "Face the camera directly at eye level": "카메라를 눈높이로 똑바로 바라보세요",
    "Face the camera directly, centered in frame": "프레임 중앙에 카메라를 직접 향하게 하세요.",
    "Face the camera with head and shoulders in frame": "머리와 어깨가 프레임 안에 들어가도록 카메라를 바라보세요.",
    "Face the camera with your head and shoulders in frame, leaving space above your head.": "머리와 어깨가 프레임 안에 들어가도록 카메라를 바라보고 머리 위에 공간을 남겨두세요.",
    "Failed to process image": "이미지를 처리하지 못했습니다.",
    "Female": "여성",
    "FINALIZING": "마무리 중",
    "FINALIZING RESULT": "최종 결과",
    "FIT": "맞춤",
    "Fit reference": "맞춤 참조",
    "Fit Result": "적합 결과",
    "Fit Terms": "적합항",
    "Flat": "플랫",
    "FLAT": "플랫",
    "FOOT": "발",
    "Foot length unit": "발 길이 단위",
    "For your safety, we cannot process photos of people under 18.": "귀하의 안전을 위해 18세 미만의 사진은 처리할 수 없습니다.",
    "Frame Measurements": "프레임 측정",
    "Full": "전체",
    "FULL": "전체",
    "Full circumference at the widest point.": "가장 넓은 지점의 전체 둘레입니다.",
    "Full Size": "전체 크기",
    "Full Size Chart": "전체 크기 차트",
    "Garment Spec": "의류 사양",
    "Garment Spotlight": "의류 스포트라이트",
    "Gender": "성별",
    "GENDER": "성별",
    "Generating try-on…": "시도 생성 중…",
    "Generating Your Look": "당신의 모습을 생성",
    "Generating your look...": "당신의 모습을 만들어가는 중...",
    "Generating your suggested size...": "제안된 크기를 생성하는 중...",
    "Go back": "돌아가기",
    "Good lighting, plain background": "좋은 조명, 평범한 배경",
    "Head and shoulders in frame": "프레임의 머리와 어깨",
    "Headwear Measurements": "모자 측정",
    "Helps us refine bust measurements for tops and dresses": "상의와 드레스의 가슴둘레를 개선하는 데 도움이 됩니다.",
    "Here's what we estimated": "우리가 추정한 것은 다음과 같습니다",
    "Hide Fit": "맞춤 숨기기",
    "HIP PROFILE": "힙합 프로필",
    "HIPS": "엉덩이",
    "Hips closer to shoulder width": "엉덩이는 어깨 너비에 더 가깝습니다.",
    "Hips proportionate to shoulders": "어깨에 비례하는 엉덩이",
    "Hips wider than shoulders": "어깨보다 엉덩이가 넓어요",
    "Hold the camera at eye level": "카메라를 눈높이로 유지하세요.",
    "Hold the phone at WAIST height (not eye level)": "휴대전화를 허리 높이(눈 높이가 아님)로 잡습니다.",
    "How to Measure": "측정 방법",
    "Identifying 478 face landmarks in your photo.": "사진에서 478개의 얼굴 랜드마크를 식별합니다.",
    "Identifying body landmarks from your photo.": "사진에서 신체 랜드마크를 식별합니다.",
    "Identifying face landmarks in your photo.": "사진에서 얼굴 랜드마크를 식별합니다.",
    "Identity": "아이덴티티",
    "Increase": "증가",
    "Inner leg seam length.": "다리 안쪽 솔기 길이.",
    "INSEAM": "안쪽 아래",
    "Is the person in this photo 18 years or older?": "이 사진 속 사람은 18세 이상인가요?",
    "JPEG, PNG (max 10MB)": "JPEG, PNG(최대 10MB)",
    "JPEG, PNG up to 10MB": "JPEG, PNG 최대 10MB",
    "JPEG, PNG up to 10MB · click or drop": "JPEG, PNG 최대 10MB · 클릭 또는 드롭",
    "JPEG, PNG, WebP, AVIF (max 10MB)": "JPEG, PNG, WebP, AVIF(최대 10MB)",
    "Keep hair away from face and ears": "머리카락을 얼굴과 귀에 닿지 않게 하세요.",
    "Keep hair away from your face and ears": "얼굴과 귀에 머리카락이 닿지 않도록 하세요.",
    "Keep your full face, ears, and head visible": "얼굴 전체, 귀, 머리가 보이도록 유지하세요.",
    "LAST UPDATE": "마지막 업데이트",
    "Layer with a fitted base for sharper silhouette": "더욱 샤프한 실루엣을 연출하는 핏 베이스 레이어",
    "Leave some space above your head": "머리 위에 공간을 좀 남겨두세요",
    "Leave space above your head": "머리 위로 공간을 남겨두세요",
    "Leave the bottom button of a suit jacket undone": "양복 재킷의 밑단 단추는 풀지 마세요",
    "left": "왼쪽",
    "LEGAL NOTICE": "법적 고지",
    "LENGTH ADJUSTMENT": "길이 조정",
    "Length of the arm from hinge to tip": "힌지부터 끝까지 암의 길이",
    "Loading your fit profile": "피트니스 프로필 로드 중",
    "Loading your saved measurements and body shape answers.": "저장된 측정값과 체형 답변을 로드하는 중입니다.",
    "long": "긴",
    "LOOSE": "루즈",
    "Male": "남성",
    "MANUAL FIT": "수동 맞춤",
    "MAPPING": "매핑",
    "Mapping body landmarks…": "신체 랜드마크 매핑 중…",
    "Mapping bridge, frame width and temple fit.": "브릿지, 프레임 폭, 안경다리 핏을 매핑합니다.",
    "Mapping bridge, lens width and temple length.": "브릿지, 렌즈 폭, 안경다리 길이 매핑.",
    "MAPPING CIRCUMFERENCE": "매핑 둘레",
    "Mapping garment to body": "의류를 신체에 매핑하기",
    "Match your belt to your shoes — never your pants": "벨트를 신발에 맞추세요. 바지에는 맞추지 마세요.",
    "MATCHING FRAME SIZE": "일치하는 프레임 크기",
    "MATCHING HAT SIZE": "어울리는 모자 크기",
    "MATCHING SIZE": "일치하는 크기",
    "Measure around your wrist where the bracelet or watch sits": "팔찌나 시계가 장착된 손목 둘레를 측정하세요.",
    "Measure from heel to longest toe": "발뒤꿈치부터 가장 긴 발가락까지 측정하세요",
    "Measure manually": "수동으로 측정",
    "Measurement": "측정",
    "MEASUREMENT BLUEPRINT": "측정 청사진",
    "Measurement Guide": "측정 가이드",
    "MEASURING": "측정",
    "MEASURING FRAME": "측정 프레임",
    "Measuring shoulders, chest, waist and hips.": "어깨, 가슴, 허리, 엉덩이를 측정합니다.",
    "MEN'S FIT": "남성 핏",
    "Menu": "메뉴",
    "mm": "mm",
    "My Sizing Profiles": "내 크기 조정 프로필",
    "NAME": "이름",
    "NARROW": "좁음",
    "NECK": "목",
    "Neutral background with good lighting": "조명이 좋은 중립 배경",
    "New Profile": "새 프로필",
    "No fit": "적합하지 않음",
    "No matching size": "일치하는 사이즈가 없습니다.",
    "NO MATCHING SIZE": "일치하는 크기가 없습니다.",
    "No matching size available": "일치하는 사이즈가 없습니다.",
    "No password needed. After sign in, you will continue to the normal profile setup.": "비밀번호가 필요하지 않습니다. 로그인한 후에는 일반 프로필 설정을 계속 진행하게 됩니다.",
    "No size chart available": "사이즈 차트가 없습니다.",
    "No size matches your measurements": "치수와 일치하는 사이즈가 없습니다.",
    "No sizes match the selected options.": "선택한 옵션과 일치하는 크기가 없습니다.",
    "Not Suggested": "제안되지 않음",
    "One Size": "원 사이즈",
    "Opening...": "여는 중...",
    "Optional note": "선택적 참고 사항",
    "or": "또는",
    "Or upload front face": "아니면 정면을 올려주세요",
    "Our AI is mapping your proportions for a size suggestion.": "우리의 AI는 사이즈 제안을 위해 귀하의 비율을 매핑하고 있습니다.",
    "Our AI is mapping your proportions.": "우리의 AI가 귀하의 비율을 매핑하고 있습니다.",
    "Our AI is precisely mapping the garment to your unique proportions.": "우리의 AI는 의류를 귀하의 고유한 비율에 정확하게 매핑합니다.",
    "Our AI works best with front-facing, full-body photos in fitted clothing. Better photos = more accurate virtual try-on!": "우리의 AI는 몸에 꼭 맞는 옷을 입고 정면을 향한 전신 사진에 가장 잘 작동합니다. 더 나은 사진 = 더 정확한 가상 시착!",
    "Our model is analyzing 150+ body landmarks for your size suggestion": "우리 모델은 귀하의 사이즈 제안을 위해 150개 이상의 신체 랜드마크를 분석하고 있습니다.",
    "Pair this with neutral tones for a balanced look": "뉴트럴 톤과 함께 매치하면 균형 잡힌 룩을 연출할 수 있습니다.",
    "Pick a brand you know well. We'll use that size as your fit reference.": "당신이 잘 아는 브랜드를 선택하세요. 해당 사이즈를 귀하의 핏 참고 자료로 사용하겠습니다.",
    "Please enter a profile name": "프로필 이름을 입력하세요.",
    "Please enter a valid age": "올바른 연령을 입력하세요.",
    "Please enter your ": "귀하의",
    "Please fill in all fields": "모든 필드를 작성해 주세요.",
    "Please pick an option": "옵션을 선택해주세요",
    "Please pick band and cup size": "밴드와 컵 사이즈를 선택해주세요.",
    "Please select your bra band and cup size": "브라 밴드와 컵 사이즈를 선택해주세요.",
    "Please select your usual shoe brand and size": "평소 사용하시는 신발 브랜드와 사이즈를 선택해주세요.",
    "Please try again or use manual measurements": "다시 시도하거나 수동 측정을 사용하십시오.",
    "Please try again or use manual measurements.": "다시 시도하거나 수동 측정을 사용하십시오.",
    "Please upload a photo first.": "먼저 사진을 올려주세요.",
    "Preparing your image": "이미지 준비",
    "Preparing your image…": "이미지 준비 중…",
    "PrimeStyleAI": "프라임스타일AI",
    "PrimeStyleAI profile": "PrimeStyleAI 프로필",
    "PrimeStyleAI profile benefits": "PrimeStyleAI 프로필 혜택",
    "Pro Tip": "프로 팁",
    "Proceed": "진행",
    "Processing...": "처리 중...",
    "Product photos": "제품 사진",
    "Profile": "프로필",
    "PROFILE": "프로필",
    "Profile details": "프로필 세부정보",
    "Profile Name": "프로필 이름",
    "Profile photo is missing. Please add a photo and try again.": "프로필 사진이 없습니다. 사진을 추가하고 다시 시도해 주세요.",
    "Profile sync failed. Your local changes are still saved here.": "프로필 동기화에 실패했습니다. 로컬 변경사항은 여기에 계속 저장됩니다.",
    "Profile welcome": "프로필 환영",
    "Quick Setup": "빠른 설정",
    "Rate try-on": "평가판 시착",
    "Rate your try-on": "당신의 시도를 평가해 주세요",
    "Rating": "등급",
    "Reading head landmarks from your photo.": "사진에서 머리 랜드마크를 읽어보세요.",
    "READING PROFILE": "독서 프로필",
    "READING YOUR PROFILE": "프로필 읽기",
    "Refining drape and shadows": "드레이프와 섀도우 개선",
    "Refining drape and shadows…": "드레이프와 섀도우 개선…",
    "Remove any glasses you're wearing": "착용하고 있는 안경을 모두 제거하세요.",
    "Remove photo": "사진 삭제",
    "Rendering shadows and highlights to match your photo's lighting": "사진의 조명에 맞게 그림자와 하이라이트 렌더링",
    "Rendering the garment…": "의상 렌더링 중…",
    "RETAKE PHOTO": "사진 다시 찍기",
    "Reuse these measurements on future products.": "향후 제품에 이러한 측정값을 재사용하십시오.",
    "Review before continuing.": "계속하기 전에 검토하세요.",
    "Review your measurements below — you can edit them later": "아래 측정값을 검토하세요. 나중에 편집할 수 있습니다.",
    "Review your photo": "사진 검토",
    "Roll sleeves twice for a relaxed, intentional finish": "편안하고 의도적인 마무리를 위해 소매를 두 번 롤업하세요.",
    "ROUND": "라운드",
    "SAVE": "저장",
    "Save Changes": "변경 사항 저장",
    "Save Profile": "프로필 저장",
    "Save your fit profile": "피트니스 프로필을 저장하세요",
    "SCANNING FRAME": "스캐닝 프레임",
    "SDK not configured. Please refresh and try again.": "SDK가 구성되지 않았습니다. 새로고침한 후 다시 시도해 주세요.",
    "Securely reuse your measurements and photo across PrimeStyleAI experiences and partner stores.": "PrimeStyleAI 경험과 파트너 매장에서 측정값과 사진을 안전하게 재사용하세요.",
    "See how it looks on yourself": "자신이 어떻게 보이는지 확인하십시오.",
    "Select": "선택",
    "SELECT": "선택",
    "Select a size to add to cart": "장바구니에 추가할 사이즈를 선택하세요",
    "SELECT A SIZE TO ADD TO CART": "장바구니에 추가할 사이즈를 선택하세요",
    "Select bra band and cup": "브라 밴드와 컵을 선택하세요",
    "Select the profile that best matches your chest breadth": "가슴 폭에 가장 잘 맞는 프로필을 선택하세요",
    "SELECTED": "선택됨",
    "Selected brand": "선택한 브랜드",
    "Send": "보내기",
    "Send feedback": "피드백 보내기",
    "Sending": "보내는 중",
    "Sent": "보냄",
    "Set height": "높이 설정",
    "Set weight": "중량 설정",
    "Shoe brand": "신발 브랜드",
    "Shoe size": "신발 사이즈",
    "Shoe Size": "신발 사이즈",
    "short": "짧은",
    "SHOULDER": "어깨",
    "Shoulder edge to shoulder edge.": "어깨 가장자리에서 어깨 가장자리까지.",
    "Shoulder seam to cuff edge.": "어깨 솔기부터 소맷단 가장자리까지.",
    "Show Fit": "핏 표시",
    "Sign in": "로그인",
    "Sign out": "로그아웃",
    "size": "크기",
    "SIZE": "크기",
    "Size Guide": "사이즈 가이드",
    "SIZE GUIDE": "사이즈 가이드",
    "Sizing Profile": "사이징 프로필",
    "SLEEVE": "소매",
    "SLIGHT EASE": "약간의 용이함",
    "SLIGHTLY TIGHT": "약간 타이트함",
    "Continue with Google": "Google로 계속하기",
    "Continue with Apple": "Apple로 계속하기",
    "Continue with LinkedIn": "LinkedIn으로 계속하기",
    "Social login failed.": "소셜 로그인에 실패했습니다.",
    "Social login failed. Please try again.": "소셜 로그인에 실패했습니다. 다시 시도해 주세요.",
    "Social login must run in the browser.": "소셜 로그인은 브라우저에서 실행되어야 합니다.",
    "Popup was blocked. Please allow popups and try again.": "팝업이 차단되었습니다. 팝업을 허용한 뒤 다시 시도해 주세요.",
    "Login did not finish. Please close the sign-in window and try again.": "로그인이 완료되지 않았습니다. 로그인 창을 닫고 다시 시도해 주세요.",
    "Social sign in": "소셜 로그인",
    "Stand straight and still, arms relaxed": "똑바로 서서 가만히 서서 팔을 편안하게 유지하세요",
    "Standard": "표준",
    "Standing 2-3 meters from camera": "카메라에서 2~3미터 떨어진 곳에 서 있음",
    "stars": "별",
    "Start Fresh": "새로 시작하다",
    "Start Try-On": "시착 시작",
    "START TRY-ON": "체험 시작",
    "STEP": "단계",
    "Step 01": "01단계",
    "Step 02": "02단계",
    "Stomach": "위",
    "STOMACH PROFILE": "위 프로필",
    "STRAIGHT": "직선",
    "Style Tip": "스타일 팁",
    "suggested": "제안",
    "SUGGESTED": "제안",
    "Suggested Size": "권장 크기",
    "Tap any section for detailed breakdown": "자세한 분석을 보려면 아무 섹션이나 탭하세요.",
    "Tap any value to adjust if needed": "필요한 경우 값을 탭하여 조정하세요.",
    "Tap the card for detailed breakdown": "자세한 내용을 보려면 카드를 탭하세요.",
    "Tap to upload": "업로드하려면 탭하세요.",
    "The curvature of your hips and thighs": "엉덩이와 허벅지의 만곡",
    "The curvature of your lower spine and seat profile": "척추 하부의 곡률과 시트 프로필",
    "The merchant hasn't uploaded sizing data for this product yet. You can still see how it looks on you with a virtual try-on.": "판매자가 아직 이 제품의 사이즈 데이터를 업로드하지 않았습니다. 가상 체험을 통해 여전히 자신에게 어떻게 보이는지 확인할 수 있습니다.",
    "THIGH": "허벅지",
    "This cannot be undone.": "이 작업은 취소할 수 없습니다.",
    "This product's size chart doesn't carry a fit close enough to your body. Try another product or update your profile.": "이 제품의 사이즈 차트는 신체에 충분히 밀착되지 않습니다. 다른 제품을 사용해 보거나 프로필을 업데이트하세요.",
    "This product's size chart doesn't include a reliable fit for your measurements.": "이 제품의 사이즈 차트에는 측정에 대한 신뢰할 수 있는 핏이 포함되어 있지 않습니다.",
    "TIGHT": "꽉",
    "Top to bottom length.": "상단에서 하단까지의 길이입니다.",
    "TRY ANOTHER SIZE": "다른 사이즈를 시도해 보세요",
    "Try-on failed": "시착 실패",
    "Unable to connect to sizing service. Please try again.": "사이즈 서비스에 연결할 수 없습니다. 다시 시도해 주세요.",
    "Unable to connect to sizing service. Please try manual measurements.": "사이즈 서비스에 연결할 수 없습니다. 수동 측정을 시도해 보십시오.",
    "Unable to get a size suggestion. Please try again.": "사이즈 제안을 받을 수 없습니다. 다시 시도해 주세요.",
    "Unable to get a size suggestion. Please try manual measurements.": "사이즈 제안을 받을 수 없습니다. 수동 측정을 시도해 보십시오.",
    "Unit": "단위",
    "Upload a full-body photo. Our AI computes every measurement.": "전신 사진을 올려주세요. 우리의 AI는 모든 측정값을 계산합니다.",
    "Upload a photo for AI sizing": "AI 크기 조정을 위한 사진 업로드",
    "Upload front face": "정면 업로드",
    "UPLOAD NOT ALLOWED": "업로드가 허용되지 않음",
    "Use a front-facing photo with your face and head clearly visible.": "얼굴과 머리가 선명하게 보이는 정면 사진을 사용하세요.",
    "Use bright, even lighting and a plain background": "밝고 균일한 조명과 단순한 배경을 사용하세요.",
    "Use natural or even lighting": "자연광이나 균일한 조명을 사용하세요.",
    "Use natural, even lighting": "자연스럽고 균일한 조명 사용",
    "Use natural, even lighting (e.g. near a window)": "자연스럽고 고른 조명을 사용하세요(예: 창 근처).",
    "USE THIS PROFILE": "이 프로필을 사용하세요",
    "Used to calibrate the AI from your photo.": "사진에서 AI를 보정하는 데 사용됩니다.",
    "USER": "사용자",
    "Using iris size as the pixel-to-mm anchor.": "조리개 크기를 픽셀 대 mm 앵커로 사용합니다.",
    "Using saved measurements for this fit.": "이 맞춤에 저장된 측정값을 사용합니다.",
    "VIEW CHART": "차트 보기",
    "VIEW DETAILS": "세부정보 보기",
    "WAIST": "허리",
    "We couldn't find a size that fits for this product.": "이 제품에 맞는 사이즈를 찾을 수 없습니다.",
    "We noticed your entered details didn't match your photo. To give you accurate sizing, we measured your body directly from the photo.": "입력하신 세부정보가 사진과 일치하지 않는 것으로 확인되었습니다. 정확한 사이즈 측정을 위해 사진을 바탕으로 고객님의 신체 사이즈를 직접 측정하였습니다.",
    "Wear fitted, simple clothing": "몸에 꼭 맞는 간단한 옷을 입으세요.",
    "Welcome": "환영합니다",
    "What is my size?": "내 사이즈는 얼마입니까?",
    "Which shoe brand do you usually wear?": "평소 어떤 신발 브랜드를 즐겨 신나요?",
    "WHILE YOU WAIT": "기다리는 동안",
    "Width of one lens": "렌즈 하나의 너비",
    "WITHIN RANGE": "범위 내",
    "WOMEN'S FIT": "여성핏",
    "Wrap a tape around the widest part of your head": "머리의 가장 넓은 부분에 테이프를 감습니다.",
    "Wrist Circumference": "손목 둘레",
    "Wrist Measurements": "손목 측정",
    "YEARS": "년",
    "You chose": "당신이 선택했습니다",
    "Your Body": "당신의 몸",
    "Your Choice · Not Suggested": "귀하의 선택 · 권장되지 않음",
    "YOUR CHOICE · NOT SUGGESTED": "귀하의 선택 · 권장되지 않음",
    "Your Details": "귀하의 세부 정보",
    "Your Fit": "당신의 핏",
    "Your measurements": "귀하의 측정",
    "Your profile is private to your PrimeStyleAI account and can be updated anytime.": "귀하의 프로필은 PrimeStyleAI 계정에만 공개되며 언제든지 업데이트될 수 있습니다.",
    "Your profiles": "귀하의 프로필",
    "Your Selection": "당신의 선택",
    "YOUR SELECTION": "당신의 선택",
    "your selection · not suggested": "귀하의 선택 · 제안되지 않음",
    "Your size": "당신의 사이즈",
    "Your size is": "당신의 사이즈는",
    "Your try-on history": "귀하의 시착 이력",
  },
  "ar": {
    "*Our sizing engine recommends": "*يوصي محرك التحجيم لدينا",
    "✓ Pose detected — running body analysis": "✓ تم اكتشاف الوضعية — تحليل الجسم الجاري",
    "A clean close-up improves landmark detection for eyewear and headwear.": "تعمل الصورة المقربة الواضحة على تحسين اكتشاف المعالم للنظارات وأغطية الرأس.",
    "A clear head-and-shoulders photo with space above your head gives the most accurate headwear try-on.": "تعطي صورة الرأس والكتفين الواضحة مع وجود مساحة فوق رأسك تجربة ارتداء أغطية الرأس الأكثر دقة.",
    "A clear, front-facing face photo — no glasses on — gives us the most accurate try-on.": "تمنحنا صورة الوجه الأمامية الواضحة - دون ارتداء النظارات - المحاولة الأكثر دقة.",
    "A clear, well-lit face photo gives the most accurate eyewear try-on.": "توفر صورة الوجه الواضحة والمضاءة جيدًا تجربة النظارات الأكثر دقة.",
    "A clear, well-lit face photo gives the most accurate fit for eyewear and headwear.": "توفر صورة الوجه الواضحة والمضاءة جيدًا ملاءمة أكثر دقة للنظارات وأغطية الرأس.",
    "A tie tip should land at the middle of your belt buckle": "يجب أن يهبط طرف ربطة العنق في منتصف مشبك حزامك",
    "Active Profile": "الملف الشخصي النشط",
    "ACTIVE PROFILE": "الملف الشخصي النشط",
    "Add a name for this profile": "أضف اسمًا لهذا الملف الشخصي",
    "ADD MEASUREMENTS & PHOTO": "إضافة القياسات والصور",
    "Add them to cart.": "أضفهم إلى سلة التسوق.",
    "Add to Bag": "أضف إلى الحقيبة",
    "Added to bag": "تمت إضافته إلى الحقيبة",
    "Adding...": "جارٍ الإضافة...",
    "Age": "العمر",
    "Age verification": "التحقق من العمر",
    "AGE VERIFICATION": "التحقق من العمر",
    "AI Fact": "حقيقة الذكاء الاصطناعي",
    "AI Powered": "مدعوم بالذكاء الاصطناعي",
    "AI SCAN": "مسح الذكاء الاصطناعي",
    "All measurements in": "جميع القياسات في",
    "almost done": "تم الانتهاء تقريبا",
    "Almost done": "انتهى تقريبا",
    "Almost done — finalizing…": "على وشك الانتهاء - وضع اللمسات النهائية ...",
    "Almost done — preparing your suggested size.": "لقد أوشكت على الانتهاء — إعداد الحجم المقترح.",
    "Analyze": "تحليل",
    "Analyze by photo": "تحليل عن طريق الصورة",
    "ANALYZE MY SIZE": "تحليل حجمي",
    "ANALYZING": "تحليل",
    "ANALYZING BODY": "تحليل الجسم",
    "ANALYZING BODY MAP": "تحليل خريطة الجسم",
    "Analyzing body proportions": "تحليل نسب الجسم",
    "Around the base of the neck.": "حول قاعدة الرقبة.",
    "AVERAGE": "متوسط",
    "BACK": "العودة",
    "Back & Seat": "الظهر والمقعد",
    "BACK & SEAT": "العودة والمقعد",
    "Back to brands": "العودة إلى العلامات التجارية",
    "Back to product": "العودة إلى المنتج",
    "based on your measurements and the garment's tailoring chart.": "بناءً على قياساتك ومخطط خياطة الملابس.",
    "based on your selected brand size and foot length.": "بناءً على حجم العلامة التجارية التي اخترتها وطول القدم.",
    "best match": "أفضل مباراة",
    "BEST MATCH": "أفضل مباراة",
    "BODY MEASUREMENTS": "قياسات الجسم",
    "Body measurements calculated!": "قياسات الجسم محسوبة!",
    "Bra": "حمالة صدر",
    "BRA SIZE": "حجم حمالة الصدر",
    "BROAD": "واسعة",
    "BUST": "تمثال نصفي",
    "Calculate My Body Parts": "حساب أجزاء جسدي",
    "CALCULATE MY FIT": "احسب لياقتي",
    "CALCULATING": "الحساب",
    "calculating...": "حساب...",
    "Calculating...": "جارٍ الحساب...",
    "CALIBRATING": "المعايرة",
    "Calibrating fabric drape against your body proportions": "معايرة ثنى القماش وفقًا لنسب جسمك",
    "CALIBRATING SCALE": "مقياس المعايرة",
    "Cancel": "إلغاء",
    "Cancel Generation": "إلغاء الجيل",
    "centimeters": "سم",
    "Change": "التغيير",
    "Checklist for accuracy": "قائمة التحقق من الدقة",
    "CHEST": "الصدر",
    "CHEST PROFILE": "ملف تعريف الصدر",
    "Choose a method": "اختر طريقة",
    "Choose a plain background": "اختر خلفية عادية",
    "Choose a plain, light background": "اختر خلفية عادية وخفيفة",
    "Choose a saved profile or create a new one before finding your best fit.": "اختر ملفًا شخصيًا محفوظًا أو أنشئ ملفًا جديدًا قبل العثور على أفضل ما يناسبك.",
    "Choose another photo": "اختر صورة أخرى",
    "Choose one account": "اختر حسابًا واحدًا",
    "Choose size": "اختر الحجم",
    "Choose your shoe brand": "اختر ماركة حذائك",
    "Choose your usual": "اختر المعتاد",
    "Circumference around the upper leg.": "محيط حول الجزء العلوي من الساق.",
    "Circumference at the fullest point.": "محيط في أقصى نقطة.",
    "Circumference at the natural waistline.": "محيط عند الخصر الطبيعي.",
    "Clear All": "مسح الكل",
    "Click or drag a close-up face photo": "انقر أو اسحب صورة وجه قريبة",
    "Click or drag a front face photo": "انقر أو اسحب صورة الوجه الأمامي",
    "Click or drag a head-and-shoulders photo": "انقر أو اسحب صورة الرأس والكتفين",
    "Click to change photo": "انقر لتغيير الصورة",
    "CM": "سم",
    "Comparing your circumference to the size chart.": "مقارنة محيطك بمخطط الحجم.",
    "Comparing your measurements to the garment's size guide.": "مقارنة قياساتك بدليل مقاسات الملابس.",
    "Comparing your measurements to the size chart.": "مقارنة قياساتك بمخطط المقاسات.",
    "Comparing your measurements to the size guide.": "مقارنة قياساتك بدليل المقاسات.",
    "Complete the look": "أكمل المظهر",
    "Computing chest, waist, hips, sleeve and inseam from your basics.": "حساب الصدر والخصر والوركين والأكمام والدرزة الداخلية من الأساسيات الخاصة بك.",
    "Confirm your measurements": "تأكيد القياسات الخاصة بك",
    "Continue Shopping": "مواصلة التسوق",
    "Could not load your saved profiles.": "تعذر تحميل ملفاتك الشخصية المحفوظة.",
    "Couldn't send. Try again.": "تعذر الإرسال. حاول ثانية.",
    "Country": "البلد",
    "Crafted with quality materials for everyday comfort": "مصنوع من مواد عالية الجودة لتوفير الراحة اليومية",
    "Create New Profile": "إنشاء ملف تعريف جديد",
    "Create Profile": "إنشاء الملف الشخصي",
    "Create your first fit profile to save your measurements, photo, and size history.": "قم بإنشاء ملفك الشخصي الأول المناسب لحفظ قياساتك وصورتك وسجل المقاسات.",
    "Create your fit profile once.": "قم بإنشاء ملف التعريف المناسب الخاص بك مرة واحدة.",
    "Cross-checking fit against millions of garment patterns": "التحقق من الملاءمة مع ملايين أنماط الملابس",
    "Cuff a pocket square so it peeks 1–2 cm above the pocket": "قم بربط مربع الجيب بحيث يظهر فوق الجيب بمقدار 1-2 سم",
    "Cuff once for a relaxed everyday feel": "الكفة مرة واحدة للشعور بالاسترخاء اليومي",
    "Cufflinks should sit half an inch past the jacket sleeve": "يجب أن تكون أزرار الأكمام على بعد نصف بوصة من أكمام السترة",
    "CURVED": "منحني",
    "Decrease": "إنقاص",
    "DEEP": "عميق",
    "DEFAULT PROFILE": "الملف الشخصي الافتراضي",
    "Delete": "حذف",
    "Delete this profile?": "هل تريد حذف هذا الملف الشخصي؟",
    "Describe your mid-section silhouette": "صف صورة ظلية للقسم الأوسط الخاص بك",
    "DETAIL": "التفاصيل",
    "Detecting body pose": "كشف وضعية الجسم",
    "Detecting face": "كشف الوجه",
    "DETECTING FACE": "كشف الوجه",
    "Detecting head": "كشف الرأس",
    "DETECTING HEAD": "كشف الرأس",
    "DETECTING POSE": "كشف الوضع",
    "Detecting pose landmarks…": "كشف معالم الوضعية...",
    "Display size in country": "حجم العرض في البلد",
    "Distance over the nose between lenses": "المسافة على الأنف بين العدسات",
    "Don't apply filters or edits": "لا تقم بتطبيق المرشحات أو التعديلات",
    "Don't apply filters or heavy edits": "لا تقم بتطبيق المرشحات أو التعديلات الثقيلة",
    "Don't cover your ears, eyes, or forehead": "لا تغطي أذنيك أو عينيك أو جبهتك",
    "Don't crop out the top of your head": "لا تقطع الجزء العلوي من رأسك",
    "Don't crop out your ears or top of head": "لا تقطع أذنيك أو أعلى رأسك",
    "Don't sit, pose, or bend": "لا تجلس أو تقف أو تنحني",
    "Don't tilt or turn your head": "لا تميل أو تدير رأسك",
    "Don't use filters, mirrored photos, or angled selfies": "لا تستخدم المرشحات أو الصور المعكوسة أو صور السيلفي ذات الزوايا",
    "Don't use heavy shadows or strong backlighting": "لا تستخدم الظلال الثقيلة أو الإضاءة الخلفية القوية",
    "Don't use strong backlighting or flash": "لا تستخدم الإضاءة الخلفية القوية أو الفلاش",
    "Don't wear a hat in the photo": "لا ترتدي قبعة في الصورة",
    "Don't wear loose or baggy clothing": "لا ترتدي ملابس فضفاضة أو فضفاضة",
    "Don't wear sunglasses or a hat in the photo": "لا ترتدي نظارات شمسية أو قبعة في الصورة",
    "Done": "تم",
    "e.g. 154": "على سبيل المثال 154",
    "e.g. 173": "على سبيل المثال 173",
    "e.g. 30": "على سبيل المثال 30",
    "e.g. 70": "على سبيل المثال 70",
    "e.g. My Measurements": "على سبيل المثال قياساتي",
    "e.g. My Photo Profile": "على سبيل المثال ملفي الشخصي للصور",
    "Edit Profile": "تحرير الملف الشخصي",
    "EDITORIAL LENGTH": "طول التحرير",
    "Ensure your full body is visible for the most accurate digital tailoring scan.": "تأكد من أن جسمك بالكامل مرئي لإجراء فحص الخياطة الرقمي الأكثر دقة.",
    "Ensure your full body is visible for the most accurate virtual try-on.": "تأكد من أن جسمك بالكامل مرئي لإجراء تجربة افتراضية أكثر دقة.",
    "Enter height, weight and answer quick body shape questions.": "أدخل الطول والوزن وأجب عن الأسئلة السريعة حول شكل الجسم.",
    "Enter your details for a bespoke size suggestion": "أدخل التفاصيل الخاصة بك لاقتراح حجم مفصل",
    "Enter your details for accurate body estimation": "أدخل التفاصيل الخاصة بك للحصول على تقدير دقيق للجسم",
    "Enter your measurements OR upload a photo — we'll use whichever you provide.": "أدخل قياساتك أو قم بتحميل صورة - سنستخدم ما تقدمه.",
    "ENTERED": "تم الإدخال",
    "ESTIMATED": "مقدر",
    "ESTIMATING BODY": "تقدير الجسم",
    "Estimating head width and depth.": "تقدير عرض الرأس وعمقه.",
    "Estimating your measurements...": "تقدير القياسات الخاصة بك...",
    "Estimation could not complete": "لا يمكن إكمال التقدير",
    "Face the camera directly at eye level": "مواجهة الكاميرا مباشرة على مستوى العين",
    "Face the camera directly, centered in frame": "واجه الكاميرا مباشرة، في منتصف الإطار",
    "Face the camera with head and shoulders in frame": "واجه الكاميرا بالرأس والكتفين في الإطار",
    "Face the camera with your head and shoulders in frame, leaving space above your head.": "واجه الكاميرا مع وضع رأسك وكتفيك في الإطار، مع ترك مساحة فوق رأسك.",
    "Failed to process image": "فشلت معالجة الصورة",
    "Female": "أنثى",
    "FINALIZING": "وضع اللمسات النهائية",
    "FINALIZING RESULT": "النتيجة النهائية",
    "FIT": "مناسب",
    "Fit reference": "مرجع مناسب",
    "Fit Result": "نتيجة مناسبة",
    "Fit Terms": "شروط صالح",
    "Flat": "شقة",
    "FLAT": "مسطحة",
    "FOOT": "قدم",
    "Foot length unit": "وحدة طول القدم",
    "For your safety, we cannot process photos of people under 18.": "من أجل سلامتك، لا يمكننا معالجة صور الأشخاص الذين تقل أعمارهم عن 18 عامًا.",
    "Frame Measurements": "قياسات الإطار",
    "Full": "كامل",
    "FULL": "كامل",
    "Full circumference at the widest point.": "محيط كامل في أوسع نقطة.",
    "Full Size": "الحجم الكامل",
    "Full Size Chart": "مخطط الحجم الكامل",
    "Garment Spec": "مواصفات الملابس",
    "Garment Spotlight": "تسليط الضوء على الملابس",
    "Gender": "الجنس",
    "GENDER": "الجنس",
    "Generating try-on…": "جارٍ إنشاء تجربة...",
    "Generating Your Look": "إنشاء مظهرك",
    "Generating your look...": "إنشاء مظهرك...",
    "Generating your suggested size...": "جارٍ إنشاء الحجم المقترح...",
    "Go back": "ارجع",
    "Good lighting, plain background": "إضاءة جيدة، خلفية واضحة",
    "Head and shoulders in frame": "الرأس والكتفين في الإطار",
    "Headwear Measurements": "قياسات أغطية الرأس",
    "Helps us refine bust measurements for tops and dresses": "يساعدنا على تحسين قياسات الصدر للقمصان والفساتين",
    "Here's what we estimated": "وهنا ما قدرناه",
    "Hide Fit": "إخفاء صالح",
    "HIP PROFILE": "ملف تعريف الورك",
    "HIPS": "الوركين",
    "Hips closer to shoulder width": "الوركين أقرب إلى عرض الكتفين",
    "Hips proportionate to shoulders": "الوركين متناسبان مع الكتفين",
    "Hips wider than shoulders": "الوركين أوسع من الكتفين",
    "Hold the camera at eye level": "أمسك الكاميرا على مستوى العين",
    "Hold the phone at WAIST height (not eye level)": "أمسك الهاتف على ارتفاع الخصر (وليس مستوى العين)",
    "How to Measure": "كيفية القياس",
    "Identifying 478 face landmarks in your photo.": "تحديد 478 من معالم الوجه في صورتك.",
    "Identifying body landmarks from your photo.": "تحديد معالم الجسم من صورتك.",
    "Identifying face landmarks in your photo.": "تحديد معالم الوجه في صورتك.",
    "Identity": "الهوية",
    "Increase": "زيادة",
    "Inner leg seam length.": "طول التماس الساق الداخلي.",
    "INSEAM": "ينسام",
    "Is the person in this photo 18 years or older?": "هل الشخص الموجود في هذه الصورة يبلغ من العمر 18 عامًا أو أكبر؟",
    "JPEG, PNG (max 10MB)": "JPEG، PNG (بحد أقصى 10 ميغابايت)",
    "JPEG, PNG up to 10MB": "JPEG، PNG يصل إلى 10 ميغابايت",
    "JPEG, PNG up to 10MB · click or drop": "JPEG، PNG يصل إلى 10 ميجابايت · انقر أو أسقط",
    "JPEG, PNG, WebP, AVIF (max 10MB)": "JPEG، PNG، WebP، AVIF (بحد أقصى 10 ميجابايت)",
    "Keep hair away from face and ears": "إبقاء الشعر بعيدا عن الوجه والأذنين",
    "Keep hair away from your face and ears": "أبقِ الشعر بعيدًا عن وجهك وأذنيك",
    "Keep your full face, ears, and head visible": "أبقِ وجهك وأذنيك ورأسك بالكامل مرئيين",
    "LAST UPDATE": "التحديث الأخير",
    "Layer with a fitted base for sharper silhouette": "طبقة بقاعدة مناسبة للحصول على صورة ظلية أكثر وضوحًا",
    "Leave some space above your head": "اترك بعض المساحة فوق رأسك",
    "Leave space above your head": "اترك مساحة فوق رأسك",
    "Leave the bottom button of a suit jacket undone": "اترك الزر السفلي لسترة البدلة مفتوحًا",
    "left": "اليسار",
    "LEGAL NOTICE": "إشعار قانوني",
    "LENGTH ADJUSTMENT": "تعديل الطول",
    "Length of the arm from hinge to tip": "طول الذراع من المفصلة إلى الحافة",
    "Loading your fit profile": "جارٍ تحميل ملفك الشخصي المناسب",
    "Loading your saved measurements and body shape answers.": "تحميل القياسات المحفوظة وإجابات شكل الجسم.",
    "long": "طويل",
    "LOOSE": "فضفاض",
    "Male": "ذكر",
    "MANUAL FIT": "ملاءمة يدوية",
    "MAPPING": "رسم الخرائط",
    "Mapping body landmarks…": "رسم معالم الجسم…",
    "Mapping bridge, frame width and temple fit.": "رسم الخرائط للجسر وعرض الإطار وملاءمة المعبد.",
    "Mapping bridge, lens width and temple length.": "رسم الخرائط الجسر وعرض العدسة وطول المعبد.",
    "MAPPING CIRCUMFERENCE": "محيط رسم الخرائط",
    "Mapping garment to body": "رسم الملابس على الجسم",
    "Match your belt to your shoes — never your pants": "قم بمطابقة حزامك مع حذائك - وليس مع سروالك أبدًا",
    "MATCHING FRAME SIZE": "مطابقة حجم الإطار",
    "MATCHING HAT SIZE": "مطابقة حجم القبعة",
    "MATCHING SIZE": "حجم مطابق",
    "Measure around your wrist where the bracelet or watch sits": "قم بالقياس حول معصمك حيث يوجد السوار أو الساعة",
    "Measure from heel to longest toe": "قم بالقياس من الكعب إلى أطول إصبع قدم",
    "Measure manually": "قم بالقياس يدويًا",
    "Measurement": "القياس",
    "MEASUREMENT BLUEPRINT": "مخطط القياس",
    "Measurement Guide": "دليل القياس",
    "MEASURING": "القياس",
    "MEASURING FRAME": "إطار القياس",
    "Measuring shoulders, chest, waist and hips.": "قياس الكتفين والصدر والخصر والوركين.",
    "MEN'S FIT": "تناسب الرجال",
    "Menu": "القائمة",
    "mm": "مم",
    "My Sizing Profiles": "ملفات تعريف التحجيم الخاصة بي",
    "NAME": "الاسم",
    "NARROW": "ضيق",
    "NECK": "الرقبة",
    "Neutral background with good lighting": "خلفية محايدة مع إضاءة جيدة",
    "New Profile": "ملف تعريف جديد",
    "No fit": "لا يصلح",
    "No matching size": "لا يوجد حجم مطابق",
    "NO MATCHING SIZE": "لا يوجد حجم مطابق",
    "No matching size available": "لا يوجد حجم مطابق متاح",
    "No password needed. After sign in, you will continue to the normal profile setup.": "لا حاجة لكلمة المرور. بعد تسجيل الدخول، ستستمر في إعداد الملف الشخصي العادي.",
    "No size chart available": "لا يوجد مخطط حجم متاح",
    "No size matches your measurements": "لا يوجد حجم يطابق قياساتك",
    "No sizes match the selected options.": "لا توجد أحجام تتطابق مع الخيارات المحددة.",
    "Not Suggested": "غير مقترح",
    "One Size": "مقاس واحد",
    "Opening...": "الافتتاح...",
    "Optional note": "ملاحظة اختيارية",
    "or": "أو",
    "Or upload front face": "أو تحميل الوجه الأمامي",
    "Our AI is mapping your proportions for a size suggestion.": "يقوم الذكاء الاصطناعي لدينا بتعيين النسب الخاصة بك لاقتراح الحجم.",
    "Our AI is mapping your proportions.": "يقوم الذكاء الاصطناعي الخاص بنا بتحديد النسب الخاصة بك.",
    "Our AI is precisely mapping the garment to your unique proportions.": "يقوم الذكاء الاصطناعي الخاص بنا بتخطيط الملابس بدقة وفقًا لأبعادك الفريدة.",
    "Our AI works best with front-facing, full-body photos in fitted clothing. Better photos = more accurate virtual try-on!": "يعمل الذكاء الاصطناعي الخاص بنا بشكل أفضل مع الصور الأمامية لكامل الجسم في الملابس المجهزة. صور أفضل = تجربة افتراضية أكثر دقة!",
    "Our model is analyzing 150+ body landmarks for your size suggestion": "يقوم نموذجنا بتحليل أكثر من 150 من معالم الجسم لاقتراح الحجم الخاص بك",
    "Pair this with neutral tones for a balanced look": "قم بإقرانها بألوان محايدة للحصول على مظهر متوازن",
    "Pick a brand you know well. We'll use that size as your fit reference.": "اختر علامة تجارية تعرفها جيدًا. سوف نستخدم هذا الحجم كمرجع مناسب لك.",
    "Please enter a profile name": "Please enter a profile name",
    "Please enter a valid age": "الرجاء إدخال عمر صالح",
    "Please enter your ": "الرجاء إدخال الخاص بك",
    "Please fill in all fields": "Please fill in all fields",
    "Please pick an option": "يرجى تحديد خيار",
    "Please pick band and cup size": "Please pick band and cup size",
    "Please select your bra band and cup size": "Please select your bra band and cup size",
    "Please select your usual shoe brand and size": "Please select your usual shoe brand and size",
    "Please try again or use manual measurements": "Please try again or use manual measurements",
    "Please try again or use manual measurements.": "Please try again or use manual measurements.",
    "Please upload a photo first.": "Please upload a photo first.",
    "Preparing your image": "تحضير صورتك",
    "Preparing your image…": "جارٍ تحضير الصورة…",
    "PrimeStyleAI": "PrimeStyleAI",
    "PrimeStyleAI profile": "الملف الشخصي لـ PrimeStyleAI",
    "PrimeStyleAI profile benefits": "PrimeStyleAI profile benefits",
    "Pro Tip": "نصيحة للمحترفين",
    "Proceed": "تابع",
    "Processing...": "جارٍ المعالجة...",
    "Product photos": "صور المنتج",
    "Profile": "الملف الشخصي",
    "PROFILE": "الملف الشخصي",
    "Profile details": "تفاصيل الملف الشخصي",
    "Profile Name": "اسم الملف الشخصي",
    "Profile photo is missing. Please add a photo and try again.": "صورة الملف الشخصي مفقودة. الرجاء إضافة صورة وحاول مرة أخرى.",
    "Profile sync failed. Your local changes are still saved here.": "فشلت مزامنة الملف الشخصي. لا تزال تغييراتك المحلية محفوظة هنا.",
    "Profile welcome": "مرحبا بكم في الملف الشخصي",
    "Quick Setup": "الإعداد السريع",
    "Rate try-on": "معدل المحاولة",
    "Rate your try-on": "قيم محاولتك",
    "Rating": "التقييم",
    "Reading head landmarks from your photo.": "قراءة معالم الرأس من صورتك.",
    "READING PROFILE": "قراءة الملف الشخصي",
    "READING YOUR PROFILE": "قراءة ملفك الشخصي",
    "Refining drape and shadows": "تكرير الستارة والظلال",
    "Refining drape and shadows…": "تكرير الستارة والظلال…",
    "Remove any glasses you're wearing": "قم بإزالة أي نظارات ترتديها",
    "Remove photo": "إزالة الصورة",
    "Rendering shadows and highlights to match your photo's lighting": "تقديم الظلال والإبرازات لتتناسب مع إضاءة صورتك",
    "Rendering the garment…": "تجسيد الملابس…",
    "RETAKE PHOTO": "إعادة التقاط الصورة",
    "Reuse these measurements on future products.": "أعد استخدام هذه القياسات على المنتجات المستقبلية.",
    "Review before continuing.": "قم بالمراجعة قبل المتابعة.",
    "Review your measurements below — you can edit them later": "راجع قياساتك أدناه — ويمكنك تعديلها لاحقًا",
    "Review your photo": "قم بمراجعة صورتك",
    "Roll sleeves twice for a relaxed, intentional finish": "قم بلف الأكمام مرتين للحصول على لمسة نهائية مريحة ومتعمدة",
    "ROUND": "جولة",
    "SAVE": "حفظ",
    "Save Changes": "حفظ التغييرات",
    "Save Profile": "حفظ الملف الشخصي",
    "Save your fit profile": "احفظ ملفك الشخصي المناسب",
    "SCANNING FRAME": "إطار المسح",
    "SDK not configured. Please refresh and try again.": "لم يتم تكوين SDK. يرجى التحديث والمحاولة مرة أخرى.",
    "Securely reuse your measurements and photo across PrimeStyleAI experiences and partner stores.": "أعد استخدام قياساتك وصورك بشكل آمن عبر تجارب PrimeStyleAI والمتاجر الشريكة.",
    "See how it looks on yourself": "انظر كيف يبدو على نفسك",
    "Select": "اختر",
    "SELECT": "اختر",
    "Select a size to add to cart": "حدد حجمًا لإضافته إلى سلة التسوق",
    "SELECT A SIZE TO ADD TO CART": "اختر حجمًا لإضافته إلى عربة التسوق",
    "Select bra band and cup": "حدد حزام حمالة الصدر والكأس",
    "Select the profile that best matches your chest breadth": "حدد الملف الشخصي الذي يناسب عرض صدرك بشكل أفضل",
    "SELECTED": "تم التحديد",
    "Selected brand": "العلامة التجارية المختارة",
    "Send": "أرسل",
    "Send feedback": "إرسال ردود الفعل",
    "Sending": "إرسال",
    "Sent": "تم الإرسال",
    "Set height": "ضبط الارتفاع",
    "Set weight": "ضبط الوزن",
    "Shoe brand": "ماركة الأحذية",
    "Shoe size": "حجم الحذاء",
    "Shoe Size": "حجم الحذاء",
    "short": "قصيرة",
    "SHOULDER": "الكتف",
    "Shoulder edge to shoulder edge.": "حافة الكتف إلى حافة الكتف.",
    "Shoulder seam to cuff edge.": "التماس الكتف إلى حافة الكفة.",
    "Show Fit": "إظهار الملاءمة",
    "Sign in": "تسجيل الدخول",
    "Sign out": "تسجيل الخروج",
    "size": "الحجم",
    "SIZE": "الحجم",
    "Size Guide": "دليل الحجم",
    "SIZE GUIDE": "دليل الحجم",
    "Sizing Profile": "ملف تعريف التحجيم",
    "SLEEVE": "كم",
    "SLIGHT EASE": "سهولة طفيفة",
    "SLIGHTLY TIGHT": "ضيق قليلاً",
    "Continue with Google": "المتابعة باستخدام Google",
    "Continue with Apple": "المتابعة باستخدام Apple",
    "Continue with LinkedIn": "المتابعة باستخدام LinkedIn",
    "Social login failed.": "فشل تسجيل الدخول الاجتماعي.",
    "Social login failed. Please try again.": "فشل تسجيل الدخول الاجتماعي. يرجى المحاولة مرة أخرى.",
    "Social login must run in the browser.": "يجب تشغيل تسجيل الدخول الاجتماعي في المتصفح.",
    "Popup was blocked. Please allow popups and try again.": "تم حظر النافذة المنبثقة. يرجى السماح بالنوافذ المنبثقة والمحاولة مرة أخرى.",
    "Login did not finish. Please close the sign-in window and try again.": "لم يكتمل تسجيل الدخول. يرجى إغلاق نافذة تسجيل الدخول والمحاولة مرة أخرى.",
    "Social sign in": "تسجيل الدخول الاجتماعي",
    "Stand straight and still, arms relaxed": "قف بشكل مستقيم وثابت، وذراعيك مسترخيتين",
    "Standard": "قياسي",
    "Standing 2-3 meters from camera": "يقف على بعد 2-3 أمتار من الكاميرا",
    "stars": "النجوم",
    "Start Fresh": "ابدأ طازجًا",
    "Start Try-On": "ابدأ بالتجربة",
    "START TRY-ON": "ابدأ التجربة",
    "STEP": "خطوة",
    "Step 01": "الخطوة 01",
    "Step 02": "الخطوة 02",
    "Stomach": "المعدة",
    "STOMACH PROFILE": "ملف المعدة",
    "STRAIGHT": "مستقيم",
    "Style Tip": "نصيحة النمط",
    "suggested": "اقترح",
    "SUGGESTED": "مقترح",
    "Suggested Size": "الحجم المقترح",
    "Tap any section for detailed breakdown": "اضغط على أي قسم للحصول على تفاصيل تفصيلية",
    "Tap any value to adjust if needed": "اضغط على أي قيمة لضبطها إذا لزم الأمر",
    "Tap the card for detailed breakdown": "اضغط على البطاقة للحصول على تفاصيل تفصيلية",
    "Tap to upload": "انقر للتحميل",
    "The curvature of your hips and thighs": "انحناء الوركين والفخذين",
    "The curvature of your lower spine and seat profile": "انحناء الجزء السفلي من العمود الفقري وشكل المقعد",
    "The merchant hasn't uploaded sizing data for this product yet. You can still see how it looks on you with a virtual try-on.": "لم يقم التاجر بتحميل بيانات الحجم لهذا المنتج بعد. لا يزال بإمكانك رؤية كيف يبدو عليك من خلال تجربة افتراضية.",
    "THIGH": "الفخذ",
    "This cannot be undone.": "لا يمكن التراجع عن هذا.",
    "This product's size chart doesn't carry a fit close enough to your body. Try another product or update your profile.": "لا يتناسب مخطط مقاسات هذا المنتج مع جسمك بدرجة كافية. جرب منتجًا آخر أو قم بتحديث ملف التعريف الخاص بك.",
    "This product's size chart doesn't include a reliable fit for your measurements.": "لا يتضمن مخطط مقاسات هذا المنتج ملاءمة موثوقة لقياساتك.",
    "TIGHT": "ضيق",
    "Top to bottom length.": "الطول من الأعلى إلى الأسفل.",
    "TRY ANOTHER SIZE": "جرب مقاسًا آخر",
    "Try-on failed": "فشلت المحاولة",
    "Unable to connect to sizing service. Please try again.": "غير قادر على الاتصال بخدمة التحجيم. يرجى المحاولة مرة أخرى.",
    "Unable to connect to sizing service. Please try manual measurements.": "غير قادر على الاتصال بخدمة التحجيم. يرجى تجربة القياسات اليدوية.",
    "Unable to get a size suggestion. Please try again.": "غير قادر على الحصول على اقتراح الحجم. يرجى المحاولة مرة أخرى.",
    "Unable to get a size suggestion. Please try manual measurements.": "غير قادر على الحصول على اقتراح الحجم. يرجى تجربة القياسات اليدوية.",
    "Unit": "وحدة",
    "Upload a full-body photo. Our AI computes every measurement.": "قم بتحميل صورة لكامل الجسم. يحسب الذكاء الاصطناعي لدينا كل القياسات.",
    "Upload a photo for AI sizing": "قم بتحميل صورة لتحجيم AI",
    "Upload front face": "تحميل الوجه الأمامي",
    "UPLOAD NOT ALLOWED": "التحميل غير مسموح به",
    "Use a front-facing photo with your face and head clearly visible.": "استخدم صورة أمامية يظهر فيها وجهك ورأسك بوضوح.",
    "Use bright, even lighting and a plain background": "استخدم إضاءة ساطعة ومتساوية وخلفية عادية",
    "Use natural or even lighting": "استخدم الإضاءة الطبيعية أو حتى",
    "Use natural, even lighting": "استخدم الإضاءة الطبيعية وحتى",
    "Use natural, even lighting (e.g. near a window)": "استخدم الإضاءة الطبيعية والمتساوية (على سبيل المثال بالقرب من النافذة)",
    "USE THIS PROFILE": "استخدم هذا الملف الشخصي",
    "Used to calibrate the AI from your photo.": "يستخدم لمعايرة الذكاء الاصطناعي من صورتك.",
    "USER": "مستخدم",
    "Using iris size as the pixel-to-mm anchor.": "استخدام حجم القزحية كمرساة من البكسل إلى المليمتر.",
    "Using saved measurements for this fit.": "استخدام القياسات المحفوظة لهذا الملاءمة.",
    "VIEW CHART": "عرض الرسم البياني",
    "VIEW DETAILS": "عرض التفاصيل",
    "WAIST": "الخصر",
    "We couldn't find a size that fits for this product.": "لم نتمكن من العثور على الحجم المناسب لهذا المنتج.",
    "We noticed your entered details didn't match your photo. To give you accurate sizing, we measured your body directly from the photo.": "لقد لاحظنا أن التفاصيل التي أدخلتها لا تتطابق مع صورتك. لنمنحك مقاسًا دقيقًا، قمنا بقياس جسمك مباشرة من الصورة.",
    "Wear fitted, simple clothing": "ارتداء الملابس المجهزة والبسيطة",
    "Welcome": "مرحبًا",
    "What is my size?": "ما هو مقاسي؟",
    "Which shoe brand do you usually wear?": "ما هي ماركة الأحذية التي ترتديها عادةً؟",
    "WHILE YOU WAIT": "أثناء انتظارك",
    "Width of one lens": "عرض عدسة واحدة",
    "WITHIN RANGE": "داخل النطاق",
    "WOMEN'S FIT": "تناسب المرأة",
    "Wrap a tape around the widest part of your head": "لف الشريط حول أوسع جزء من رأسك",
    "Wrist Circumference": "محيط المعصم",
    "Wrist Measurements": "قياسات المعصم",
    "YEARS": "سنوات",
    "You chose": "اخترت",
    "Your Body": "جسمك",
    "Your Choice · Not Suggested": "اختيارك · غير مقترح",
    "YOUR CHOICE · NOT SUGGESTED": "اختيارك · غير مقترح",
    "Your Details": "التفاصيل الخاصة بك",
    "Your Fit": "صالحك",
    "Your measurements": "قياساتك",
    "Your profile is private to your PrimeStyleAI account and can be updated anytime.": "ملفك الشخصي خاص بحساب PrimeStyleAI الخاص بك ويمكن تحديثه في أي وقت.",
    "Your profiles": "الملفات الشخصية الخاصة بك",
    "Your Selection": "اختيارك",
    "YOUR SELECTION": "اختيارك",
    "your selection · not suggested": "اختيارك · غير مقترح",
    "Your size": "حجمك",
    "Your size is": "حجمك هو",
    "Your try-on history": "تاريخ محاولتك",
  },
};
